import { clsx as e } from "clsx";
import { twMerge as t } from "tailwind-merge";
import { Accessibility as n, Activity as r, ArrowRightLeft as i, AtSign as a, Award as o, Baby as s, BadgePercent as c, Banknote as l, BarChart3 as u, Bell as d, BookOpen as f, Box as p, Briefcase as m, Building as h, Building2 as g, Cake as _, Calendar as v, CalendarCheck as y, CalendarDays as b, Car as x, Check as S, CheckCheck as C, CheckCircle as w, ChevronDown as T, ChevronLeft as E, ChevronRight as D, ChevronUp as O, Circle as k, CircleDollarSign as ee, CircleX as A, ClipboardList as j, Clock as M, Coins as te, Compass as ne, Contact as re, CreditCard as ie, Dices as ae, DollarSign as oe, Download as se, Euro as N, File as ce, FileArchive as le, FileAudio as ue, FileCheck as de, FileSpreadsheet as fe, FileText as P, FileVideo as pe, Flag as me, FolderOpen as he, Gift as ge, Globe as _e, GripVertical as ve, HandCoins as ye, HandHeart as be, Headset as xe, Heart as Se, HelpCircle as Ce, History as we, Home as Te, Image as F, ImageOff as Ee, Inbox as De, KeyRound as Oe, Layout as ke, LayoutGrid as Ae, Lightbulb as je, ListChecks as Me, Loader2 as Ne, Mail as Pe, MailOpen as Fe, MailWarning as Ie, Mails as Le, MapPin as Re, Megaphone as ze, MessageCircle as Be, MessageCircleWarning as Ve, MessageSquare as He, MessagesSquare as Ue, Music as We, Navigation as Ge, Newspaper as I, Package as Ke, Palette as qe, PanelLeftClose as Je, PanelLeftOpen as Ye, PartyPopper as Xe, Pen as Ze, Phone as Qe, PhoneCall as $e, PiggyBank as et, Pin as tt, PlusCircle as nt, Presentation as rt, Puzzle as it, Receipt as at, ReceiptText as ot, Rocket as st, RotateCcw as ct, Search as lt, Send as ut, Settings as dt, Shield as ft, ShoppingBag as pt, Sparkles as mt, Square as ht, Star as gt, StickyNote as _t, Store as vt, Tag as yt, Target as bt, ThumbsUp as xt, Ticket as L, Trash2 as St, TrendingUp as Ct, Trophy as wt, User as Tt, UserCheck as Et, UserCircle as Dt, UserRoundCog as Ot, Users as R, Users2 as kt, UsersRound as At, Video as jt, Volleyball as Mt, Vote as z, Wallet as Nt, Waves as Pt, Wrench as Ft, X as It, Zap as Lt } from "lucide-react";
import { Fragment as B, jsx as V, jsxs as H } from "react/jsx-runtime";
import { Fragment as Rt, createContext as zt, forwardRef as Bt, useCallback as U, useContext as Vt, useEffect as W, useImperativeHandle as Ht, useMemo as G, useRef as K, useState as q } from "react";
import { createPortal as Ut } from "react-dom";
import { DragDropContext as Wt, Draggable as Gt, Droppable as Kt } from "@hello-pangea/dnd";
import { Responsive as qt, WidthProvider as Jt } from "react-grid-layout/legacy";
import Yt from "dompurify";
//#region src/types/content.types.ts
var Xt = [
	"hero_welcome",
	"vouchers",
	"balance",
	"cards",
	"expenses",
	"transactions",
	"quick_actions",
	"shop",
	"shop_highlights",
	"communication",
	"news",
	"pinned_notes",
	"calendar",
	"polls",
	"blog",
	"raffle",
	"metrics",
	"file_manager",
	"catalog_rentals",
	"custom_forms",
	"surveys"
];
function Zt(e) {
	return Xt.includes(e);
}
//#endregion
//#region src/utils/cn.ts
function J(...n) {
	return t(e(n));
}
//#endregion
//#region src/utils/format.ts
function Qt(e) {
	return e.replace(/\u202F/g, "\xA0");
}
function $t(e, t = "fr-FR") {
	return Qt(new Intl.NumberFormat(t, {
		style: "currency",
		currency: "EUR",
		minimumFractionDigits: 2,
		maximumFractionDigits: 2
	}).format(e));
}
function en(e, t = "fr-FR", n = {
	year: "numeric",
	month: "2-digit",
	day: "2-digit"
}) {
	let r = typeof e == "string" ? new Date(e) : e;
	if (isNaN(r.getTime())) throw Error("Invalid date provided");
	return new Intl.DateTimeFormat(t, n).format(r);
}
//#endregion
//#region src/utils/widgetColors.ts
function tn(e) {
	let t = e.replace("#", "");
	t.length === 3 && (t = t[0] + t[0] + t[1] + t[1] + t[2] + t[2]);
	let n = parseInt(t.substring(0, 2), 16) / 255, r = parseInt(t.substring(2, 4), 16) / 255, i = parseInt(t.substring(4, 6), 16) / 255, a = Math.max(n, r, i), o = Math.min(n, r, i), s = (a + o) / 2;
	if (a === o) return {
		h: 0,
		s: 0,
		l: s * 100
	};
	let c = a - o, l = s > .5 ? c / (2 - a - o) : c / (a - o), u = 0;
	return u = a === n ? ((r - i) / c + (r < i ? 6 : 0)) / 6 : a === r ? ((i - n) / c + 2) / 6 : ((n - r) / c + 4) / 6, {
		h: u * 360,
		s: l * 100,
		l: s * 100
	};
}
function Y(e, t, n) {
	return `hsl(${Math.round(e)}, ${Math.round(t)}%, ${Math.round(n)}%)`;
}
function nn(e, t, n, r) {
	return `hsla(${Math.round(e)}, ${Math.round(t)}%, ${Math.round(n)}%, ${r})`;
}
function rn(e) {
	let { h: t, s: n } = tn(e), r = Math.min(n, 90);
	return {
		"--w-bg": Y(t, r, 95),
		"--w-bg-subtle": nn(t, r, 85, .6),
		"--w-bg-emphasis": Y(t, r, 82),
		"--w-bg-hover": Y(t, r, 80),
		"--w-text": Y(t, r, 45),
		"--w-text-emphasis": Y(t, r, 35),
		"--w-text-muted": nn(t, r, 45, .6),
		"--w-text-subtle": Y(t, r, 55),
		"--w-accent": Y(t, r, 60),
		"--w-progress-bg": nn(t, r, 65, .5),
		"--w-progress-fill": Y(t, r, 50),
		"--w-scrollbar": nn(t, r, 45, .4),
		"--w-scrollbar-hover": nn(t, r, 45, .6)
	};
}
//#endregion
//#region src/utils/lucideIconRegistry.ts
var an = {
	Accessibility: n,
	ArrowRightLeft: i,
	AtSign: a,
	Award: o,
	Baby: s,
	BadgePercent: c,
	Banknote: l,
	BarChart3: u,
	Bell: d,
	BookOpen: f,
	Box: p,
	Briefcase: m,
	Building: h,
	Building2: g,
	Car: x,
	Cake: _,
	Calendar: v,
	CalendarCheck: y,
	Check: S,
	CheckCheck: C,
	CheckCircle: w,
	Circle: k,
	CircleX: A,
	ChevronDown: T,
	ChevronLeft: E,
	ChevronRight: D,
	ChevronUp: O,
	CircleDollarSign: ee,
	ClipboardList: j,
	Clock: M,
	Coins: te,
	Compass: ne,
	Contact: re,
	CreditCard: ie,
	Dices: ae,
	DollarSign: oe,
	Euro: N,
	FileCheck: de,
	FileText: P,
	Flag: me,
	FolderOpen: he,
	Gift: ge,
	Globe: _e,
	GripVertical: ve,
	HandCoins: ye,
	HandHeart: be,
	Headset: xe,
	Heart: Se,
	HelpCircle: Ce,
	History: we,
	Home: Te,
	Image: F,
	Inbox: De,
	KeyRound: Oe,
	Layout: ke,
	LayoutGrid: Ae,
	Lightbulb: je,
	ListChecks: Me,
	Loader2: Ne,
	Mail: Pe,
	MailOpen: Fe,
	MailWarning: Ie,
	Mails: Le,
	MapPin: Re,
	Megaphone: ze,
	MessageCircle: Be,
	MessageCircleWarning: Ve,
	MessageSquare: He,
	MessagesSquare: Ue,
	Music: We,
	Navigation: Ge,
	Newspaper: I,
	Package: Ke,
	PanelLeftClose: Je,
	PanelLeftOpen: Ye,
	Palette: qe,
	PartyPopper: Xe,
	Pen: Ze,
	Phone: Qe,
	PhoneCall: $e,
	PiggyBank: et,
	Pin: tt,
	PlusCircle: nt,
	Puzzle: it,
	Receipt: at,
	ReceiptText: ot,
	Rocket: st,
	RotateCcw: ct,
	Search: lt,
	Send: ut,
	Settings: dt,
	Shield: ft,
	ShoppingBag: pt,
	Sparkles: mt,
	Square: ht,
	Star: gt,
	StickyNote: _t,
	Store: vt,
	Tag: yt,
	Target: bt,
	ThumbsUp: xt,
	Ticket: L,
	Trash2: St,
	TrendingUp: Ct,
	Trophy: wt,
	User: Tt,
	UserCheck: Et,
	UserCircle: Dt,
	UserRoundCog: Ot,
	Users: R,
	Users2: kt,
	UsersRound: At,
	Video: jt,
	Volleyball: Mt,
	Vote: z,
	Wallet: Nt,
	Waves: Pt,
	Wrench: Ft,
	X: It,
	Zap: Lt
}, on = (e) => e ? an[e] : void 0, X = ({ children: e, className: t, backgroundColor: n, backgroundImage: r, noPadding: i = !1, hover: a = !1 }) => {
	let o = {}, s = typeof n == "string" && (n.includes("linear-gradient") || n.includes("radial-gradient"));
	return n && (s ? o.backgroundImage = n : o.backgroundColor = n), r && (o.backgroundImage = `url(${r})`, o.backgroundSize = "cover", o.backgroundPosition = "center"), /* @__PURE__ */ V("div", {
		className: J("rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 overflow-hidden", "bg-white dark:bg-gray-800", !i && "p-4 md:p-6", a && "cursor-pointer transition-transform hover:scale-[1.02]", t),
		style: o,
		children: e
	});
}, sn = ({ icon: e, title: t, subtitle: n, action: r, accentColor: i = "#3B82F6" }) => {
	let a = typeof e == "string" ? an[e] : e;
	return /* @__PURE__ */ H("div", {
		className: "mb-4",
		children: [/* @__PURE__ */ H("div", {
			className: "flex items-center justify-between",
			children: [/* @__PURE__ */ H("div", {
				className: "flex items-center gap-2",
				children: [a && /* @__PURE__ */ V(a, {
					className: "w-5 h-5",
					style: { color: i }
				}), /* @__PURE__ */ V("h3", {
					className: "font-semibold text-gray-900 dark:text-gray-100",
					children: t
				})]
			}), r]
		}), n && /* @__PURE__ */ V("p", {
			className: "text-sm text-gray-600 dark:text-gray-400 mt-1",
			children: n
		})]
	});
}, Z = ({ className: e, rows: t = 3 }) => /* @__PURE__ */ H("div", {
	className: J("rounded-xl shadow-sm border border-gray-200 dark:border-gray-700", "bg-white dark:bg-gray-800 p-4 md:p-6 animate-pulse", e),
	children: [/* @__PURE__ */ H("div", {
		className: "flex items-center gap-2 mb-4",
		children: [/* @__PURE__ */ V("div", { className: "w-5 h-5 bg-gray-200 dark:bg-gray-700 rounded" }), /* @__PURE__ */ V("div", { className: "h-5 bg-gray-200 dark:bg-gray-700 rounded w-32" })]
	}), /* @__PURE__ */ V("div", {
		className: "space-y-3",
		children: Array.from({ length: t }).map((e, t) => /* @__PURE__ */ V("div", { className: "h-16 bg-gray-200 dark:bg-gray-700 rounded" }, t))
	})]
}), cn = ({ message: e, icon: t = "📦", className: n }) => {
	let r = typeof t == "string" ? an[t] : t;
	return /* @__PURE__ */ H("div", {
		className: J("flex flex-col items-center justify-center py-8 text-center", n),
		children: [/* @__PURE__ */ V("div", {
			className: "mb-3 opacity-50",
			children: r ? /* @__PURE__ */ V(r, { className: "w-10 h-10 text-gray-400 dark:text-gray-500" }) : /* @__PURE__ */ V("span", {
				className: "text-4xl",
				children: typeof t == "string" ? t : null
			})
		}), /* @__PURE__ */ V("p", {
			className: "text-sm text-gray-500 dark:text-gray-400",
			children: e
		})]
	});
}, ln = {
	primary: "bg-primary text-white hover:bg-primary-emphasis",
	secondary: "bg-secondary text-white hover:bg-secondary-emphasis",
	lightprimary: "bg-lightprimary text-primary hover:bg-primary hover:text-white dark:bg-lightprimary dark:text-primary dark:hover:bg-primary dark:hover:text-white",
	lightsecondary: "bg-lightsecondary text-secondary hover:bg-secondary hover:text-white dark:bg-lightsecondary dark:text-secondary dark:hover:bg-secondary dark:hover:text-white",
	danger: "bg-error text-white hover:bg-error-emphasis",
	lighterror: "bg-lighterror text-error hover:bg-error hover:text-white dark:bg-lighterror dark:text-error dark:hover:bg-error dark:hover:text-white",
	ghost: "bg-transparent text-gray-700 hover:bg-lightgray dark:text-darklink dark:hover:bg-darkmuted",
	outline: "bg-transparent border border-border text-dark hover:bg-lightgray dark:border-darkborder dark:text-white dark:hover:bg-darkmuted",
	outlineprimary: "bg-transparent border border-primary text-primary hover:bg-primary hover:text-white dark:border-primary dark:text-primary dark:hover:bg-primary dark:hover:text-white"
}, un = {
	xs: "py-0.5 px-1.5 text-xs",
	sm: "py-1.5 px-3 text-sm",
	md: "py-2 px-4 text-sm",
	lg: "py-2.5 px-5 text-base",
	xl: "py-3 px-6 text-base"
}, dn = Bt(({ color: e = "primary", size: t = "md", isLoading: n = !1, loadingText: r = "Chargement...", leftIcon: i, rightIcon: a, disabled: o, className: s, children: c, ...l }, u) => {
	let d = o || n;
	return /* @__PURE__ */ V("button", {
		ref: u,
		disabled: d,
		className: J("inline-flex items-center justify-center gap-2 rounded-md font-medium transition-colors duration-200", "focus:outline-none focus:ring-0 focus:shadow-none", ln[e], un[t], d && "opacity-50 cursor-not-allowed", s),
		...l,
		children: n ? /* @__PURE__ */ H(B, { children: [/* @__PURE__ */ V(Ne, {
			size: t === "sm" ? 14 : t === "lg" ? 20 : 16,
			className: "animate-spin"
		}), r] }) : /* @__PURE__ */ H(B, { children: [
			i,
			c,
			a
		] })
	});
});
dn.displayName = "Button";
//#endregion
//#region src/components/widgets/BalanceWidget.tsx
var fn = ({ totalBalance: e, availableBalance: t, pendingBalance: n, showPending: r = !0, backgroundColor: i, icon: a, title: o = "Solde", isLoading: s = !1, lastUpdated: c, onRefresh: l }) => s ? /* @__PURE__ */ V(Z, { rows: 2 }) : /* @__PURE__ */ H(X, {
	backgroundColor: i,
	children: [/* @__PURE__ */ V(sn, {
		icon: a || Nt,
		title: o,
		action: l ? /* @__PURE__ */ V("button", {
			onClick: l,
			className: "text-sm text-blue-600 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300",
			children: "Actualiser"
		}) : void 0
	}), /* @__PURE__ */ H("div", {
		className: "space-y-4",
		children: [
			/* @__PURE__ */ H("div", { children: [/* @__PURE__ */ V("p", {
				className: "text-sm text-gray-600 dark:text-gray-400 mb-1",
				children: "Solde disponible"
			}), /* @__PURE__ */ V("p", {
				className: "text-3xl font-bold text-gray-900 dark:text-gray-100",
				children: $t(t)
			})] }),
			/* @__PURE__ */ H("div", { children: [/* @__PURE__ */ V("p", {
				className: "text-sm text-gray-600 dark:text-gray-400 mb-1",
				children: "Solde total"
			}), /* @__PURE__ */ V("p", {
				className: "text-xl font-semibold text-gray-700 dark:text-gray-300",
				children: $t(e)
			})] }),
			r && n !== void 0 && n > 0 && /* @__PURE__ */ H("div", {
				className: "pt-4 border-t border-gray-200 dark:border-gray-700",
				children: [/* @__PURE__ */ V("p", {
					className: "text-sm text-gray-600 dark:text-gray-400 mb-1",
					children: "En attente"
				}), /* @__PURE__ */ V("p", {
					className: "text-lg font-medium text-amber-600 dark:text-amber-400",
					children: $t(n)
				})]
			}),
			c && /* @__PURE__ */ V("div", {
				className: "pt-2",
				children: /* @__PURE__ */ H("p", {
					className: "text-xs text-gray-500 dark:text-gray-500",
					children: ["Dernière mise à jour : ", c.toLocaleTimeString("fr-FR")]
				})
			})
		]
	})]
}), pn = "data:image/png;base64,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", mn = 300, hn = 2.5, gn = 10, _n = "•••• •••• •••• ••••", vn = {
	standard: {
		textColorClassName: "text-gray-200 dark:text-gray-800",
		cardClassName: J("border-black border-t-gray-500 dark:border-gray-300 dark:border-t-white", "bg-gradient-to-br from-gray-700 via-gray-800 to-gray-900", "dark:bg-gradient-to-br dark:from-gray-100 dark:via-gray-200 dark:to-gray-300"),
		getDisplayedNumber: (e) => e.formattedCardNumber
	},
	masked: {
		textColorClassName: "text-gray-200 dark:text-gray-800",
		cardClassName: J("border-black border-t-gray-500 dark:border-gray-300 dark:border-t-white", "bg-gradient-to-br from-gray-700 via-gray-800 to-gray-900", "dark:bg-gradient-to-br dark:from-gray-100 dark:via-gray-200 dark:to-gray-300"),
		getDisplayedNumber: () => _n
	}
}, yn = (e) => e && (e === "masked" || e === "minimal" || e === "minimaliste") ? "masked" : "standard", bn = (e) => vn[e] ?? vn.standard, xn = ({ className: e }) => /* @__PURE__ */ H("svg", {
	width: "45",
	height: "28",
	viewBox: "0 0 45 28",
	fill: "none",
	className: e,
	children: [
		/* @__PURE__ */ V("circle", {
			cx: "14",
			cy: "14",
			r: "14",
			fill: "#EB001B"
		}),
		/* @__PURE__ */ V("circle", {
			cx: "31",
			cy: "14",
			r: "14",
			fill: "#F79E1B"
		}),
		/* @__PURE__ */ V("path", {
			d: "M22.5 3.5C25.5 6 27.5 9.8 27.5 14C27.5 18.2 25.5 22 22.5 24.5C19.5 22 17.5 18.2 17.5 14C17.5 9.8 19.5 6 22.5 3.5Z",
			fill: "#FF5F00"
		})
	]
}), Sn = ({ className: e }) => /* @__PURE__ */ V("img", {
	src: pn,
	alt: "Yeati",
	className: J("h-6 xl:h-7 2xl:h-8 w-auto max-w-[88px] object-contain", e)
}), Cn = () => /* @__PURE__ */ V("div", {
	className: "absolute top-[-5px] bottom-[-5px] w-1 bg-red-500 opacity-90 shadow-lg blur-[1px] z-20 rounded-full animate-scan",
	"data-testid": "scanning-bar"
}), wn = ({ id: e, checked: t, onChange: n, disabled: r = !1 }) => /* @__PURE__ */ V("button", {
	id: e,
	type: "button",
	role: "switch",
	"aria-checked": t,
	onClick: n,
	disabled: r,
	className: J("relative inline-flex h-6 w-11 items-center rounded-full transition-colors", t ? "bg-primary" : "bg-gray-300 dark:bg-gray-600", r && "opacity-50 cursor-not-allowed"),
	"data-testid": "card-activation-toggle",
	children: /* @__PURE__ */ V("span", { className: J("inline-block h-4 w-4 transform rounded-full bg-white transition-transform", t ? "translate-x-6" : "translate-x-1") })
}), Tn = ({ pinCode: e, secondsRemaining: t, onClose: n }) => /* @__PURE__ */ H("div", {
	className: "relative flex items-center justify-between bg-lightprimary dark:bg-primary/20 border border-primary/30 dark:border-primary/40 rounded-lg p-3",
	role: "region",
	"aria-label": "Code PIN temporaire",
	"data-testid": "inline-pin-display",
	children: [/* @__PURE__ */ V("div", {
		className: "flex items-center gap-3 flex-1",
		children: /* @__PURE__ */ H("div", {
			className: "flex flex-col gap-1",
			children: [/* @__PURE__ */ V("div", {
				className: "text-3xl font-mono font-bold text-gray-900 dark:text-white tracking-wider",
				"data-testid": "pin-code-display",
				children: e
			}), /* @__PURE__ */ V("p", {
				className: "text-xs text-gray-500 dark:text-gray-400",
				children: `Fermeture dans ${t}s`
			})]
		})
	}), /* @__PURE__ */ V("button", {
		type: "button",
		onClick: n,
		className: "flex items-center justify-center w-8 h-8 rounded-md hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors",
		"aria-label": "Masquer le code PIN",
		"data-testid": "close-pin-button",
		children: /* @__PURE__ */ V(It, {
			size: 18,
			className: "text-gray-600 dark:text-gray-400"
		})
	})]
}), En = ({ cardId: e, isActive: t, onToggleLock: n, isUpdating: r = !1, isLocking: i = !1, isUnlocking: a = !1, isPinVisible: o, isPinLoading: s = !1, pin: c, secondsRemaining: l, onShowPin: u, onHidePin: d }) => /* @__PURE__ */ H(B, { children: [
	/* @__PURE__ */ V("h3", {
		className: "text-base font-bold text-gray-900 dark:text-white",
		children: `Carte ${t ? "active" : "désactivée"}`
	}),
	o ? c ? /* @__PURE__ */ V(Tn, {
		pinCode: c,
		secondsRemaining: l,
		onClose: d
	}) : null : /* @__PURE__ */ V(dn, {
		type: "button",
		color: "primary",
		onClick: u,
		disabled: s || r,
		isLoading: s,
		className: "w-full",
		"data-testid": "show-pin-button",
		children: "Afficher mon PIN"
	}),
	/* @__PURE__ */ H("div", {
		className: "flex flex-col gap-1",
		children: [/* @__PURE__ */ H("label", {
			htmlFor: `active-toggle-${e}`,
			className: "flex flex-row items-center justify-between",
			children: [/* @__PURE__ */ V("div", {
				className: "flex items-center gap-2 text-sm font-medium text-gray-700 dark:text-gray-300",
				children: i ? "Verrouillage en cours…" : a ? "Déverrouillage en cours…" : t ? "Verrouiller ma carte" : "Déverrouiller ma carte"
			}), /* @__PURE__ */ H("div", {
				className: "flex items-center gap-2",
				children: [(i || a) && /* @__PURE__ */ V(Ne, {
					className: "w-4 h-4 animate-spin text-primary",
					"data-testid": "switch-spinner"
				}), /* @__PURE__ */ V(wn, {
					id: `active-toggle-${e}`,
					checked: t,
					onChange: n,
					disabled: r
				})]
			})]
		}), /* @__PURE__ */ V("p", {
			className: "text-xs text-gray-500 dark:text-gray-400",
			children: "Désactivez si perdue ou volée."
		})]
	})
] }), Dn = ({ cardId: e, onActivateCard: t }) => /* @__PURE__ */ H(B, { children: [/* @__PURE__ */ H("div", { children: [/* @__PURE__ */ V("h3", {
	className: "text-base font-bold text-gray-900 dark:text-white mb-1",
	children: "Carte non activée"
}), /* @__PURE__ */ V("p", {
	className: "text-sm text-gray-600 dark:text-gray-400",
	children: "Vous n'avez pas encore activé votre carte. Vous pouvez le faire en renseignant votre code PIN."
})] }), /* @__PURE__ */ V(dn, {
	type: "button",
	color: "primary",
	onClick: () => t(e),
	className: "w-full",
	"data-testid": "activate-card-button",
	children: "Activer ma carte"
})] }), On = ({ dataTestId: e, data: t, variant: n = "standard", isScanning: r = !1 }) => {
	let i = bn(n), a = i.getDisplayedNumber(t), o = n === "masked";
	return /* @__PURE__ */ H("div", {
		"data-testid": e,
		className: "relative w-full h-full min-w-[244px] max-w-[310px] aspect-[287/168] overflow-visible",
		children: [r && /* @__PURE__ */ V(Cn, {}), /* @__PURE__ */ V("div", {
			className: J("font-mono text-base", i.textColorClassName, "relative flex flex-col justify-between gap-2 w-full min-w-[244px] max-w-[310px] h-full aspect-[287/168] rounded-md py-3 px-4 shadow-lg border transition-all duration-200", i.cardClassName, !t.isActive && "opacity-50 shadow-none before:content-[''] before:absolute before:opacity-100 before:inset-0 before:bg-[repeating-linear-gradient(-45deg,transparent,transparent_20px,rgba(128,128,128,0.6)_20px,rgba(128,128,128,0.6)_40px)] dark:before:bg-[repeating-linear-gradient(45deg,transparent,transparent_20px,rgba(64,64,64,0.6)_20px,rgba(64,64,64,0.6)_40px)] before:rounded-md before:pointer-events-none before:z-10"),
			children: o ? /* @__PURE__ */ H(B, { children: [
				/* @__PURE__ */ V("div", {
					className: "flex justify-end",
					children: /* @__PURE__ */ V(Sn, { className: "max-w-[72px] sm:max-w-[88px]" })
				}),
				/* @__PURE__ */ V("div", { className: "flex-1" }),
				/* @__PURE__ */ H("div", {
					className: "flex items-end justify-between gap-2 min-w-0",
					children: [/* @__PURE__ */ V("h5", {
						className: "min-w-0 flex-1 truncate text-sm sm:text-base",
						children: t.embossedName.toUpperCase()
					}), /* @__PURE__ */ V(xn, { className: "shrink-0" })]
				})
			] }) : /* @__PURE__ */ H(B, { children: [
				/* @__PURE__ */ H("div", {
					className: "flex min-w-0 flex-row justify-between items-end gap-2",
					children: [/* @__PURE__ */ V("h5", {
						className: "min-w-0 truncate text-xs sm:text-sm",
						children: a
					}), /* @__PURE__ */ V(Sn, { className: "shrink-0 max-w-[72px] sm:max-w-[88px]" })]
				}),
				/* @__PURE__ */ V("h5", {
					className: "flex-1 min-w-0 truncate text-base sm:text-lg",
					children: t.embossedName.toUpperCase()
				}),
				/* @__PURE__ */ H("div", {
					className: "flex min-w-0 flex-row justify-between items-end gap-2",
					children: [/* @__PURE__ */ H("h5", {
						className: "min-w-0 flex-1 truncate text-xs sm:text-base",
						children: [/* @__PURE__ */ V("span", {
							className: "text-xs sm:text-sm mr-2 sm:mr-3",
							children: "Expiration"
						}), `${t.expireAt.month}/${t.expireAt.shortYear}`]
					}), /* @__PURE__ */ V(xn, { className: "shrink-0" })]
				})
			] })
		})]
	});
}, kn = {
	id: "placeholder",
	lastFour: "0000",
	formattedCardNumber: _n,
	embossedName: "Prénom Nom",
	isActive: !1,
	isActivated: !1,
	isUnlocked: !1,
	type: "mastercard",
	expiryDate: "",
	expireAt: {
		month: "00",
		shortYear: "00"
	}
}, An = ({ variant: e }) => /* @__PURE__ */ H("div", {
	className: "flex flex-col items-center gap-4",
	children: [/* @__PURE__ */ V(On, {
		data: kn,
		variant: e
	}), /* @__PURE__ */ V("p", {
		className: "text-sm text-gray-500 dark:text-gray-400",
		children: "Aucune carte disponible"
	})]
}), jn = ({ card: e, variant: t = "standard", isScanning: n = !1, showControls: r = !0, isLocking: i = !1, isUnlocking: a = !1, isPinLoading: o = !1, pin: s, pinVisibleDuration: c = gn, onToggleLock: l, onActivateCard: u, onShowPin: d, onHidePin: f }) => {
	let [p, m] = q(e.isUnlocked), [h, g] = q(!1), [_, v] = q(c), [y, b] = q(!1), [x, S] = q(!1), [C, w] = q(!1), T = !d && !l, [E] = q(() => T ? String(Math.floor(1e3 + Math.random() * 9e3)) : null), D = s ?? E, O = e.isActivated, k = i || a || y;
	W(() => {
		if (!h || !D) {
			v(c);
			return;
		}
		let e = setInterval(() => {
			v((e) => e <= 1 ? (g(!1), f?.(), c) : e - 1);
		}, 1e3);
		return () => clearInterval(e);
	}, [
		h,
		D,
		c,
		f
	]);
	let ee = () => {
		if (k || !O) return;
		let t = !p;
		m(t), T && (b(!0), t ? w(!0) : S(!0), setTimeout(() => {
			b(!1), S(!1), w(!1);
		}, 1500)), l?.(e.id, !t);
	}, A = () => {
		g(!0), d?.(e.id);
	}, j = () => {
		g(!1), f?.();
	}, M = p && O;
	return /* @__PURE__ */ H("div", {
		"data-testid": "card-manager",
		className: "@container mx-auto w-full max-w-2xl",
		children: [/* @__PURE__ */ H("h2", {
			className: "text-base font-semibold text-gray-900 dark:text-white mb-4",
			children: [
				"Ma carte",
				" ",
				/* @__PURE__ */ V("span", { dangerouslySetInnerHTML: { __html: e.formattedCardNumber } })
			]
		}), /* @__PURE__ */ H("div", {
			className: "flex flex-col items-center @md:flex-row @md:items-start gap-4",
			children: [/* @__PURE__ */ V("div", {
				className: "w-full @md:w-auto @md:max-w-[310px] flex-shrink-0",
				children: /* @__PURE__ */ V(On, {
					dataTestId: `${M ? "active" : "inactive"}-payment-card-${e.id}`,
					data: {
						...e,
						isActive: M
					},
					variant: t,
					isScanning: n || y
				})
			}), r && /* @__PURE__ */ V("div", {
				className: "flex flex-col gap-3 w-full @md:flex-1 min-w-0",
				children: O ? /* @__PURE__ */ V(En, {
					cardId: e.id,
					isActive: p,
					onToggleLock: ee,
					isUpdating: k,
					isLocking: i || x,
					isUnlocking: a || C,
					isPinVisible: h,
					isPinLoading: o,
					pin: D,
					secondsRemaining: _,
					onShowPin: A,
					onHidePin: j
				}) : /* @__PURE__ */ V(Dn, {
					cardId: e.id,
					onActivateCard: u ?? (() => {})
				})
			})]
		})]
	});
}, Mn = ({ keys: e, current: t, hasPrevious: n, hasNext: r, goToPrevious: i, goToNext: a, goTo: o }) => /* @__PURE__ */ H(B, { children: [
	/* @__PURE__ */ V("button", {
		type: "button",
		onClick: i,
		disabled: !n,
		className: J("p-2 rounded-full transition-colors", n ? "text-primary hover:bg-lightprimary dark:hover:bg-primary/20" : "text-gray-300 dark:text-gray-600 cursor-not-allowed"),
		"aria-label": "Voir ma carte précédente",
		"data-testid": "previous-card-button",
		children: /* @__PURE__ */ V(E, { className: "w-5 h-5" })
	}),
	/* @__PURE__ */ V("div", {
		className: "flex items-center gap-1",
		children: e.map((e, n) => /* @__PURE__ */ V("button", {
			type: "button",
			onClick: () => o(n),
			className: J("rounded-full h-2 w-2 transition-colors", t === n ? "bg-primary pointer-events-none" : "bg-gray-300 dark:bg-gray-600 hover:bg-gray-400 dark:hover:bg-gray-500"),
			"data-testid": `card-indicator-${n}`,
			"aria-label": `Aller à la carte ${n + 1}`
		}, e))
	}),
	/* @__PURE__ */ V("button", {
		type: "button",
		onClick: a,
		disabled: !r,
		className: J("p-2 rounded-full transition-colors", r ? "text-primary hover:bg-lightprimary dark:hover:bg-primary/20" : "text-gray-300 dark:text-gray-600 cursor-not-allowed"),
		"aria-label": "Voir ma carte suivante",
		"data-testid": "next-card-button",
		children: /* @__PURE__ */ V(D, { className: "w-5 h-5" })
	})
] }), Nn = ({ cards: e, variant: t = "standard", isScanning: n = !1, showControls: r = !0, isLocking: i = !1, isUnlocking: a = !1, isPinLoading: o = !1, pin: s, pinVisibleDuration: c, onToggleLock: l, onActivateCard: u, onShowPin: d, onHidePin: f }) => {
	let [p, m] = q(0), h = e.length, g = p > 0, _ = p < h - 1, v = e[p];
	return /* @__PURE__ */ H("div", {
		className: "relative",
		children: [/* @__PURE__ */ V("div", {
			className: "overflow-hidden px-6 mx-[-1.5rem]",
			children: /* @__PURE__ */ V("div", {
				id: "slider",
				className: "flex flex-row gap-10 pb-4 [&>*]:min-w-full",
				style: {
					transform: `translateX(calc(-${p * 100}% - ${p * hn}rem))`,
					transition: `transform ${mn}ms ease-in-out`
				},
				children: e.map((e) => /* @__PURE__ */ V("div", {
					"data-testid": `card-slide-${e.id}`,
					children: /* @__PURE__ */ V(jn, {
						card: e,
						variant: t,
						isScanning: n && e.id === v?.id,
						showControls: r,
						isLocking: i,
						isUnlocking: a,
						isPinLoading: o,
						pin: e.id === v?.id ? s : void 0,
						pinVisibleDuration: c,
						onToggleLock: l,
						onActivateCard: u,
						onShowPin: d,
						onHidePin: f
					})
				}, e.id))
			})
		}), h > 1 && /* @__PURE__ */ H("div", {
			className: "mt-2 text-center text-sm",
			children: [/* @__PURE__ */ V("p", {
				className: "text-red-500 text-sm pb-0 mb-1",
				children: `Vous avez ${h} cartes Yeati en cours.`
			}), /* @__PURE__ */ V("div", {
				className: "flex justify-center items-center gap-2",
				children: /* @__PURE__ */ V(Mn, {
					keys: e.map(({ id: e }) => e),
					current: p,
					hasPrevious: g,
					hasNext: _,
					goToPrevious: () => {
						p !== 0 && m(p - 1);
					},
					goToNext: () => {
						p !== h - 1 && m(p + 1);
					},
					goTo: (e) => m(e)
				})
			})]
		})]
	});
};
function Pn({ card: e, cards: t, variant: n = "standard", isScanning: r = !1, showControls: i = !0, compactPreview: a = !1, pinVisibleDuration: o = gn, backgroundColor: s, className: c, isLoading: l = !1, disabled: u = !1, isLocking: d = !1, isUnlocking: f = !1, isPinLoading: p = !1, pin: m, onToggleLock: h, onActivateCard: g, onShowPin: _, onHidePin: v }) {
	let y = t ?? (e ? [e] : []), b = yn(n), x = !a && i;
	return u ? /* @__PURE__ */ V(X, {
		backgroundColor: s,
		className: c,
		children: /* @__PURE__ */ V("div", {
			className: "flex justify-center",
			children: /* @__PURE__ */ V(On, {
				data: kn,
				variant: b
			})
		})
	}) : l && y.length === 0 ? /* @__PURE__ */ V(Z, {
		rows: 2,
		className: c
	}) : y.length === 0 ? /* @__PURE__ */ V(X, {
		backgroundColor: s,
		className: c,
		children: /* @__PURE__ */ V(An, { variant: b })
	}) : /* @__PURE__ */ V(X, {
		backgroundColor: s,
		className: c,
		children: y.length === 1 ? /* @__PURE__ */ V(jn, {
			card: y[0],
			variant: b,
			isScanning: r,
			showControls: x,
			isLocking: d,
			isUnlocking: f,
			isPinLoading: p,
			pin: m,
			pinVisibleDuration: o,
			onToggleLock: h,
			onActivateCard: g,
			onShowPin: _,
			onHidePin: v
		}) : /* @__PURE__ */ V(Nn, {
			cards: y,
			variant: b,
			isScanning: r,
			showControls: x,
			isLocking: d,
			isUnlocking: f,
			isPinLoading: p,
			pin: m,
			pinVisibleDuration: o,
			onToggleLock: h,
			onActivateCard: g,
			onShowPin: _,
			onHidePin: v
		})
	});
}
//#endregion
//#region src/components/widgets/ExpensesWidget.tsx
var Fn = (e) => Qt(new Intl.NumberFormat("fr-FR", {
	style: "currency",
	currency: "EUR"
}).format(e)), In = (e) => new Date(e).toLocaleDateString("fr-FR", {
	day: "numeric",
	month: "long",
	year: "numeric",
	hour: "2-digit",
	minute: "2-digit"
}).replace(/^[1] /, "1er "), Ln = (e) => {
	let t = e.split(" ").filter((e) => e.length > 0);
	return t.length >= 2 ? t.slice(0, 2).map((e) => e[0]).join("").toUpperCase() : e.slice(0, 2).toUpperCase();
}, Rn = ({ label: e }) => /* @__PURE__ */ V("div", {
	className: "size-8 rounded-md bg-gray-200 dark:bg-gray-600 flex items-center justify-center flex-shrink-0",
	children: /* @__PURE__ */ V("span", {
		className: "text-xs font-semibold text-gray-700 dark:text-gray-200",
		children: Ln(e)
	})
}), zn = () => /* @__PURE__ */ V("tbody", {
	className: "divide-y divide-gray-200 dark:divide-gray-700",
	children: Array.from({ length: 5 }).map((e, t) => /* @__PURE__ */ V("tr", { children: /* @__PURE__ */ V("td", {
		colSpan: 2,
		className: "p-0",
		children: /* @__PURE__ */ H("div", {
			className: "flex justify-between items-center py-3 px-2",
			children: [/* @__PURE__ */ H("div", {
				className: "flex gap-3 items-center",
				children: [/* @__PURE__ */ V("div", { className: "w-8 h-8 bg-gray-200 dark:bg-gray-700 animate-pulse rounded-md" }), /* @__PURE__ */ H("div", {
					className: "flex flex-col gap-1",
					children: [/* @__PURE__ */ V("div", { className: "w-40 h-5 bg-gray-200 dark:bg-gray-700 animate-pulse rounded" }), /* @__PURE__ */ V("div", { className: "w-32 h-3 bg-gray-200 dark:bg-gray-700 animate-pulse rounded" })]
				})]
			}), /* @__PURE__ */ H("div", {
				className: "flex flex-col items-end gap-1",
				children: [/* @__PURE__ */ V("div", { className: "w-20 h-5 bg-gray-200 dark:bg-gray-700 animate-pulse rounded" }), /* @__PURE__ */ H("div", {
					className: "flex items-center gap-1",
					children: [/* @__PURE__ */ V("div", { className: "w-16 h-4 bg-gray-200 dark:bg-gray-700 animate-pulse rounded" }), /* @__PURE__ */ V("div", { className: "w-4 h-4 bg-gray-200 dark:bg-gray-700 animate-pulse rounded" })]
				})]
			})]
		})
	}) }, `expense-skeleton-${t}`))
}), Bn = () => /* @__PURE__ */ V("tr", { children: /* @__PURE__ */ V("td", {
	colSpan: 2,
	className: "text-center py-8",
	"data-testid": "no-recent-expenses",
	children: /* @__PURE__ */ V("p", {
		className: "text-sm text-gray-500 dark:text-gray-400",
		children: "Aucune dépense de moins de 6 mois"
	})
}) }), Vn = ({ expense: e, isExpanded: t, onToggle: n }) => {
	let r = (e) => {
		(e.key === "Enter" || e.key === " ") && (e.preventDefault(), n());
	}, i = t ? "Masquer les détails" : "Afficher les détails", a = `détail ${t ? "moins" : "plus"}`;
	return /* @__PURE__ */ H("tr", {
		"data-testid": `expense-row-${e.payment_id}`,
		className: "cursor-pointer hover:text-primary hover:bg-lightprimary dark:hover:bg-primary/20 transition-colors duration-200",
		onClick: n,
		onKeyDown: r,
		tabIndex: 0,
		role: "button",
		"aria-expanded": t,
		"aria-label": `${e.merchant_name} - ${i}`,
		children: [/* @__PURE__ */ V("td", {
			className: "whitespace-nowrap py-3 ps-2",
			children: /* @__PURE__ */ H("div", {
				className: "flex gap-3 items-center",
				children: [e.merchant_logo?.medium_url ? /* @__PURE__ */ V("img", {
					src: e.merchant_logo.medium_url,
					alt: `Logo ${e.merchant_name}`,
					className: "size-8 rounded-md object-cover flex-shrink-0"
				}) : /* @__PURE__ */ V(Rn, { label: e.merchant_name }), /* @__PURE__ */ H("div", {
					className: "truncate line-clamp-2 text-wrap max-w-56",
					children: [/* @__PURE__ */ V("p", {
						className: "text-base text-gray-900 dark:text-white",
						children: e.merchant_name
					}), /* @__PURE__ */ V("p", {
						className: "text-xs text-gray-500 dark:text-gray-400",
						children: `Le ${In(e.authorization_time)}`
					})]
				})]
			})
		}), /* @__PURE__ */ V("td", {
			className: "text-end pe-1 py-3",
			children: /* @__PURE__ */ H("div", {
				className: "flex flex-col items-end gap-0",
				children: [e.total_transaction_amount < 0 ? /* @__PURE__ */ H("p", {
					className: "text-base text-green-600 dark:text-green-400 font-medium whitespace-nowrap pe-1",
					children: ["+", Fn(Math.abs(e.total_transaction_amount))]
				}) : /* @__PURE__ */ H("p", {
					className: "text-base text-red-600 dark:text-red-400 font-medium whitespace-nowrap pe-1",
					children: ["-", Fn(e.total_transaction_amount)]
				}), /* @__PURE__ */ H("button", {
					className: "text-sm text-right text-primary dark:text-primary whitespace-nowrap p-0 m-0 h-6 flex items-center gap-1",
					onClick: (e) => {
						e.stopPropagation(), n();
					},
					"aria-label": a,
					"aria-expanded": t,
					children: [
						/* @__PURE__ */ V("span", {
							className: "sr-only",
							children: a
						}),
						/* @__PURE__ */ V("span", {
							className: "text-xs",
							children: "voir le détail"
						}),
						V(t ? T : D, {
							size: 16,
							"aria-hidden": "true"
						})
					]
				})]
			})
		})]
	});
}, Hn = ({ transactions: e, isExpanded: t, paymentId: n, showBottomBorder: r }) => {
	let i = K(null), [a, o] = q(0);
	return W(() => {
		if (i.current) {
			let e = i.current.scrollHeight;
			o(e);
		}
	}, [e]), /* @__PURE__ */ V("tr", {
		className: `bg-gray-50 dark:bg-gray-700/50 ${r ? "border-b border-gray-200 dark:border-gray-700" : ""}`,
		children: /* @__PURE__ */ V("td", {
			colSpan: 2,
			className: "p-0 sm:pl-14 w-full text-sm text-gray-500 dark:text-gray-400 overflow-hidden",
			children: /* @__PURE__ */ V("div", {
				"data-testid": `expense-details-${n}`,
				className: "transition-all duration-300 ease-in-out overflow-hidden",
				style: {
					maxHeight: t ? `${a}px` : "0px",
					opacity: +!!t
				},
				children: /* @__PURE__ */ V("div", {
					ref: i,
					children: e.map((e) => /* @__PURE__ */ H("div", {
						"data-testid": `transaction-${e.id}`,
						className: "flex justify-between items-center gap-4 p-2 border-b border-gray-200 dark:border-gray-600 last:border-b-0 last:pb-4",
						children: [/* @__PURE__ */ V("span", {
							className: "flex-1",
							children: e.voucher_employee_voucher_campaign_name
						}), /* @__PURE__ */ V("span", {
							className: `text-right whitespace-nowrap font-medium ${e.amount < 0 ? "text-green-600 dark:text-green-400" : "text-red-600 dark:text-red-400"}`,
							children: e.amount < 0 ? `+${Fn(Math.abs(e.amount))}` : `-${Fn(e.amount)}`
						})]
					}, e.id))
				})
			})
		})
	});
};
function Un({ expenses: e, maxItems: t, title: n = "Mes dernières dépenses", isLoading: r = !1, onViewAllClick: i, className: a }) {
	let [o, s] = q(null), c = (e) => {
		s((t) => t === e ? null : e);
	}, l = t ? e.slice(0, t) : e;
	return /* @__PURE__ */ V(X, {
		className: a,
		children: /* @__PURE__ */ H("table", {
			className: "w-full",
			children: [/* @__PURE__ */ V("thead", { children: /* @__PURE__ */ V("tr", { children: /* @__PURE__ */ V("th", {
				colSpan: 2,
				className: "p-0 pb-2 bg-transparent text-left",
				children: /* @__PURE__ */ H("div", {
					className: "flex justify-between items-center gap-4",
					children: [/* @__PURE__ */ V("h2", {
						className: "text-base font-bold text-gray-900 dark:text-white normal-case",
						children: n
					}), /* @__PURE__ */ H("button", {
						onClick: i,
						className: "flex flex-1 items-center justify-end text-xs text-right font-semibold text-primary dark:text-primary hover:underline",
						children: ["Toutes mes dépenses", /* @__PURE__ */ V(D, {
							size: 15,
							className: "ms-1"
						})]
					})]
				})
			}) }) }), r ? /* @__PURE__ */ V(zn, {}) : /* @__PURE__ */ V("tbody", { children: l.length > 0 ? l.map((e, t) => /* @__PURE__ */ H(Rt, { children: [/* @__PURE__ */ V(Vn, {
				expense: e,
				isExpanded: o === e.payment_id,
				onToggle: () => c(e.payment_id)
			}), /* @__PURE__ */ V(Hn, {
				transactions: e.transactions,
				isExpanded: o === e.payment_id,
				paymentId: e.payment_id,
				showBottomBorder: t < l.length - 1
			})] }, e.payment_id)) : /* @__PURE__ */ V(Bn, {}) })]
		})
	});
}
//#endregion
//#region src/components/widgets/HeroWidget.tsx
var Wn = () => /* @__PURE__ */ H("div", {
	className: "flex items-center gap-4",
	children: [/* @__PURE__ */ V("div", { className: "w-10 h-10 rounded-full bg-gray-200 dark:bg-gray-700 animate-pulse" }), /* @__PURE__ */ V("div", { className: "w-40 h-5 bg-gray-200 dark:bg-gray-700 animate-pulse rounded" })]
}), Gn = ({ userName: e, animated: t = !1, showGreeting: n = !0, backgroundColor: r, backgroundImage: i, title: a, subtitle: o, mascotImage: s, mascotAlt: c = "Mascotte", isLoading: l = !1, className: u }) => {
	if (l) return /* @__PURE__ */ V(X, {
		className: J("relative overflow-hidden border-none", u),
		backgroundColor: r,
		children: /* @__PURE__ */ V(Wn, {})
	});
	let d = !!i, f = a || (n ? `Bienvenue, ${e}` : "");
	return /* @__PURE__ */ H(X, {
		className: J("relative overflow-hidden border-none", !d && !r && "bg-blue-50 dark:bg-blue-950", t && "transition-all duration-300", u),
		backgroundColor: r,
		backgroundImage: i,
		children: [/* @__PURE__ */ V("div", {
			className: J("flex items-center gap-4 m-0 p-0 z-10 min-w-0 w-fit", d && "backdrop-blur-sm bg-white/70 dark:bg-gray-900/70 rounded-lg p-3"),
			children: /* @__PURE__ */ H("div", {
				className: "flex-1 min-w-0",
				children: [/* @__PURE__ */ V("h4", {
					className: J("card-title text-base font-semibold min-w-0 whitespace-normal", "text-gray-900 dark:text-white"),
					children: f
				}), o && /* @__PURE__ */ V("p", {
					className: "mt-1 text-sm text-gray-700 dark:text-gray-200 whitespace-normal",
					children: o
				})]
			})
		}), s && /* @__PURE__ */ V("img", {
			alt: c,
			className: "absolute bottom-0 right-0 w-32 z-10",
			src: s
		})]
	});
}, Kn = "\n  .sw-container-hover:hover { background-color: var(--w-bg-subtle, rgba(254,205,211,0.6)) !important; }\n";
function qn({ promoText: e = "Decouvrez nos produits", ctaText: t = "La boutique", title: n, onShopClick: r, isLoading: i = !1, className: a }) {
	if (i) return /* @__PURE__ */ V(Z, {
		rows: 2,
		className: a
	});
	let o = n || t, s = () => {
		r && r();
	};
	return /* @__PURE__ */ H("div", {
		className: J("dark:bg-rose-900 rounded-lg p-3 sm:p-3.5 md:p-4 lg:p-4 xl:p-6", r && "cursor-pointer sw-container-hover dark:hover:bg-rose-800/60 transition-colors", a),
		style: { backgroundColor: "var(--w-bg, #ffe4e6)" },
		onClick: s,
		role: r ? "button" : void 0,
		tabIndex: r ? 0 : void 0,
		onKeyDown: r ? (e) => {
			(e.key === "Enter" || e.key === " ") && (e.preventDefault(), s());
		} : void 0,
		children: [/* @__PURE__ */ V("style", { children: Kn }), /* @__PURE__ */ H("div", {
			className: "flex flex-col items-center justify-center h-full gap-2 xl:gap-3",
			children: [
				/* @__PURE__ */ V("div", {
					className: "rounded-lg dark:bg-rose-800 p-2 xl:p-3",
					style: { backgroundColor: "var(--w-bg-emphasis, #fecdd3)" },
					children: /* @__PURE__ */ V(pt, {
						size: 24,
						className: "xl:w-7 xl:h-7 dark:text-rose-400",
						style: { color: "var(--w-text, #e11d48)" },
						"aria-hidden": "true"
					})
				}),
				/* @__PURE__ */ V("span", {
					className: "text-base xl:text-lg font-bold dark:text-rose-300",
					style: { color: "var(--w-text, #e11d48)" },
					children: o
				}),
				e && /* @__PURE__ */ V("p", {
					className: "text-xs xl:text-sm dark:text-rose-400",
					style: { color: "var(--w-text-subtle, #f43f5e)" },
					children: e
				})
			]
		})]
	});
}
//#endregion
//#region src/components/widgets/VouchersWidget.tsx
var Jn = {
	"Noël des enfants": {
		textColor: "text-rose-900 dark:text-rose-200",
		badgeColor: "bg-rose-500/15",
		background: "bg-gradient-to-br from-rose-200/10 to-rose-500/10"
	},
	"Noël des salariés": {
		textColor: "text-red-900 dark:text-red-200",
		badgeColor: "bg-red-500/15",
		background: "bg-gradient-to-br from-red-200/10 to-red-500/10"
	},
	"Fête Ste Catherine": {
		textColor: "text-green-900 dark:text-green-200",
		badgeColor: "bg-green-500/15",
		background: "bg-gradient-to-br from-green-200/10 to-green-500/10"
	},
	"Fête des Mères": {
		textColor: "text-pink-900 dark:text-pink-200",
		badgeColor: "bg-pink-500/15",
		background: "bg-gradient-to-br from-pink-200/10 to-pink-500/10"
	},
	"Fête des Pères": {
		textColor: "text-blue-900 dark:text-blue-200",
		badgeColor: "bg-blue-500/15",
		background: "bg-gradient-to-br from-blue-200/10 to-blue-500/10"
	},
	"Fête St Nicolas": {
		textColor: "text-teal-900 dark:text-teal-200",
		badgeColor: "bg-teal-500/15",
		background: "bg-gradient-to-br from-teal-200/10 to-teal-500/10"
	},
	"Départ en Retraite": {
		textColor: "text-emerald-900 dark:text-emerald-200",
		badgeColor: "bg-emerald-500/15",
		background: "bg-gradient-to-br from-emerald-200/10 to-emerald-500/10"
	},
	"Mariage / PACS": {
		textColor: "text-fuchsia-900 dark:text-fuchsia-200",
		badgeColor: "bg-fuchsia-500/15",
		background: "bg-gradient-to-br from-fuchsia-200/10 to-fuchsia-500/10"
	},
	Naissance: {
		textColor: "text-violet-900 dark:text-violet-200",
		badgeColor: "bg-violet-500/15",
		background: "bg-gradient-to-br from-violet-200/10 to-violet-500/10"
	},
	"Rentrée scolaire": {
		textColor: "text-primary dark:text-primary",
		badgeColor: "bg-primary/15",
		background: "bg-gradient-to-br from-primary/10 to-primary/20"
	},
	Culture: {
		textColor: "text-lime-900 dark:text-lime-200",
		badgeColor: "bg-lime-500/15",
		background: "bg-gradient-to-br from-lime-200/10 to-lime-500/10"
	},
	"Aide aux vacances": {
		textColor: "text-amber-900 dark:text-amber-200",
		badgeColor: "bg-amber-500/15",
		background: "bg-gradient-to-br from-yellow-200/10 to-yellow-500/10"
	},
	Remboursement: {
		textColor: "text-slate-900 dark:text-slate-200",
		badgeColor: "bg-slate-500/15",
		background: "bg-gradient-to-br from-slate-200/10 to-slate-500/10"
	},
	"Hors évènement": {
		textColor: "text-stone-900 dark:text-stone-200",
		badgeColor: "bg-stone-500/15",
		background: "bg-gradient-to-br from-stone-200/10 to-stone-500/10"
	}
}, Yn = {
	textColor: "text-gray-900 dark:text-gray-200",
	badgeColor: "bg-gray-500/15",
	background: "bg-gradient-to-br from-gray-200/10 to-gray-500/10"
}, Xn = (e) => Qt(new Intl.NumberFormat("fr-FR", {
	style: "currency",
	currency: "EUR"
}).format(e)), Zn = (e) => new Date(e).toLocaleDateString("fr-FR", {
	day: "numeric",
	month: "long",
	year: "numeric"
}), Qn = (e) => {
	let t = new Date(e.end_date), n = /* @__PURE__ */ new Date();
	return n.setHours(0, 0, 0, 0), t < n;
}, $n = (e) => e.balance === 0 || Qn(e), er = (e) => Jn[e] || Yn, tr = ({ id: e, checked: t, onChange: n, disabled: r = !1, label: i, isLoading: a = !1 }) => /* @__PURE__ */ H("div", {
	className: "flex items-center gap-3",
	children: [/* @__PURE__ */ V("label", {
		htmlFor: e,
		className: J("text-sm font-medium text-gray-700 dark:text-gray-300", (r || a) && "opacity-50"),
		children: i
	}), /* @__PURE__ */ V("button", {
		id: e,
		type: "button",
		role: "switch",
		"aria-checked": t,
		onClick: n,
		disabled: r || a,
		className: J("relative inline-flex h-6 w-11 items-center rounded-full transition-colors", t ? "bg-primary" : "bg-gray-300 dark:bg-gray-600", (r || a) && "opacity-50 cursor-not-allowed"),
		"data-testid": "sortable-toggle",
		children: /* @__PURE__ */ V("span", { className: J("inline-block h-4 w-4 transform rounded-full bg-white transition-transform", t ? "translate-x-6" : "translate-x-1") })
	})]
}), nr = () => /* @__PURE__ */ V("div", {
	className: "w-full h-[100px] bg-gray-200 dark:bg-gray-700 rounded-lg animate-pulse",
	"data-testid": "voucher-skeleton"
}), rr = () => /* @__PURE__ */ H("div", {
	className: "flex items-center gap-3",
	children: [/* @__PURE__ */ V("div", { className: "w-64 h-4 bg-gray-200 dark:bg-gray-700 rounded animate-pulse" }), /* @__PURE__ */ V("div", { className: "w-11 h-6 bg-gray-200 dark:bg-gray-700 rounded-full animate-pulse" })]
}), ir = () => /* @__PURE__ */ H("div", {
	className: "flex items-center gap-3 py-2",
	children: [
		/* @__PURE__ */ V("div", { className: "flex-1 h-px bg-gray-300 dark:bg-gray-600" }),
		/* @__PURE__ */ V("span", {
			className: "text-xs text-gray-500 dark:text-gray-400 whitespace-nowrap",
			children: "Bons épuisés"
		}),
		/* @__PURE__ */ V("div", { className: "flex-1 h-px bg-gray-300 dark:bg-gray-600" })
	]
}), ar = ({ index: e, totalCount: t, onMoveUp: n, onMoveDown: r, isDraggable: i, dragHandleProps: a }) => {
	if (!i) return null;
	let o = e === 0, s = e === t - 1;
	return /* @__PURE__ */ H("div", {
		className: "flex flex-col items-center justify-center gap-0.5 pr-2",
		children: [
			/* @__PURE__ */ V("button", {
				type: "button",
				onClick: (e) => {
					e.stopPropagation(), n();
				},
				disabled: o,
				className: J("p-0.5 rounded transition-colors", o ? "text-gray-300 dark:text-gray-600 cursor-not-allowed" : "text-gray-500 dark:text-gray-400 hover:text-primary hover:bg-gray-100 dark:hover:bg-gray-700"),
				"aria-label": "Déplacer vers le haut",
				children: /* @__PURE__ */ V(O, { size: 16 })
			}),
			/* @__PURE__ */ V("div", {
				...a,
				className: "p-1 cursor-grab text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300",
				"aria-label": "Glisser pour réordonner",
				children: /* @__PURE__ */ V(ve, { size: 20 })
			}),
			/* @__PURE__ */ V("button", {
				type: "button",
				onClick: (e) => {
					e.stopPropagation(), r();
				},
				disabled: s,
				className: J("p-0.5 rounded transition-colors", s ? "text-gray-300 dark:text-gray-600 cursor-not-allowed" : "text-gray-500 dark:text-gray-400 hover:text-primary hover:bg-gray-100 dark:hover:bg-gray-700"),
				"aria-label": "Déplacer vers le bas",
				children: /* @__PURE__ */ V(T, { size: 16 })
			})
		]
	});
};
ar.displayName = "DragHandle";
var or = ({ voucher: e, isDragging: t, isDraggable: n, onVoucherClick: r }) => {
	let i = $n(e), a = Qn(e), o = er(e.event), s = !!e.mascot_thumbnail_url, c = !i && !!e.customBackgroundColor, l = !i && !!e.customTextColor;
	return /* @__PURE__ */ V("div", {
		className: J(!c && o.background, "rounded-lg p-2 border transition-all duration-200", "border-black/15 border-t-white/30 dark:border-black/15 dark:border-t-white/5", n ? "shadow-sm hover:shadow-lg" : "hover:cursor-default shadow-none", t && "opacity-50 scale-105 shadow-xl", i && "opacity-60 grayscale-[50%]"),
		style: c ? { background: e.customBackgroundColor } : void 0,
		children: /* @__PURE__ */ H("div", {
			className: "min-h-[100px] flex gap-2 items-center",
			children: [/* @__PURE__ */ V("img", {
				src: s ? e.mascot_thumbnail_url : "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='128' height='128' viewBox='0 0 128 128'%3E%3Crect fill='%23e5e7eb' width='128' height='128'/%3E%3C/svg%3E",
				alt: e.voucher_campaign_name,
				className: J("max-w-[64px] sm:max-w-[118px] min-w-[64px] max-h-fit aspect-square object-cover", i && "grayscale-[50%]")
			}), /* @__PURE__ */ H("div", {
				className: "w-full h-auto flex flex-col gap-2 p-1 pl-3 pb-0 border-l border-black/15",
				children: [
					/* @__PURE__ */ H("div", {
						className: "flex flex-row justify-between",
						children: [/* @__PURE__ */ V("h5", {
							className: J("text-base font-semibold", i ? "text-gray-500 dark:text-gray-400" : "text-gray-900 dark:text-white"),
							style: l ? { color: e.customTextColor } : void 0,
							children: e.voucher_campaign_name
						}), /* @__PURE__ */ V("span", {
							className: J("text-sm font-bold px-2 py-0.5 rounded whitespace-nowrap", "border border-black/5 dark:border-white/5", i ? "bg-gray-400/15 text-gray-500 dark:text-gray-400" : J(o.badgeColor, o.textColor)),
							style: l ? { color: e.customTextColor } : void 0,
							children: Xn(e.balance)
						})]
					}),
					/* @__PURE__ */ V("p", {
						className: J("flex-1 text-sm", i ? "text-gray-500 dark:text-gray-400" : "text-gray-700 dark:text-gray-300"),
						style: l ? { color: e.customTextColor } : void 0,
						children: e.event
					}),
					/* @__PURE__ */ V("p", {
						className: J("flex items-center gap-2 text-sm", i ? "text-gray-500 dark:text-gray-400" : "text-gray-700 dark:text-gray-300"),
						style: l ? { color: e.customTextColor } : void 0,
						children: a ? `Expiré depuis le ${Zn(e.end_date)}` : `Valide jusqu'au ${Zn(e.end_date)}`
					}),
					/* @__PURE__ */ V("button", {
						onClick: (e) => {
							e.stopPropagation(), r?.();
						},
						className: J("text-sm font-bold underline text-left", i ? "text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200" : J(o.textColor, "hover:text-primary dark:hover:text-primary")),
						style: l ? {
							color: e.customTextColor,
							pointerEvents: "all"
						} : { pointerEvents: "all" },
						children: "Voir mes dépenses sur ce bon"
					})
				]
			})]
		})
	});
};
or.displayName = "VoucherCard";
function sr({ vouchers: e, isSortable: t, showSortToggle: n = !0, title: r = "Mes bons", onSortChange: i, onSortToggle: a, onVoucherClick: o, isLoading: s = !1, isSortToggleLoading: c = !1, className: l }) {
	let [u, d] = q(null);
	W(() => {
		d(null);
	}, [e]);
	let [f, p] = q(t ?? !0), [m, h] = q(!1), g = u ?? e, _ = t ?? f, v = !i && !a, { activeVouchers: y, inactiveVouchers: b } = G(() => {
		let e = [], t = [];
		return g.forEach((n) => {
			$n(n) ? t.push(n) : e.push(n);
		}), {
			activeVouchers: e,
			inactiveVouchers: t
		};
	}, [g]), x = U(() => {
		v && (h(!0), setTimeout(() => {
			p((e) => !e), h(!1);
		}, 300)), a?.(!_);
	}, [
		v,
		_,
		a
	]), S = U((e) => {
		if (!e.destination || e.source.index === e.destination.index) return;
		let t = [...y], [n] = t.splice(e.source.index, 1);
		t.splice(e.destination.index, 0, n);
		let r = [...t, ...b].map((e, t) => ({
			...e,
			priority: t + 1
		}));
		d(r), i?.(r);
	}, [
		y,
		b,
		i
	]), C = U((e) => {
		if (e === 0) return;
		let t = [...y];
		[t[e - 1], t[e]] = [t[e], t[e - 1]];
		let n = [...t, ...b].map((e, t) => ({
			...e,
			priority: t + 1
		}));
		d(n), i?.(n);
	}, [
		y,
		b,
		i
	]), w = U((e) => {
		if (e === y.length - 1) return;
		let t = [...y];
		[t[e], t[e + 1]] = [t[e + 1], t[e]];
		let n = [...t, ...b].map((e, t) => ({
			...e,
			priority: t + 1
		}));
		d(n), i?.(n);
	}, [
		y,
		b,
		i
	]);
	return s ? /* @__PURE__ */ H(X, {
		className: l,
		children: [
			/* @__PURE__ */ V("h2", {
				className: "text-base font-bold text-gray-900 dark:text-white mb-4",
				children: r
			}),
			/* @__PURE__ */ V(rr, {}),
			/* @__PURE__ */ H("div", {
				className: "mt-4 opacity-80 space-y-3",
				"data-testid": "voucher-list-loading",
				children: [
					/* @__PURE__ */ V(nr, {}),
					/* @__PURE__ */ V(nr, {}),
					/* @__PURE__ */ V(nr, {})
				]
			})
		]
	}) : g.length === 0 ? /* @__PURE__ */ H(X, {
		className: l,
		children: [/* @__PURE__ */ V("h2", {
			className: "text-base font-bold text-gray-900 dark:text-white mb-4",
			children: r
		}), /* @__PURE__ */ V("p", {
			className: "text-gray-500 dark:text-gray-400",
			"data-testid": "voucher-list-empty",
			children: "Aucun bon à dépenser pour le moment"
		})]
	}) : /* @__PURE__ */ H(X, {
		className: l,
		children: [
			/* @__PURE__ */ V("h2", {
				className: "text-base font-bold text-gray-900 dark:text-white mb-4",
				children: r
			}),
			n && /* @__PURE__ */ H("div", {
				className: "mb-4",
				children: [/* @__PURE__ */ V(tr, {
					id: "sortable-toggle",
					checked: !_,
					onChange: x,
					disabled: m || c,
					isLoading: c,
					label: "Affectation automatique"
				}), /* @__PURE__ */ V("p", {
					className: "text-xs text-gray-500 dark:text-gray-400 mt-2",
					children: _ ? "Glissez ou utilisez les flèches pour définir manuellement l’ordre de priorité de vos achats. Les bons en haut seront dépensés en premier." : "Le bon expirant le plus tôt avec du solde disponible sera utilisé en priorité lors de vos achats."
				})]
			}),
			/* @__PURE__ */ H("div", {
				className: J("mt-4 pb-2", !_ && "opacity-80"),
				children: [
					y.length > 0 && /* @__PURE__ */ V(Wt, {
						onDragEnd: S,
						children: /* @__PURE__ */ V(Kt, {
							droppableId: "vouchers",
							children: (e) => /* @__PURE__ */ H("div", {
								...e.droppableProps,
								ref: e.innerRef,
								className: "space-y-3",
								"data-testid": "voucher-list",
								children: [y.map((e, t) => /* @__PURE__ */ V(Gt, {
									draggableId: e.id.toString(),
									index: t,
									isDragDisabled: !_,
									children: (n, r) => {
										let i = /* @__PURE__ */ H("div", {
											ref: n.innerRef,
											...n.draggableProps,
											"data-testid": `voucher-item-${e.id}`,
											className: J("flex items-stretch", r.isDragging && "z-[9999]"),
											children: [/* @__PURE__ */ V(ar, {
												index: t,
												totalCount: y.length,
												onMoveUp: () => C(t),
												onMoveDown: () => w(t),
												isDraggable: _,
												dragHandleProps: n.dragHandleProps
											}), /* @__PURE__ */ V("div", {
												className: "flex-1",
												children: /* @__PURE__ */ V(or, {
													voucher: e,
													isDragging: r.isDragging,
													isDraggable: _,
													onVoucherClick: () => o?.(e)
												})
											})]
										});
										return r.isDragging && typeof document < "u" ? Ut(i, document.body) : i;
									}
								}, e.id)), e.placeholder]
							})
						})
					}),
					b.length > 0 && /* @__PURE__ */ V(ir, {}),
					b.length > 0 && /* @__PURE__ */ V("div", {
						className: "space-y-3",
						"data-testid": "inactive-voucher-list",
						children: b.map((e) => /* @__PURE__ */ V("div", {
							"data-testid": `voucher-item-${e.id}`,
							children: /* @__PURE__ */ V(or, {
								voucher: e,
								isDragging: !1,
								isDraggable: !1,
								onVoucherClick: () => o?.(e)
							})
						}, e.id))
					})
				]
			})
		]
	});
}
sr.displayName = "VouchersWidget";
//#endregion
//#region src/components/widgets/PlaceholderWidget.tsx
var cr = ({ contentType: e, showIcon: t = !0, backgroundColor: n, title: r, subtitle: i, className: a, isPreview: o = !1, isLoading: s = !1 }) => {
	if (s) return /* @__PURE__ */ V(Z, {
		rows: 2,
		className: a
	});
	let c = r || "Widget";
	return /* @__PURE__ */ V(X, {
		backgroundColor: n,
		className: J("flex flex-col items-center justify-center min-h-[120px]", a),
		children: /* @__PURE__ */ H("div", {
			className: "flex flex-col items-center justify-center text-center gap-3",
			children: [
				t && /* @__PURE__ */ V("div", {
					className: "w-12 h-12 rounded-full bg-gray-100 dark:bg-gray-700 flex items-center justify-center",
					children: /* @__PURE__ */ V(Ce, { className: "w-6 h-6 text-gray-400 dark:text-gray-500" })
				}),
				/* @__PURE__ */ H("div", {
					className: "space-y-1",
					children: [
						/* @__PURE__ */ V("p", {
							className: "text-sm font-medium text-gray-700 dark:text-gray-300",
							children: c
						}),
						i && /* @__PURE__ */ V("p", {
							className: "text-xs text-gray-500 dark:text-gray-400",
							children: i
						}),
						/* @__PURE__ */ V("p", {
							className: "text-xs text-gray-400 dark:text-gray-500",
							children: e
						})
					]
				}),
				o && /* @__PURE__ */ V("div", {
					className: "mt-2 px-3 py-1 rounded-full bg-blue-50 dark:bg-blue-900/20",
					children: /* @__PURE__ */ V("p", {
						className: "text-xs text-blue-600 dark:text-blue-400 font-medium",
						children: "Aperçu"
					})
				})
			]
		})
	});
}, lr = ({ metric: e, onClick: t }) => {
	let n = e.icon ? typeof e.icon == "string" ? an[e.icon] : e.icon : null;
	return /* @__PURE__ */ H("div", {
		className: J("flex items-center gap-2.5 rounded-lg bg-teal-200/60 dark:bg-teal-800/30 px-3 py-2.5 transition-colors hover:bg-teal-200 dark:hover:bg-teal-800/50", t && "cursor-pointer"),
		onClick: () => t?.(e),
		role: t ? "button" : void 0,
		tabIndex: t ? 0 : void 0,
		onKeyDown: t ? (n) => {
			(n.key === "Enter" || n.key === " ") && (n.preventDefault(), t(e));
		} : void 0,
		children: [n && /* @__PURE__ */ V("div", {
			className: "w-8 h-8 xl:w-9 xl:h-9 rounded-lg flex items-center justify-center flex-shrink-0",
			style: { backgroundColor: e.color ? `${e.color}20` : "rgba(20, 184, 166, 0.2)" },
			children: /* @__PURE__ */ V(n, {
				size: 16,
				className: "xl:w-5 xl:h-5",
				style: { color: e.color || "#14B8A6" }
			})
		}), /* @__PURE__ */ H("div", {
			className: "flex-1 min-w-0",
			children: [/* @__PURE__ */ V("p", {
				className: "text-sm xl:text-base font-bold text-teal-700 dark:text-teal-200 truncate",
				children: e.value
			}), /* @__PURE__ */ V("p", {
				className: "text-[10px] xl:text-xs text-teal-600/70 dark:text-teal-300/70 truncate",
				children: e.label
			})]
		})]
	});
}, ur = ({ metrics: e, customMetrics: t, layout: n = "grid", title: r = "Statistiques", className: i, isLoading: a = !1, onMetricClick: o, onWidgetClick: s }) => {
	if (a) return /* @__PURE__ */ V(Z, {
		rows: 3,
		className: i
	});
	let c = [
		{
			label: "Bons Actifs",
			value: e.activeVouchers,
			icon: "Gift",
			color: "#10B981"
		},
		{
			label: "Utilisation",
			value: `${e.usagePercent}%`,
			icon: "TrendingUp",
			color: "#3B82F6"
		},
		{
			label: "Sondages",
			value: e.activePolls,
			icon: "Vote",
			color: "#8B5CF6"
		},
		{
			label: "Participation",
			value: `${e.participation}%`,
			icon: "Users",
			color: "#F59E0B"
		}
	], l = t || c, u = () => {
		s && s();
	};
	return /* @__PURE__ */ V("div", {
		className: J("h-full w-full bg-teal-100 dark:bg-teal-900 rounded-lg p-3 sm:p-3.5 md:p-4 lg:p-4 xl:p-6", s && "cursor-pointer", i),
		onClick: u,
		role: s ? "button" : void 0,
		tabIndex: s ? 0 : void 0,
		onKeyDown: s ? (e) => {
			(e.key === "Enter" || e.key === " ") && (e.preventDefault(), u());
		} : void 0,
		children: /* @__PURE__ */ H("div", {
			className: "flex h-full flex-col",
			children: [/* @__PURE__ */ H("div", {
				className: "flex items-center gap-1.5 xl:gap-2 mb-3 xl:mb-4",
				children: [/* @__PURE__ */ V("div", {
					className: "rounded-lg bg-teal-200 dark:bg-teal-800 p-1.5 xl:p-2",
					children: /* @__PURE__ */ V(Ct, {
						size: 16,
						className: "xl:w-5 xl:h-5 text-teal-600 dark:text-teal-400",
						"aria-hidden": "true"
					})
				}), /* @__PURE__ */ V("span", {
					className: "text-xs xl:text-sm font-semibold text-teal-600 dark:text-teal-300",
					children: r
				})]
			}), /* @__PURE__ */ V("div", {
				className: J("flex-1 overflow-y-auto pr-1", n === "grid" ? "grid grid-cols-2 gap-2" : "flex flex-col gap-2"),
				style: {
					scrollbarWidth: "thin",
					scrollbarColor: "rgba(20, 184, 166, 0.4) transparent"
				},
				children: l.map((e) => /* @__PURE__ */ V("div", {
					onClick: (t) => {
						o && (t.stopPropagation(), o(e));
					},
					children: /* @__PURE__ */ V(lr, {
						metric: e,
						onClick: o
					})
				}, e.label))
			})]
		})
	});
}, dr = ({ reactions: e, maxVisible: t = 3, onReactionClick: n }) => {
	let r = [...e].filter((e) => e.count > 0).sort((e, t) => t.count - e.count), i = r.slice(0, t), a = r.length - t;
	return i.length === 0 ? null : /* @__PURE__ */ H("div", {
		className: "flex flex-wrap items-center gap-1 p-2",
		children: [i.map((e) => /* @__PURE__ */ H("button", {
			type: "button",
			onClick: n ? () => n(e.emoji) : void 0,
			className: `flex items-center gap-0.5 px-1.5 h-7 rounded-full text-xs text-gray-900
                     bg-yellow-200 border border-yellow-300 hover:bg-yellow-300
                     transition-colors duration-200
                     ${n ? "cursor-pointer" : "cursor-default"}`,
			title: e.actors.join(", "),
			disabled: !n,
			children: [/* @__PURE__ */ V("span", {
				className: "text-sm",
				children: e.emoji
			}), /* @__PURE__ */ V("span", {
				className: "font-medium text-xs",
				children: e.count
			})]
		}, e.emoji)), a > 0 && /* @__PURE__ */ H("span", {
			className: "text-xs text-gray-500 px-1",
			children: ["+", a]
		})]
	});
}, fr = zt(null), pr = () => Vt(fr), mr = " · ", hr = "pinned-note-table-row", gr = (e) => e.tagName === "TD" || e.tagName === "TH", _r = (e) => (e.textContent ?? "").trim() !== "" || e.querySelector("img") !== null, vr = (e) => {
	let t = e.createElement("div");
	return t.className = hr, t;
}, yr = (e, t) => {
	let n = Array.from(t.children).filter((e) => e.tagName === "P");
	n.forEach((t, r) => {
		let i = Array.from(t.childNodes);
		r < n.length - 1 && i.push(e.createElement("br")), t.replaceWith(...i);
	});
}, br = (e, t) => {
	let n = vr(e);
	return t.forEach((t, r) => {
		r > 0 && n.append(e.createTextNode(mr));
		let i = e.createElement("span");
		i.append(...Array.from(t.childNodes)), yr(e, i), n.append(i);
	}), n;
}, xr = (e, t) => {
	let n = t.querySelector(":scope > figcaption");
	if (n) {
		let t = vr(e);
		t.append(...Array.from(n.childNodes)), n.replaceWith(t);
	}
	t.replaceWith(...Array.from(t.childNodes));
}, Sr = (e, t) => {
	let n = e.createDocumentFragment(), r = t.querySelector(":scope > caption");
	if (r && _r(r)) {
		let t = vr(e);
		t.append(...Array.from(r.childNodes)), n.append(t);
	}
	Array.from(t.rows).forEach((t) => {
		let r = Array.from(t.children).filter(gr).filter(_r);
		r.length > 0 && n.append(br(e, r));
	});
	let i = t.parentElement;
	t.replaceWith(n), i?.tagName === "FIGURE" && i.classList.contains("table") && xr(e, i);
}, Cr = (e) => {
	if (!e) return "";
	if (typeof window > "u") return e;
	let t = new DOMParser().parseFromString(e, "text/html"), n = Array.from(t.querySelectorAll("table"));
	return n.length === 0 ? e : (n.reverse().forEach((e) => Sr(t, e)), t.body.innerHTML);
}, wr = /* @__PURE__ */ "p.div.span.br.hr.wbr.strong.em.b.i.u.s.sub.sup.small.big.del.ins.mark.h1.h2.h3.h4.h5.h6.ul.ol.li.dl.dt.dd.table.caption.thead.tbody.tfoot.tr.th.td.colgroup.col.a.img.figure.figcaption.pre.code.blockquote.cite.q.abbr.acronym.dfn.kbd.samp.var.address.time".split("."), Tr = /* @__PURE__ */ "class.id.title.lang.dir.style.role.href.target.rel.download.hreflang.src.alt.width.height.loading.decoding.border.cellpadding.cellspacing.summary.align.valign.colspan.rowspan.scope.headers.type.start.reversed.value.cite.datetime.abbr.name.data-signedid.aria-label.aria-labelledby.aria-describedby.aria-hidden".split("."), Er = [
	"script",
	"object",
	"embed",
	"form",
	"input",
	"button",
	"iframe",
	"video",
	"audio"
], Dr = (e) => typeof window > "u" ? e : Yt.sanitize(e, {
	ALLOWED_TAGS: wr,
	ALLOWED_ATTR: Tr,
	FORBID_TAGS: Er,
	ALLOW_DATA_ATTR: !1,
	KEEP_CONTENT: !0
}), Or = ({ htmlContent: e, className: t, textColor: n, skipSanitization: r = !1, children: i }) => {
	let a = Cr(r ? e : Dr(e)), o = n ? { color: n } : void 0;
	return /* @__PURE__ */ H("div", {
		className: J("pinned-note-content", t),
		style: o,
		children: [/* @__PURE__ */ V("div", { dangerouslySetInnerHTML: { __html: a } }), i]
	});
}, kr = /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6})$/, Ar = (e) => kr.test(e), jr = (e) => {
	let t = e.replace("#", "");
	return t.length === 3 ? {
		r: parseInt(t[0] + t[0], 16),
		g: parseInt(t[1] + t[1], 16),
		b: parseInt(t[2] + t[2], 16)
	} : t.length === 6 ? {
		r: parseInt(t.substring(0, 2), 16),
		g: parseInt(t.substring(2, 4), 16),
		b: parseInt(t.substring(4, 6), 16)
	} : null;
}, Mr = (e) => {
	let t = e / 255;
	return t <= .03928 ? t / 12.92 : ((t + .055) / 1.055) ** 2.4;
}, Nr = ({ r: e, g: t, b: n }) => .2126 * Mr(e) + .7152 * Mr(t) + .0722 * Mr(n), Pr = 1, Fr = 0, Ir = .05, Lr = (e, t) => (e + Ir) / (t + Ir), Rr = (e) => {
	let t = jr(e);
	if (!t) return "#000000";
	let n = Nr(t);
	return Lr(n, Fr) >= Lr(Pr, n) ? "#000000" : "#ffffff";
}, zr = ({ r: e, g: t, b: n }) => {
	let r = e / 255, i = t / 255, a = n / 255, o = Math.max(r, i, a), s = Math.min(r, i, a), c = o - s, l = 0, u = 0, d = (o + s) / 2;
	if (c !== 0) switch (u = d > .5 ? c / (2 - o - s) : c / (o + s), o) {
		case r:
			l = ((i - a) / c + (i < a ? 6 : 0)) / 6;
			break;
		case i:
			l = ((a - r) / c + 2) / 6;
			break;
		case a: l = ((r - i) / c + 4) / 6;
	}
	return {
		h: l * 360,
		s: u * 100,
		l: d * 100
	};
}, Br = ({ h: e, s: t, l: n }) => {
	let r = e / 360, i = t / 100, a = n / 100, o = (e, t, n) => (n < 0 && (n += 1), n > 1 && --n, n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e);
	if (i === 0) {
		let e = Math.round(a * 255);
		return {
			r: e,
			g: e,
			b: e
		};
	}
	let s = a < .5 ? a * (1 + i) : a + i - a * i, c = 2 * a - s;
	return {
		r: Math.round(o(c, s, r + 1 / 3) * 255),
		g: Math.round(o(c, s, r) * 255),
		b: Math.round(o(c, s, r - 1 / 3) * 255)
	};
}, Vr = (e) => {
	let t = (e) => {
		let t = Math.max(0, Math.min(255, Math.round(e))).toString(16);
		return t.length === 1 ? "0" + t : t;
	};
	return "#" + t(e.r) + t(e.g) + t(e.b);
}, Hr = (e, t = .1) => {
	if (!Ar(e)) return e;
	let n = jr(e);
	if (!n) return e;
	let r = zr(n);
	return r.l = Math.max(0, r.l - t * 100), `linear-gradient(135deg, ${e} 0%, ${Vr(Br(r))} 100%)`;
}, Ur = {
	yellow: "#fef3c7",
	blue: "#dbeafe",
	green: "#dcfce7",
	pink: "#fce7f3",
	purple: "#f3e8ff",
	orange: "#fed7aa"
}, Wr = (e) => e ? e.startsWith("#") ? e : e in Ur ? Ur[e] : Ur.yellow : Ur.yellow, Gr = (e) => {
	if (!e) return null;
	let t = typeof e == "string" ? new Date(e) : e;
	return Number.isNaN(t.getTime()) ? null : t.toLocaleDateString("fr-FR", {
		day: "2-digit",
		month: "2-digit",
		hour: "2-digit",
		minute: "2-digit"
	});
}, Kr = Bt(({ note: e, showDate: t = !0, actions: n, footerLeft: r, footerRight: i, dragHandle: a, contentFooter: o, contentOverride: s, expirationBadge: c, onClick: l, isOptimistic: u = !1, className: d, style: f }, p) => {
	let m = K(null);
	Ht(p, () => m.current);
	let h = pr(), g = Wr(e.color), _ = Hr(g, .1), v = Rr(g), y = t ? Gr(e.createdAt) : null, b = !!l && !u, x = e.layoutId ?? e.id;
	W(() => {
		if (!h || !x) return;
		let e = m.current;
		if (!e) return;
		let t = null, n = () => {
			let t = Math.ceil(e.getBoundingClientRect().height), n = Math.ceil(e.scrollHeight), r = Math.max(t, n) + h.verticalPadding;
			r > 0 && h.reportHeight(x, r);
		}, r = () => {
			t !== null && cancelAnimationFrame(t), t = requestAnimationFrame(() => {
				t = null, n();
			});
		};
		r();
		let i = new ResizeObserver(r);
		i.observe(e);
		let a = Array.from(e.querySelectorAll("img")), o = () => r();
		return a.forEach((e) => {
			e.addEventListener("load", o), e.addEventListener("error", o);
		}), () => {
			i.disconnect(), a.forEach((e) => {
				e.removeEventListener("load", o), e.removeEventListener("error", o);
			}), t !== null && cancelAnimationFrame(t);
		};
	}, [
		h,
		x,
		e.htmlContent,
		e.title
	]);
	let S = b ? (e) => {
		(e.key === "Enter" || e.key === " ") && (e.preventDefault(), l?.());
	} : void 0;
	return /* @__PURE__ */ H("div", {
		ref: m,
		className: J("pinned-note-card", "flex flex-col h-full w-full overflow-hidden rounded-sm", "border border-black/5 shadow-md hover:shadow-2xl", "transition-all duration-300 relative", b && "cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-300", u && "opacity-60 pointer-events-none", d),
		style: {
			background: _,
			color: v,
			transition: "box-shadow 0.3s ease, opacity 0.3s ease",
			...f
		},
		onClick: b ? l : void 0,
		onKeyDown: S,
		role: b ? "button" : void 0,
		tabIndex: b ? 0 : void 0,
		children: [
			/* @__PURE__ */ H("div", {
				className: "p-4 pb-2",
				children: [
					/* @__PURE__ */ H("div", {
						className: "flex items-start justify-between gap-2",
						children: [/* @__PURE__ */ V("h4", {
							className: "text-sm font-medium leading-snug flex-[1_1_auto] min-w-[120px] break-words whitespace-normal",
							children: e.title
						}), n && /* @__PURE__ */ V("div", {
							className: "shrink-0",
							children: n
						})]
					}),
					y && /* @__PURE__ */ H("div", {
						className: "text-xs opacity-60 mt-1",
						children: ["Créée le ", y]
					}),
					c
				]
			}),
			/* @__PURE__ */ H("div", {
				className: "px-4 pt-0 pb-2 flex-1 flex flex-col min-h-0",
				children: [s ?? /* @__PURE__ */ V(Or, {
					htmlContent: e.htmlContent,
					textColor: v,
					children: o
				}), s && o]
			}),
			(r || i || a) && /* @__PURE__ */ V("div", {
				className: "mt-2 px-4 pb-3 flex flex-wrap items-center justify-between gap-2",
				children: /* @__PURE__ */ H("div", {
					className: "flex items-end gap-0 w-full",
					children: [
						/* @__PURE__ */ V("div", {
							className: "flex-1 min-w-0",
							children: r
						}),
						i && /* @__PURE__ */ V("div", {
							className: "shrink-0",
							children: i
						}),
						a && /* @__PURE__ */ V("div", {
							className: "shrink-0",
							children: a
						})
					]
				})
			})
		]
	});
});
Kr.displayName = "PinnedNoteCard";
//#endregion
//#region src/components/widgets/pinned-notes/pinned-notes.constants.ts
var qr = 12, Jr = {
	w: 2,
	h: 2
}, Yr = {
	w: 3,
	h: 3
}, Xr = 32, Zr = 16, Qr = 12, $r = [16, 12], ei = "optimistic-", ti = {
	lg: 1200,
	md: 996,
	sm: 768,
	xs: 480,
	xxs: 0
}, ni = {
	lg: 12,
	md: 10,
	sm: 6,
	xs: 4,
	xxs: 2
}, ri = () => `${ei}${Date.now()}`, ii = (e) => !!e && e.startsWith("optimistic-"), ai = (e) => Array.isArray(e.attachments) && e.attachments.length > 0, oi = (e) => {
	if (!e) return "none";
	let t = /* @__PURE__ */ new Date();
	t.setHours(0, 0, 0, 0);
	let n = new Date(e);
	if (n.setHours(0, 0, 0, 0), n < t) return "expired";
	let r = new Date(t);
	return r.setDate(r.getDate() + 7), n <= r ? "expiring-soon" : "active";
}, si = (e) => new Date(e).toLocaleDateString("fr-FR", {
	day: "2-digit",
	month: "2-digit",
	year: "numeric"
}), ci = (e, t = 32, n = 12) => {
	let r = t + n;
	return Math.max(1, Math.ceil((e + n) / r));
}, li = (e, t) => !t || t < 24 ? !1 : e === void 0 || Math.abs(e - t) >= 16, ui = (e, t) => e.i !== t.i && e.x < t.x + t.w && e.x + e.w > t.x && e.y < t.y + t.h && e.y + e.h > t.y, di = (e) => {
	let t = [...e].sort((e, t) => e.y === t.y ? e.x - t.x : e.y - t.y), n = [];
	for (let e of t) {
		let t = { ...e }, r = 0;
		for (; t.y = r, n.some((e) => ui(t, e));) r += 1;
		n.push({
			...t,
			minH: Math.max(t.minH ?? 0, Jr.h)
		});
	}
	return n;
}, fi = (e, t) => Math.max(e.h, e.minH ?? 0, t ?? 0), pi = (e, t) => di(e.map((e) => ({
	...e,
	h: fi(e, t[e.i])
}))), mi = (e) => {
	let { width: t, height: n } = e;
	return t >= 4 ? 3 : t >= 3 && n >= 3 || t >= 3 ? 2 : 1;
}, hi = (e) => mi(e) === 1, gi = Jt(qt), _i = "\n.pinned-notes-grid .react-grid-item {\n  transition: none !important;\n}\n.pinned-notes-grid .react-grid-item.react-draggable-dragging {\n  transition: transform 200ms ease !important;\n}\n.pinned-notes-grid .react-grid-item.react-grid-placeholder {\n  transition: all 100ms ease !important;\n}\n.pinned-notes-grid .react-grid-item.static {\n  cursor: default !important;\n}\n.pinned-notes-grid .react-grid-item.static .react-resizable-handle {\n  display: none !important;\n}\n.pinned-notes-grid.pinned-notes-grid--frozen .react-grid-layout {\n  pointer-events: none;\n  opacity: 0.7;\n}\n.pinned-notes-grid.pinned-notes-grid--frozen .react-grid-item {\n  pointer-events: none;\n}\n.pinned-notes-grid.pinned-notes-grid--frozen .react-grid-item.react-draggable-dragging {\n  opacity: 0;\n}\n", vi = ({ notes: e, renderCard: t, onLayoutChange: n, isDraggable: r = !1, isResizable: i = !1, isFrozen: a = !1, cols: o = ni, rowHeight: s = 32, deferRenderUntilMeasured: c = !1, className: l }) => {
	let u = K(!1), d = K(null), f = K(!1), p = K(a), [m, h] = q({}), [g, _] = q(/* @__PURE__ */ new Set()), [v, y] = q(!c), b = K(/* @__PURE__ */ new Set()), x = G(() => e.filter((e) => e.position?.i && e.id), [e]), S = G(() => new Set(x.map((e) => e.position.i)), [x]), C = U((e, t) => {
		h((n) => li(n[e], t) ? {
			...n,
			[e]: t
		} : n), _((t) => {
			if (t.has(e)) return t;
			let n = new Set(t);
			return n.add(e), n;
		});
	}, []);
	W(() => {
		if (!c || v || g.size === 0) return;
		if (Array.from(S).every((e) => g.has(e))) {
			y(!0);
			return;
		}
		let e = setTimeout(() => y(!0), 1e3);
		return () => clearTimeout(e);
	}, [
		g,
		S,
		v,
		c
	]), W(() => {
		if (!c) return;
		let e = new Set(x.map((e) => e.position.i)), t = b.current;
		t.size === 0 ? b.current = e : (e.size !== t.size || Array.from(e).some((e) => !t.has(e)) || Array.from(t).some((t) => !e.has(t))) && (_(/* @__PURE__ */ new Set()), y(!1), b.current = e);
	}, [x, c]), W(() => {
		if (p.current && !a) {
			u.current = !1, f.current = !0;
			let e = setTimeout(() => {
				f.current = !1;
			}, 100);
			return () => clearTimeout(e);
		}
		p.current = a;
	}, [a]);
	let w = U(() => {
		d.current && clearTimeout(d.current), d.current = setTimeout(() => {
			u.current = !1;
		}, 120);
	}, []), T = U(() => {
		u.current = !0;
	}, []), E = U(() => {
		w();
	}, [w]), D = U(() => {
		u.current = !0;
	}, []), O = U((e, t, r) => {
		let i = r ? m[String(r.i)] : void 0;
		if (r && i) {
			let t = Math.max(Jr.h, ci(i, s, 12));
			if (r.h < t) {
				let i = e.map((e) => e.i === r.i ? {
					...e,
					h: t,
					minH: t
				} : e);
				n?.(i, !0);
			}
		}
		w();
	}, [
		m,
		s,
		n,
		w
	]), k = U((e) => {
		a || f.current || n?.([...e], u.current);
	}, [a, n]), ee = G(() => x.map((e) => {
		let t = e.position.i, n = e.position.w || 3, r = e.position.h && e.position.h > 0 ? e.position.h : 3, i = m[t], a = i === void 0 ? r : ci(i, s, 12), o = Math.max(r, a), c = Jr.h;
		return {
			i: t,
			x: e.position.x || 0,
			y: e.position.y || 0,
			w: n,
			h: o,
			minW: Jr.w,
			minH: c,
			static: ii(e.id)
		};
	}), [
		x,
		m,
		s
	]), A = G(() => {
		let e = pi(ee, {});
		return {
			lg: e,
			md: e,
			sm: e,
			xs: e,
			xxs: e
		};
	}, [ee]), j = G(() => ({
		reportHeight: C,
		rowHeight: s,
		verticalPadding: 0
	}), [C, s]);
	return /* @__PURE__ */ H("div", {
		className: J("pinned-notes-grid w-full", a && "pinned-notes-grid--frozen", l),
		children: [/* @__PURE__ */ V("style", { children: _i }), /* @__PURE__ */ V(fr.Provider, {
			value: j,
			children: /* @__PURE__ */ V(gi, {
				className: "layout",
				layouts: A,
				breakpoints: ti,
				cols: o,
				rowHeight: s,
				onLayoutChange: k,
				onDragStart: T,
				onDragStop: E,
				onResizeStart: D,
				onResizeStop: O,
				isDraggable: r && !a,
				isResizable: i && !a,
				resizeHandles: ["se"],
				margin: $r,
				containerPadding: [16, 16],
				draggableHandle: ".drag-handle",
				compactType: "vertical",
				preventCollision: !1,
				measureBeforeMount: !1,
				useCSSTransforms: !1,
				children: x.map((e) => /* @__PURE__ */ V("div", {
					style: {
						opacity: +!!v,
						transition: v ? "opacity 0.2s ease-in" : "none"
					},
					children: t(e)
				}, e.position.i))
			})
		})]
	});
}, yi = (e) => {
	if (!e) return "";
	if (typeof window > "u") return e;
	let t = new DOMParser().parseFromString(e, "text/html");
	return t.querySelectorAll("table").forEach((e) => {
		let t = Array.from(e.querySelectorAll("tr"));
		if (t.length === 0) return;
		let n = t.reduce((e, t) => {
			let n = Array.from(t.children).filter((e) => e.tagName === "TD" || e.tagName === "TH").reduce((e, t) => {
				let n = parseInt(t.getAttribute("colspan") ?? "1", 10);
				return e + (Number.isFinite(n) ? n : 1);
			}, 0);
			return Math.max(e, n);
		}, 0);
		n !== 0 && t.forEach((e) => {
			Array.from(e.children).filter((e) => e.tagName === "TD" || e.tagName === "TH").forEach((e) => {
				let t = parseInt(e.getAttribute("colspan") ?? "1", 10);
				Number.isFinite(t) && t > n && e.setAttribute("colspan", String(n));
			});
		});
	}), t.body.innerHTML;
}, bi = 2, xi = Jt(qt), Si = 12, Ci = 1, wi = 32, Ti = 16, Ei = 12, Di = [Ti, Ei], Oi = {
	lg: 768,
	sm: 0
}, ki = {
	lg: Si,
	sm: Ci
}, Ai = 2, ji = 4, Mi = (e) => e === "Infinity" ? 0 : e, Ni = (e) => {
	if (!e.position) return null;
	let t = e.position.i?.trim() || e.id;
	if (!t) return null;
	let n = Math.min(Si, Math.max(1, e.position.w || 1)), r = Si - n;
	return {
		i: t,
		x: Math.min(r, Math.max(0, e.position.x || 0)),
		y: Math.max(0, Mi(e.position.y)),
		w: n,
		h: Math.max(Ai, e.position.h || Ai)
	};
}, Pi = (e, t, n) => {
	let r = t + n;
	return Math.max(1, Math.ceil((e + n) / r));
}, Fi = (e, t) => e.i !== t.i && e.x < t.x + t.w && e.x + e.w > t.x && e.y < t.y + t.h && e.y + e.h > t.y, Ii = (e) => {
	let t = [...e].sort((e, t) => e.y === t.y ? e.x - t.x : e.y - t.y), n = [];
	for (let e of t) {
		let t = { ...e }, r = 0;
		for (; t.y = r, n.some((e) => Fi(t, e));) r += 1;
		n.push({
			...t,
			static: !0,
			minH: Math.max(t.minH ?? 0, Ai)
		});
	}
	return n;
}, Li = (e, t) => Math.max(e.h, e.minH ?? 0, t ?? 0), Ri = (e, t) => Ii(e.map((e) => ({
	...e,
	h: Li(e, t[e.i])
}))), zi = (e) => {
	if (!e) return null;
	let t = new Date(e);
	return Number.isNaN(t.getTime()) ? null : t.toLocaleDateString("fr-FR", {
		day: "2-digit",
		month: "2-digit",
		hour: "2-digit",
		minute: "2-digit"
	});
}, Bi = (e) => new Date(2026, 0, 16 + e, 9 + e, 15).toISOString(), Vi = (e) => e === "minimal" || e === "minimaliste" ? "minimaliste" : "classic", Hi = [
	{
		id: "preview-1",
		title: "A faire",
		content: "",
		color: "#fef3c7",
		previewCreatedAt: "2026-01-18T09:30:00.000Z",
		previewContent: /* @__PURE__ */ H("div", {
			className: "space-y-2",
			children: [
				/* @__PURE__ */ H("p", { children: [
					/* @__PURE__ */ V("span", {
						className: "font-semibold",
						children: "Priorite:"
					}),
					" ",
					/* @__PURE__ */ V("span", {
						className: "italic",
						children: "semaine en cours"
					})
				] }),
				/* @__PURE__ */ H("div", {
					className: "space-y-1",
					children: [
						/* @__PURE__ */ V("p", { children: "Valider les conges avant vendredi" }),
						/* @__PURE__ */ H("p", { children: [
							"Envoyer le recap RH avec un",
							" ",
							/* @__PURE__ */ V("span", {
								className: "font-semibold",
								children: "mini bilan"
							})
						] }),
						/* @__PURE__ */ V("p", { children: "Confirmer la presence au point hebdo" })
					]
				}),
				/* @__PURE__ */ V("p", {
					className: "text-blue-700 underline font-medium",
					children: "Voir le modele"
				})
			]
		})
	},
	{
		id: "preview-2",
		title: "Offres voyages",
		content: "",
		color: "#dbeafe",
		previewCreatedAt: "2026-01-20T14:05:00.000Z",
		previewContent: /* @__PURE__ */ H("div", {
			className: "space-y-2",
			children: [
				/* @__PURE__ */ H("p", { children: [
					"Destinations mises en avant:",
					" ",
					/* @__PURE__ */ V("span", {
						className: "font-semibold",
						children: "Grece"
					}),
					" et Italie"
				] }),
				/* @__PURE__ */ V("p", {
					className: "italic",
					children: "Offres limitees jusqu'a dimanche"
				}),
				/* @__PURE__ */ H("div", {
					className: "space-y-1",
					children: [/* @__PURE__ */ V("p", { children: "Athenes: sejour 4 jours" }), /* @__PURE__ */ V("p", { children: "Rome: city break tout compris" })]
				}),
				/* @__PURE__ */ V("p", {
					className: "text-blue-700 underline font-medium",
					children: "Lire la note"
				})
			]
		})
	},
	{
		id: "preview-3",
		title: "Equipe",
		content: "",
		color: "#dcfce7",
		previewCreatedAt: "2026-01-22T08:45:00.000Z",
		previewContent: /* @__PURE__ */ H("div", {
			className: "space-y-2",
			children: [
				/* @__PURE__ */ V("p", {
					className: "font-semibold",
					children: "Reunion jeudi 10h"
				}),
				/* @__PURE__ */ H("div", {
					className: "space-y-1",
					children: [
						/* @__PURE__ */ V("p", { children: "Salle Atlas (niveau 2)" }),
						/* @__PURE__ */ H("p", { children: [
							"Ordre du jour: ",
							/* @__PURE__ */ V("span", {
								className: "italic",
								children: "priorites T1"
							}),
							", budget, planning"
						] }),
						/* @__PURE__ */ V("p", { children: "Pense-bete: arriver 5 min en avance" })
					]
				}),
				/* @__PURE__ */ V("p", {
					className: "text-blue-700 underline font-medium",
					children: "Ouvrir le doc"
				})
			]
		})
	}
], Ui = ({ note: e, index: t, isMinimalVariant: n, isInteractive: r, onNoteClick: i, showReactions: a, maxVisibleReactions: o, onReactionClick: s, renderReactions: c, onMeasuredHeight: l }) => {
	let u = K(null), d = e.position?.i || e.id;
	zi(e.createdAt ?? e.previewCreatedAt ?? Bi(t));
	let f = a && !c && e.reactions && e.reactions.length > 0, p = a && !!c;
	return W(() => {
		if (!l) return;
		let e = u.current;
		if (!e) return;
		let t = null, n = () => {
			let t = Math.ceil(e.getBoundingClientRect().height), n = Math.ceil(e.scrollHeight), r = Math.max(t, n);
			r > 0 && l(d, r);
		}, r = () => {
			t !== null && cancelAnimationFrame(t), t = requestAnimationFrame(() => {
				t = null, n();
			});
		};
		r();
		let i = new ResizeObserver(() => {
			r();
		});
		i.observe(e);
		let a = Array.from(e.querySelectorAll("img")), o = () => r();
		return a.forEach((e) => {
			e.addEventListener("load", o), e.addEventListener("error", o);
		}), () => {
			i.disconnect(), a.forEach((e) => {
				e.removeEventListener("load", o), e.removeEventListener("error", o);
			}), t !== null && cancelAnimationFrame(t);
		};
	}, [
		d,
		e.content,
		e.htmlContent,
		e.title,
		l
	]), /* @__PURE__ */ H("button", {
		ref: u,
		type: "button",
		onClick: r ? () => i?.(e) : void 0,
		className: J("pinned-note-card", "relative flex h-full w-full min-h-[112px] flex-col overflow-hidden rounded-sm text-left", n ? "border border-gray-200 bg-white shadow-sm transition-colors duration-200" : "border border-black/5 shadow-md transition-all duration-300", r && n && "cursor-pointer hover:border-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-300", r && !n && "cursor-pointer hover:shadow-2xl focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-300", !r && n && "cursor-default", !r && !n && "cursor-default hover:shadow-2xl"),
		style: {
			background: n ? Wr(e.color) : Hr(Wr(e.color), .1),
			color: Rr(Wr(e.color))
		},
		children: [
			/* @__PURE__ */ H("div", {
				className: "mb-2 p-4 pb-2",
				children: [/* @__PURE__ */ V("h4", {
					className: "text-sm font-medium text-gray-900 whitespace-normal break-words",
					children: e.title
				}), !1]
			}),
			/* @__PURE__ */ V("div", {
				className: "mb-2 px-4 pt-0",
				children: e.previewContent ? /* @__PURE__ */ V("div", {
					className: "text-xs leading-relaxed",
					children: e.previewContent
				}) : e.htmlContent ? /* @__PURE__ */ V(Or, { htmlContent: e.htmlContent }) : /* @__PURE__ */ V("p", {
					className: "text-xs leading-relaxed whitespace-pre-line break-words",
					children: e.content
				})
			}),
			/* @__PURE__ */ H("div", {
				className: "mt-auto",
				children: [p && c?.({
					noteId: e.id,
					reactions: e.reactions ?? []
				}), f && /* @__PURE__ */ V(dr, {
					reactions: e.reactions,
					maxVisible: o,
					onReactionClick: s ? (t) => s(e.id, t) : void 0
				})]
			})
		]
	});
}, Wi = ({ notes: e, variant: t = "classic", maxNotes: n, gridColumns: r = 2, backgroundColor: i, icon: a = "FileText", title: o = "Notes Epinglees", subtitle: s, className: c, isPreview: l = !1, isLoading: u = !1, onNoteClick: d, boards: f, activeBoardId: p, onBoardChange: m, showReactions: h = !1, maxVisibleReactions: g = 3, onReactionClick: _, renderReactions: v }) => {
	let [y, b] = q({}), [x, S] = q(!1), [C, w] = q(!1), E = f?.map((e) => e.id).join("|");
	if (W(() => {
		S(!1);
	}, [E]), u) return /* @__PURE__ */ V(Z, {
		rows: 3,
		className: c
	});
	let D = Vi(t) === "minimaliste", O = f && f.length > 0, k = O ? p ?? f[0].id : void 0, ee = O ? (f.find((e) => e.id === k) ?? f[0]).notes : e, A = O && f.length > bi, j = A ? f.slice(bi) : [], M = j.length, te = A && j.some((e) => e.id === k), ne = (e) => {
		m?.(e), S(!1);
	}, re = (e) => J("px-2.5 py-1 text-xs font-medium rounded-full transition-colors cursor-pointer", e ? "bg-primary text-white" : "border border-primary text-primary hover:bg-primary hover:text-white dark:border-primary dark:text-primary dark:hover:bg-primary dark:hover:text-white"), ie = O && f.length > 1 ? /* @__PURE__ */ H("div", {
		className: "flex items-center gap-1.5 flex-wrap",
		children: [f.slice(0, bi).map((e) => /* @__PURE__ */ V("button", {
			type: "button",
			onClick: () => ne(e.id),
			className: re(e.id === k),
			children: e.label
		}, e.id)), A && /* @__PURE__ */ H("button", {
			type: "button",
			onClick: () => S(!x),
			className: J("inline-flex items-center gap-0.5", re(!!te && !x)),
			children: [
				"+",
				M,
				/* @__PURE__ */ V(T, { className: J("w-3 h-3 transition-transform", x && "rotate-180") })
			]
		})]
	}) : void 0, ae = A && x ? /* @__PURE__ */ V("div", {
		className: "flex items-center gap-1.5 flex-wrap mb-3",
		children: j.map((e) => /* @__PURE__ */ V("button", {
			type: "button",
			onClick: () => ne(e.id),
			className: re(e.id === k),
			children: e.label
		}, e.id))
	}) : null, oe = G(() => {
		let e = l ? Hi : ee;
		return n ? e.slice(0, n) : e;
	}, [
		l,
		ee,
		n
	]), se = !!d && !l, N = G(() => {
		if (l) return [];
		let e = [];
		for (let t of oe) {
			let n = Ni(t);
			if (!n) return [];
			e.push({
				...t,
				position: n
			});
		}
		return e.sort((e, t) => e.position.y === t.position.y ? e.position.x - t.position.x : e.position.y - t.position.y);
	}, [oe, l]), ce = N.length > 0, le = G(() => N.map((e) => e.position.i).join("|"), [N]);
	W(() => {
		b({}), w(!1);
	}, [le]);
	let ue = U((e, t) => {
		!Number.isFinite(t) || t <= 0 || b((n) => {
			let r = n[e];
			if (r !== void 0 && Math.abs(r - t) < ji) return n;
			let i = r === void 0 ? t : Math.max(r, t);
			return {
				...n,
				[e]: i
			};
		});
	}, []);
	W(() => {
		if (C || !ce) return;
		if (N.every((e) => e.position.i in y)) {
			w(!0);
			return;
		}
		let e = setTimeout(() => w(!0), 1e3);
		return () => clearTimeout(e);
	}, [
		y,
		N,
		ce,
		C
	]);
	let de = G(() => {
		let e = {};
		for (let [t, n] of Object.entries(y)) e[t] = Math.max(Ai, Pi(n, wi, Ei));
		return e;
	}, [y]), fe = G(() => {
		if (!ce) return {
			lg: [],
			sm: []
		};
		let e = N.map((e) => ({
			i: e.position.i,
			x: e.position.x,
			y: e.position.y,
			w: e.position.w,
			h: e.position.h,
			minH: Ai,
			static: !0
		})), t = N.map((e, t) => ({
			i: e.position.i,
			x: 0,
			y: t,
			w: Ci,
			h: e.position.h,
			minH: Ai,
			static: !0
		}));
		return {
			lg: Ri(e, de),
			sm: Ri(t, de)
		};
	}, [
		ce,
		N,
		de
	]);
	return oe.length === 0 ? /* @__PURE__ */ H(X, {
		backgroundColor: i,
		className: c,
		children: [
			/* @__PURE__ */ V(sn, {
				title: o,
				subtitle: s,
				icon: a,
				action: ie
			}),
			ae,
			/* @__PURE__ */ V(cn, {
				icon: "Pin",
				message: "Aucune note épinglée"
			})
		]
	}) : /* @__PURE__ */ H(X, {
		backgroundColor: i,
		className: J(c, "h-auto"),
		children: [
			/* @__PURE__ */ V(sn, {
				title: o,
				subtitle: s,
				icon: a,
				action: ie
			}),
			ae,
			ce ? /* @__PURE__ */ V(xi, {
				className: "relative",
				layouts: fe,
				breakpoints: Oi,
				cols: ki,
				rowHeight: wi,
				margin: Di,
				containerPadding: [0, 0],
				isDraggable: !1,
				isResizable: !1,
				compactType: null,
				preventCollision: !0,
				useCSSTransforms: !0,
				measureBeforeMount: !1,
				children: N.map((e, t) => /* @__PURE__ */ V("div", {
					className: "h-full w-full",
					style: {
						opacity: +!!C,
						transition: C ? "opacity 0.2s ease-in" : "none"
					},
					children: /* @__PURE__ */ V(Ui, {
						note: e,
						index: t,
						isMinimalVariant: D,
						isInteractive: se,
						onNoteClick: d,
						showReactions: h,
						maxVisibleReactions: g,
						onReactionClick: _,
						renderReactions: v,
						onMeasuredHeight: ue
					})
				}, e.position.i))
			}) : /* @__PURE__ */ V("div", {
				className: J("grid gap-3 grid-cols-1", r === 2 && "sm:grid-cols-2", r === 3 && "sm:grid-cols-2 md:grid-cols-3"),
				children: oe.map((e, t) => /* @__PURE__ */ V(Ui, {
					note: e,
					index: t,
					isMinimalVariant: D,
					isInteractive: se,
					onNoteClick: d,
					showReactions: h,
					maxVisibleReactions: g,
					onReactionClick: _,
					renderReactions: v
				}, e.id))
			})
		]
	});
}, Gi = "#0ea5e9", Ki = [
	"Lun",
	"Mar",
	"Mer",
	"Jeu",
	"Ven",
	"Sam",
	"Dim"
], qi = 42, Ji = "\n  .caw-item-hover:hover { background-color: var(--w-bg-hover, #bae6fd) !important; }\n  .caw-scroll {\n    scrollbar-width: thin;\n    scrollbar-color: var(--w-scrollbar, rgba(14, 165, 233, 0.4)) transparent;\n  }\n  .caw-scroll::-webkit-scrollbar { width: 6px; }\n  .caw-scroll::-webkit-scrollbar-track { background: transparent; }\n  .caw-scroll::-webkit-scrollbar-thumb {\n    background: var(--w-scrollbar, rgba(14, 165, 233, 0.4));\n    border-radius: 3px;\n  }\n  .caw-scroll::-webkit-scrollbar-thumb:hover {\n    background: var(--w-scrollbar-hover, rgba(14, 165, 233, 0.6));\n  }\n  .caw-viewall-hover:hover { color: var(--w-text-emphasis, #0369a1) !important; }\n", Yi = (e) => {
	if (e === "list" || e === "month_grid" || e === "week_grid") return e;
	if (typeof e == "string") {
		let t = e.trim().toLowerCase();
		if (t.includes("month")) return "month_grid";
		if (t.includes("week") || t.includes("semaine")) return "week_grid";
	}
	return "list";
}, Xi = (e) => {
	let t = new Date(e);
	return Number.isNaN(t.getTime()) ? null : t;
}, Zi = (e) => new Date(e.getFullYear(), e.getMonth(), e.getDate()), Qi = (e) => `${e.getFullYear()}-${`${e.getMonth() + 1}`.padStart(2, "0")}-${`${e.getDate()}`.padStart(2, "0")}`, $i = (e) => (e.getDay() + 6) % 7, ea = (e) => {
	let t = Zi(e), n = $i(t);
	return t.setDate(t.getDate() - n), t;
}, ta = (e) => {
	let t = ea(new Date(e.getFullYear(), e.getMonth(), 1));
	return Array.from({ length: qi }, (e, n) => {
		let r = new Date(t);
		return r.setDate(t.getDate() + n), r;
	});
}, na = (e, t) => {
	let n = ea(e), r = 7 * Math.max(1, t);
	return Array.from({ length: r }, (e, t) => {
		let r = new Date(n);
		return r.setDate(n.getDate() + t), r;
	});
}, ra = (e) => {
	let t = Xi(e.date);
	if (!t) return Infinity;
	if (!e.time) return t.getTime();
	let [n, r] = e.time.split(":").map((e) => Number(e));
	if (Number.isNaN(n) || Number.isNaN(r)) return t.getTime();
	let i = new Date(t);
	return i.setHours(n, r, 0, 0), i.getTime();
}, ia = (e) => [...e].sort((e, t) => ra(e) - ra(t)), aa = (e) => {
	let t = /* @__PURE__ */ new Map();
	return e.forEach((e) => {
		let n = Xi(e.date);
		if (!n) return;
		let r = Qi(n), i = t.get(r) ?? [];
		i.push(e), t.set(r, i);
	}), t;
}, oa = (e) => {
	let t = Xi(e);
	return t ? t.toLocaleDateString("fr-FR", {
		day: "2-digit",
		month: "short"
	}) : "";
}, sa = (e) => e.toLocaleDateString("fr-FR", {
	month: "long",
	year: "numeric"
}), ca = (e) => {
	let t = e[0], n = e[e.length - 1];
	return !t || !n ? "" : `Semaine du ${t.toLocaleDateString("fr-FR", {
		day: "2-digit",
		month: "short"
	})} au ${n.toLocaleDateString("fr-FR", {
		day: "2-digit",
		month: "short",
		year: "numeric"
	})}`;
}, la = ({ event: e, showTime: t, onClick: n }) => /* @__PURE__ */ H("div", {
	className: J("caw-item-hover flex items-center gap-3 rounded-lg dark:bg-sky-800/30 px-3 py-2.5 transition-colors dark:hover:bg-sky-800/50", n && "cursor-pointer"),
	style: { backgroundColor: "var(--w-bg-subtle, rgba(186,230,253,0.6))" },
	onClick: () => n?.(e),
	role: n ? "button" : void 0,
	tabIndex: n ? 0 : void 0,
	onKeyDown: n ? (t) => {
		(t.key === "Enter" || t.key === " ") && (t.preventDefault(), n(e));
	} : void 0,
	children: [/* @__PURE__ */ V("div", {
		className: "w-1 h-10 rounded-full flex-shrink-0",
		style: { backgroundColor: e.color || Gi }
	}), /* @__PURE__ */ H("div", {
		className: "flex-1 min-w-0",
		children: [/* @__PURE__ */ V("p", {
			className: "text-xs xl:text-sm font-medium dark:text-sky-200 truncate",
			style: { color: "var(--w-text-emphasis, #0369a1)" },
			children: e.title
		}), /* @__PURE__ */ H("div", {
			className: "flex items-center gap-2 text-[10px] xl:text-xs dark:text-sky-300/70 mt-0.5",
			style: { color: "var(--w-text-muted, rgba(2,132,199,0.7))" },
			children: [/* @__PURE__ */ V("span", {
				className: "font-semibold",
				children: oa(e.date)
			}), t && e.time && /* @__PURE__ */ H(B, { children: [/* @__PURE__ */ V("span", { children: "•" }), /* @__PURE__ */ H("div", {
				className: "flex items-center gap-1",
				children: [/* @__PURE__ */ V(M, { size: 10 }), /* @__PURE__ */ V("span", { children: e.time })]
			})] })]
		})]
	})]
}), ua = () => /* @__PURE__ */ V("div", {
	className: "grid grid-cols-7 gap-1",
	role: "rowgroup",
	children: Ki.map((e) => /* @__PURE__ */ V("div", {
		className: "rounded-md dark:bg-sky-800/50 px-2 py-1 text-center text-[10px] sm:text-xs font-semibold uppercase tracking-wide dark:text-sky-200",
		style: {
			backgroundColor: "var(--w-bg-subtle, rgba(186,230,253,0.6))",
			color: "var(--w-text-emphasis, #0369a1)"
		},
		children: e
	}, e))
}), da = ({ day: e, dayEvents: t, isToday: n, isOutsideMonth: r, onEventClick: i, dataTestId: a }) => {
	let o = t[0], s = Math.max(0, t.length - 1);
	return /* @__PURE__ */ H("div", {
		"data-testid": a,
		"data-outside-month": r ? "true" : "false",
		className: J("rounded-md border px-2 py-1.5 min-h-[74px] flex flex-col gap-1", r ? "dark:border-sky-800/40 dark:bg-sky-950/40 dark:text-sky-300/60" : "dark:border-sky-800/70 dark:bg-sky-900/40 dark:text-sky-200", n && "dark:border-sky-300 dark:bg-sky-700/30 ring-1 shadow-sm"),
		style: {
			borderColor: n ? "var(--w-accent, #0ea5e9)" : r ? "var(--w-bg-subtle, rgba(186,230,253,0.4))" : "var(--w-bg-emphasis, rgba(186,230,253,0.8))",
			backgroundColor: n ? "var(--w-bg, #e0f2fe)" : r ? "rgba(255,255,255,0.3)" : "rgba(255,255,255,0.7)",
			...n ? { ringColor: "var(--w-accent, rgba(14,165,233,0.7))" } : {}
		},
		children: [/* @__PURE__ */ H("div", {
			className: "flex items-center justify-between",
			children: [/* @__PURE__ */ V("span", {
				className: J("text-xs font-semibold", n && "inline-flex h-5 min-w-5 items-center justify-center rounded-full px-1 text-white dark:text-sky-900"),
				style: n ? {
					backgroundColor: "var(--w-text, #0284c7)",
					color: "white"
				} : { color: r ? "var(--w-text-muted, rgba(2,132,199,0.6))" : "var(--w-text-emphasis, #0369a1)" },
				children: e.getDate()
			}), s > 0 && /* @__PURE__ */ H("span", {
				className: "inline-flex items-center rounded-full px-1.5 py-0.5 text-[10px] font-semibold dark:bg-sky-700/60 dark:text-sky-100",
				style: {
					backgroundColor: "var(--w-bg-emphasis, #bae6fd)",
					color: "var(--w-text-emphasis, #0369a1)"
				},
				children: ["+", s]
			})]
		}), o ? i ? /* @__PURE__ */ H("button", {
			type: "button",
			className: "mt-0.5 flex items-center gap-1 text-left text-[10px] sm:text-xs leading-tight dark:text-sky-200 dark:hover:text-sky-100",
			style: { color: "var(--w-text-emphasis, #0369a1)" },
			onClick: () => i(o),
			"data-testid": `calendar-day-event-${o.id}`,
			children: [/* @__PURE__ */ V("span", {
				className: "h-1.5 w-1.5 rounded-full shrink-0",
				style: { backgroundColor: o.color || Gi }
			}), /* @__PURE__ */ V("span", {
				className: "truncate",
				children: o.title
			})]
		}) : /* @__PURE__ */ H("div", {
			className: "mt-0.5 flex items-center gap-1 text-[10px] sm:text-xs leading-tight dark:text-sky-200",
			style: { color: "var(--w-text-emphasis, #0369a1)" },
			children: [/* @__PURE__ */ V("span", {
				className: "h-1.5 w-1.5 rounded-full shrink-0",
				style: { backgroundColor: o.color || Gi }
			}), /* @__PURE__ */ V("span", {
				className: "truncate",
				children: o.title
			})]
		}) : null]
	});
}, fa = ({ variant: e, today: t, eventsByDay: n, onEventClick: r, numberOfWeeks: i = 1 }) => {
	let a = e === "month_grid", o = a ? ta(t) : na(t, i), s = a ? sa(t) : ca(o);
	return /* @__PURE__ */ H("div", {
		className: "flex-1 min-h-0 flex flex-col gap-2",
		children: [
			/* @__PURE__ */ V("p", {
				className: "text-[10px] sm:text-xs font-medium dark:text-sky-200/80",
				style: { color: "var(--w-text-muted, rgba(2,132,199,0.8))" },
				children: s
			}),
			/* @__PURE__ */ V(ua, {}),
			/* @__PURE__ */ V("div", {
				"data-testid": a ? "calendar-month-grid" : "calendar-week-grid",
				className: J("grid grid-cols-7 gap-1", a && "auto-rows-fr"),
				style: a ? void 0 : { gridTemplateRows: `repeat(${i}, minmax(0, 1fr))` },
				children: o.map((e) => {
					let i = Qi(e), o = n.get(i) ?? [], s = i === Qi(t), c = a && e.getMonth() !== t.getMonth();
					return /* @__PURE__ */ V(da, {
						day: e,
						dayEvents: o,
						isToday: s,
						isOutsideMonth: c,
						onEventClick: r,
						dataTestId: a ? "calendar-month-day-cell" : "calendar-week-day-cell"
					}, i);
				})
			})
		]
	});
}, pa = ({ events: e = [], variant: t = "list", numberOfWeeks: n = 1, maxEvents: r, showTime: i = !0, title: a = "Mes prochains evenements", isLoading: o = !1, className: s, onEventClick: c, onViewAll: l }) => {
	if (o) return /* @__PURE__ */ V(Z, {
		rows: 3,
		className: s
	});
	let u = Yi(t), d = ia(e), f = r ? d.slice(0, r) : d, p = d.length > 0, m = f.length > 0, h = Zi(/* @__PURE__ */ new Date()), g = aa(d), _ = u === "list", y = u === "month_grid";
	return /* @__PURE__ */ H("div", {
		className: J("h-full w-full dark:bg-sky-900 rounded-lg p-3 sm:p-3.5 md:p-4 lg:p-4 xl:p-6", s),
		style: { backgroundColor: "var(--w-bg, #e0f2fe)" },
		children: [/* @__PURE__ */ V("style", { children: Ji }), /* @__PURE__ */ H("div", {
			className: "flex h-full flex-col",
			children: [
				/* @__PURE__ */ H("div", {
					className: "flex items-center gap-1.5 xl:gap-2 mb-3 xl:mb-4",
					children: [/* @__PURE__ */ V("div", {
						className: "rounded-lg dark:bg-sky-800 p-1.5 xl:p-2",
						style: { backgroundColor: "var(--w-bg-emphasis, #bae6fd)" },
						children: /* @__PURE__ */ V(v, {
							size: 16,
							className: "xl:w-5 xl:h-5 dark:text-sky-400",
							style: { color: "var(--w-text, #0284c7)" },
							"aria-hidden": "true"
						})
					}), /* @__PURE__ */ V("span", {
						className: "text-xs xl:text-sm font-semibold dark:text-sky-300",
						style: { color: "var(--w-text, #0284c7)" },
						children: a
					})]
				}),
				_ ? m ? /* @__PURE__ */ V("div", {
					"data-testid": "calendar-list-view",
					className: "caw-scroll flex-1 overflow-y-auto space-y-2 pr-1",
					children: f.map((e) => /* @__PURE__ */ V(la, {
						event: e,
						showTime: i,
						onClick: c
					}, e.id))
				}) : /* @__PURE__ */ V("div", {
					className: "flex-1 flex items-center justify-center",
					"data-testid": "calendar-list-view",
					children: /* @__PURE__ */ V("p", {
						className: "text-xs xl:text-sm dark:text-sky-300/60",
						style: { color: "var(--w-text-muted, rgba(2,132,199,0.6))" },
						children: "Aucun evenement a venir"
					})
				}) : /* @__PURE__ */ V(fa, {
					variant: y ? "month_grid" : "week_grid",
					today: h,
					eventsByDay: g,
					onEventClick: c,
					numberOfWeeks: n
				}),
				!p && !_ && /* @__PURE__ */ V("p", {
					className: "mt-2 text-[10px] sm:text-xs dark:text-sky-300/60",
					style: { color: "var(--w-text-muted, rgba(2,132,199,0.6))" },
					children: "Aucun evenement sur cette periode"
				}),
				l && /* @__PURE__ */ H("button", {
					onClick: l,
					className: "caw-viewall-hover mt-3 pt-3 dark:border-sky-800 flex items-center justify-center gap-1 text-xs xl:text-sm dark:text-sky-400 font-medium dark:hover:text-sky-300 transition-colors",
					style: {
						borderTop: "1px solid var(--w-bg-emphasis, #bae6fd)",
						color: "var(--w-text, #0284c7)"
					},
					children: ["Voir tous mes evenements", /* @__PURE__ */ V(D, { size: 14 })]
				})
			]
		})]
	});
}, ma = "\n  .pw-container-hover:hover { background-color: var(--w-bg-subtle, rgba(254,215,170,0.6)) !important; }\n  .pw-item-hover:hover { background-color: var(--w-bg-hover, #fed7aa) !important; }\n  .pw-nav-hover:hover { background-color: var(--w-bg-hover, #fed7aa) !important; }\n  .pw-scroll {\n    scrollbar-width: thin;\n    scrollbar-color: var(--w-scrollbar, rgba(249, 115, 22, 0.4)) transparent;\n  }\n  .pw-scroll::-webkit-scrollbar { width: 6px; }\n  .pw-scroll::-webkit-scrollbar-track { background: transparent; }\n  .pw-scroll::-webkit-scrollbar-thumb {\n    background: var(--w-scrollbar, rgba(249, 115, 22, 0.4));\n    border-radius: 3px;\n  }\n  .pw-scroll::-webkit-scrollbar-thumb:hover {\n    background: var(--w-scrollbar-hover, rgba(249, 115, 22, 0.6));\n  }\n", ha = ({ poll: e }) => /* @__PURE__ */ H("div", {
	className: "pw-item-hover flex items-center gap-2 rounded-lg dark:bg-orange-800/30 px-3 py-2.5 transition-colors dark:hover:bg-orange-800/50",
	style: { backgroundColor: "var(--w-bg-subtle, rgba(254,215,170,0.6))" },
	children: [/* @__PURE__ */ V(z, {
		size: 16,
		className: "dark:text-orange-500 flex-shrink-0",
		style: { color: "var(--w-accent, #fb923c)" },
		"aria-hidden": "true"
	}), /* @__PURE__ */ H("div", {
		className: "flex-1 min-w-0",
		children: [/* @__PURE__ */ V("p", {
			className: "text-xs xl:text-sm font-medium dark:text-orange-200 truncate",
			style: { color: "var(--w-text-emphasis, #c2410c)" },
			children: e.title
		}), /* @__PURE__ */ H("div", {
			className: "flex items-center gap-1 mt-0.5",
			children: [/* @__PURE__ */ V(R, {
				size: 12,
				className: "dark:text-orange-300/60",
				style: { color: "var(--w-text-muted, rgba(234,88,12,0.6))" },
				"aria-hidden": "true"
			}), /* @__PURE__ */ H("span", {
				className: "text-[10px] xl:text-xs dark:text-orange-300/60",
				style: { color: "var(--w-text-muted, rgba(234,88,12,0.6))" },
				children: [
					e.participantCount,
					" ",
					"participant",
					e.participantCount > 1 ? "s" : ""
				]
			})]
		})]
	})]
}), ga = ({ title: e, displayedActiveCount: t, className: n, onWidgetClick: r }) => {
	let i = () => {
		r && r();
	};
	return /* @__PURE__ */ H("div", {
		className: J("h-full w-full dark:bg-orange-900 rounded-lg p-3 sm:p-3.5 md:p-4", r && "cursor-pointer pw-container-hover dark:hover:bg-orange-800/60 transition-colors", n),
		style: { backgroundColor: "var(--w-bg, #ffedd5)" },
		onClick: i,
		role: r ? "button" : void 0,
		tabIndex: r ? 0 : void 0,
		onKeyDown: r ? (e) => {
			(e.key === "Enter" || e.key === " ") && (e.preventDefault(), i());
		} : void 0,
		children: [/* @__PURE__ */ V("style", { children: ma }), /* @__PURE__ */ H("div", {
			className: "flex items-center justify-between h-full",
			children: [/* @__PURE__ */ H("div", {
				className: "flex items-center gap-2",
				children: [/* @__PURE__ */ V("div", {
					className: "rounded-lg dark:bg-orange-800 p-1.5",
					style: { backgroundColor: "var(--w-bg-emphasis, #fed7aa)" },
					children: /* @__PURE__ */ V(z, {
						size: 16,
						className: "dark:text-orange-400",
						style: { color: "var(--w-text, #ea580c)" },
						"aria-hidden": "true"
					})
				}), /* @__PURE__ */ V("span", {
					className: "text-xs xl:text-sm font-semibold dark:text-orange-300",
					style: { color: "var(--w-text, #ea580c)" },
					children: e
				})]
			}), /* @__PURE__ */ H("div", {
				className: "flex items-baseline gap-1.5 dark:bg-orange-800/40 px-3 py-1.5 rounded-full",
				style: { backgroundColor: "var(--w-bg-subtle, rgba(254,215,170,0.6))" },
				children: [/* @__PURE__ */ V("span", {
					className: "text-lg xl:text-xl font-bold dark:text-orange-200",
					style: { color: "var(--w-text-emphasis, #c2410c)" },
					children: t
				}), /* @__PURE__ */ V("span", {
					className: "text-[10px] xl:text-xs font-medium dark:text-orange-400",
					style: { color: "var(--w-text-subtle, #f97316)" },
					children: t <= 1 ? "actif" : "actifs"
				})]
			})]
		})]
	});
}, _a = ({ polls: e, displayedActiveCount: t, title: n, className: r, maxPolls: i, onPollClick: a, onWidgetClick: o }) => {
	let [s, c] = q(0), l = i ? e.slice(0, i) : e, u = l.length > 0, d = l.length, f = (e) => {
		e.stopPropagation(), c((e) => e === 0 ? d - 1 : e - 1);
	}, p = (e) => {
		e.stopPropagation(), c((e) => e === d - 1 ? 0 : e + 1);
	}, m = () => {
		o && o();
	}, h = l[s];
	return /* @__PURE__ */ H("div", {
		className: J("h-full w-full dark:bg-orange-900 rounded-lg p-3 sm:p-3.5 md:p-4 lg:p-4 xl:p-6", o && "cursor-pointer", r),
		style: { backgroundColor: "var(--w-bg, #ffedd5)" },
		onClick: m,
		role: o ? "button" : void 0,
		tabIndex: o ? 0 : void 0,
		onKeyDown: o ? (e) => {
			(e.key === "Enter" || e.key === " ") && (e.preventDefault(), m());
		} : void 0,
		children: [/* @__PURE__ */ V("style", { children: ma }), /* @__PURE__ */ H("div", {
			className: "flex h-full flex-col",
			children: [
				/* @__PURE__ */ H("div", {
					className: "flex items-center justify-between mb-4",
					children: [/* @__PURE__ */ H("div", {
						className: "flex items-center gap-1.5 xl:gap-2",
						children: [/* @__PURE__ */ V("div", {
							className: "rounded-lg dark:bg-orange-800 p-1.5 xl:p-2",
							style: { backgroundColor: "var(--w-bg-emphasis, #fed7aa)" },
							children: /* @__PURE__ */ V(z, {
								size: 16,
								className: "xl:w-5 xl:h-5 dark:text-orange-400",
								style: { color: "var(--w-text, #ea580c)" },
								"aria-hidden": "true"
							})
						}), /* @__PURE__ */ V("span", {
							className: "text-xs xl:text-sm font-semibold dark:text-orange-300",
							style: { color: "var(--w-text, #ea580c)" },
							children: n
						})]
					}), /* @__PURE__ */ H("div", {
						className: "flex items-baseline gap-1 dark:bg-orange-800/40 px-3 py-1 rounded-full",
						style: { backgroundColor: "var(--w-bg-subtle, rgba(254,215,170,0.6))" },
						children: [/* @__PURE__ */ V("span", {
							className: "text-lg xl:text-xl font-bold dark:text-orange-200",
							style: { color: "var(--w-text-emphasis, #c2410c)" },
							children: t
						}), /* @__PURE__ */ V("span", {
							className: "text-[10px] xl:text-xs font-medium dark:text-orange-400",
							style: { color: "var(--w-text-subtle, #f97316)" },
							children: t <= 1 ? "actif" : "actifs"
						})]
					})]
				}),
				u && h && /* @__PURE__ */ H("div", {
					className: "flex-1 flex flex-col",
					children: [/* @__PURE__ */ H("div", {
						className: J("flex-1 dark:bg-orange-800/30 rounded-xl p-4", a && "cursor-pointer pw-item-hover dark:hover:bg-orange-800/50 transition-colors"),
						style: { backgroundColor: "var(--w-bg-subtle, rgba(254,215,170,0.6))" },
						onClick: (e) => {
							a && (e.stopPropagation(), a(h));
						},
						role: a ? "button" : void 0,
						tabIndex: a ? 0 : void 0,
						children: [
							/* @__PURE__ */ H("div", {
								className: "flex items-center gap-2 mb-3",
								children: [/* @__PURE__ */ V(z, {
									size: 18,
									className: "dark:text-orange-400 flex-shrink-0",
									style: { color: "var(--w-text-subtle, #f97316)" }
								}), /* @__PURE__ */ V("h4", {
									className: "text-sm xl:text-base font-semibold dark:text-orange-200 truncate",
									style: { color: "var(--w-text-emphasis, #c2410c)" },
									children: h.title
								})]
							}),
							/* @__PURE__ */ H("div", {
								className: "flex items-center justify-between mb-3 text-xs xl:text-sm dark:text-orange-300/80",
								style: { color: "var(--w-text-muted, rgba(234,88,12,0.8))" },
								children: [/* @__PURE__ */ H("div", {
									className: "flex items-center gap-1.5",
									children: [/* @__PURE__ */ V(R, { size: 14 }), /* @__PURE__ */ H("span", { children: [h.participantCount, " participants"] })]
								}), h.deadline && /* @__PURE__ */ H("div", {
									className: "flex items-center gap-1.5",
									children: [/* @__PURE__ */ V(M, { size: 14 }), /* @__PURE__ */ H("span", { children: ["Se termine: ", h.deadline] })]
								})]
							}),
							h.progressPercent !== void 0 && /* @__PURE__ */ H("div", {
								className: "mt-2",
								children: [/* @__PURE__ */ V("div", {
									className: "h-2 dark:bg-orange-700/50 rounded-full overflow-hidden",
									style: { backgroundColor: "var(--w-progress-bg, rgba(253,186,116,0.5))" },
									children: /* @__PURE__ */ V("div", {
										className: "h-full dark:bg-orange-400 rounded-full transition-all duration-300",
										style: {
											width: `${Math.min(100, h.progressPercent)}%`,
											backgroundColor: "var(--w-progress-fill, #f97316)"
										}
									})
								}), /* @__PURE__ */ H("p", {
									className: "text-[10px] xl:text-xs dark:text-orange-300/70 text-right mt-1",
									style: { color: "var(--w-text-muted, rgba(234,88,12,0.7))" },
									children: [h.progressPercent, "%"]
								})]
							})
						]
					}), d > 1 && /* @__PURE__ */ H("div", {
						className: "flex items-center justify-center gap-4 mt-3",
						children: [
							/* @__PURE__ */ V("button", {
								onClick: f,
								className: "pw-nav-hover p-1.5 rounded-full dark:bg-orange-800/40 dark:text-orange-300 dark:hover:bg-orange-800/60 transition-colors",
								style: {
									backgroundColor: "var(--w-bg-subtle, rgba(254,215,170,0.6))",
									color: "var(--w-text, #ea580c)"
								},
								"aria-label": "Sondage precedent",
								children: /* @__PURE__ */ V(E, { size: 16 })
							}),
							/* @__PURE__ */ H("span", {
								className: "text-xs font-medium dark:text-orange-300/70",
								style: { color: "var(--w-text-muted, rgba(234,88,12,0.7))" },
								children: [
									s + 1,
									" / ",
									d
								]
							}),
							/* @__PURE__ */ V("button", {
								onClick: p,
								className: "pw-nav-hover p-1.5 rounded-full dark:bg-orange-800/40 dark:text-orange-300 dark:hover:bg-orange-800/60 transition-colors",
								style: {
									backgroundColor: "var(--w-bg-subtle, rgba(254,215,170,0.6))",
									color: "var(--w-text, #ea580c)"
								},
								"aria-label": "Sondage suivant",
								children: /* @__PURE__ */ V(D, { size: 16 })
							})
						]
					})]
				}),
				!u && /* @__PURE__ */ V("div", {
					className: "flex-1 flex items-center justify-center",
					children: /* @__PURE__ */ V("p", {
						className: "text-xs xl:text-sm dark:text-orange-300/60",
						style: { color: "var(--w-text-muted, rgba(234,88,12,0.6))" },
						children: "Aucun sondage actif"
					})
				})
			]
		})]
	});
}, va = ({ polls: e, displayedActiveCount: t, title: n, className: r, maxPolls: i, showParticipantCount: a, onPollClick: o, onWidgetClick: s }) => {
	let c = i ? e.slice(0, i) : e, l = c.length > 0, u = (e) => {
		o && o(e);
	}, d = () => {
		s && s();
	};
	return /* @__PURE__ */ H("div", {
		className: J("h-full w-full dark:bg-orange-900 rounded-lg p-3 sm:p-3.5 md:p-4 lg:p-4 xl:p-6", s && "cursor-pointer", r),
		style: { backgroundColor: "var(--w-bg, #ffedd5)" },
		onClick: d,
		role: s ? "button" : void 0,
		tabIndex: s ? 0 : void 0,
		onKeyDown: s ? (e) => {
			(e.key === "Enter" || e.key === " ") && (e.preventDefault(), d());
		} : void 0,
		children: [/* @__PURE__ */ V("style", { children: ma }), /* @__PURE__ */ H("div", {
			className: "flex h-full flex-col",
			children: [
				/* @__PURE__ */ H("div", {
					className: "flex items-center justify-between mb-3 xl:mb-4",
					children: [/* @__PURE__ */ H("div", {
						className: "flex items-center gap-1.5 xl:gap-2",
						children: [/* @__PURE__ */ V("div", {
							className: "rounded-lg dark:bg-orange-800 p-1.5 xl:p-2",
							style: { backgroundColor: "var(--w-bg-emphasis, #fed7aa)" },
							children: /* @__PURE__ */ V(z, {
								size: 16,
								className: "xl:w-5 xl:h-5 dark:text-orange-400",
								style: { color: "var(--w-text, #ea580c)" },
								"aria-hidden": "true"
							})
						}), /* @__PURE__ */ V("span", {
							className: "text-xs xl:text-sm font-semibold dark:text-orange-300",
							style: { color: "var(--w-text, #ea580c)" },
							children: n
						})]
					}), /* @__PURE__ */ H("div", {
						className: "flex items-baseline gap-1",
						children: [/* @__PURE__ */ V("span", {
							className: "text-2xl xl:text-3xl font-bold dark:text-orange-200",
							style: { color: "var(--w-text-emphasis, #c2410c)" },
							children: t
						}), /* @__PURE__ */ V("span", {
							className: "text-[10px] xl:text-xs font-medium dark:text-orange-400",
							style: { color: "var(--w-text-subtle, #f97316)" },
							children: t <= 1 ? "actif" : "actifs"
						})]
					})]
				}),
				l && a && /* @__PURE__ */ V("div", {
					className: "pw-scroll flex-1 overflow-y-auto space-y-2 pr-1",
					children: c.map((e) => /* @__PURE__ */ V("div", {
						onClick: (t) => {
							o && (t.stopPropagation(), u(e));
						},
						role: o ? "button" : void 0,
						tabIndex: o ? 0 : void 0,
						onKeyDown: o ? (t) => {
							(t.key === "Enter" || t.key === " ") && (t.preventDefault(), t.stopPropagation(), u(e));
						} : void 0,
						children: /* @__PURE__ */ V(ha, { poll: e })
					}, e.id))
				}),
				!l && /* @__PURE__ */ V("div", {
					className: "flex-1 flex items-center justify-center",
					children: /* @__PURE__ */ V("p", {
						className: "text-xs xl:text-sm dark:text-orange-300/60",
						style: { color: "var(--w-text-muted, rgba(234,88,12,0.6))" },
						children: "Aucun sondage actif"
					})
				})
			]
		})]
	});
}, ya = ({ variant: e = "standard", polls: t, activeCount: n, maxPolls: r, showParticipantCount: i = !0, title: a = "Sondages", className: o, isLoading: s = !1, onPollClick: c, onWidgetClick: l }) => {
	if (s) return /* @__PURE__ */ V(Z, { rows: e === "compact" ? 1 : 3 });
	let u = n === void 0 ? t.length : n;
	switch (e) {
		case "compact": return /* @__PURE__ */ V(ga, {
			title: a,
			displayedActiveCount: u,
			className: o,
			onWidgetClick: l
		});
		case "expanded": return /* @__PURE__ */ V(_a, {
			polls: t,
			displayedActiveCount: u,
			title: a,
			className: o,
			maxPolls: r,
			onPollClick: c,
			onWidgetClick: l
		});
		default: return /* @__PURE__ */ V(va, {
			polls: t,
			displayedActiveCount: u,
			title: a,
			className: o,
			maxPolls: r,
			showParticipantCount: i,
			onPollClick: c,
			onWidgetClick: l
		});
	}
}, ba = "\n  .rw-container-hover:hover { background-color: var(--w-bg-subtle, rgba(153,246,228,0.6)) !important; }\n  .rw-item-hover:hover { background-color: var(--w-bg-hover, #99f6e4) !important; }\n  .rw-nav-hover:hover { background-color: var(--w-bg-hover, #99f6e4) !important; }\n  .rw-scroll {\n    scrollbar-width: thin;\n    scrollbar-color: var(--w-scrollbar, rgba(20, 184, 166, 0.4)) transparent;\n  }\n  .rw-scroll::-webkit-scrollbar { width: 6px; }\n  .rw-scroll::-webkit-scrollbar-track { background: transparent; }\n  .rw-scroll::-webkit-scrollbar-thumb {\n    background: var(--w-scrollbar, rgba(20, 184, 166, 0.4));\n    border-radius: 3px;\n  }\n  .rw-scroll::-webkit-scrollbar-thumb:hover {\n    background: var(--w-scrollbar-hover, rgba(20, 184, 166, 0.6));\n  }\n", xa = ({ raffle: e }) => /* @__PURE__ */ H("div", {
	className: "rw-item-hover flex items-center gap-2 rounded-lg dark:bg-teal-800/30 px-3 py-2.5 transition-colors dark:hover:bg-teal-800/50",
	style: { backgroundColor: "var(--w-bg-subtle, rgba(153,246,228,0.6))" },
	children: [/* @__PURE__ */ V(L, {
		size: 16,
		className: "dark:text-teal-500 flex-shrink-0",
		style: { color: "var(--w-accent, #2dd4bf)" },
		"aria-hidden": "true"
	}), /* @__PURE__ */ H("div", {
		className: "flex-1 min-w-0",
		children: [/* @__PURE__ */ V("p", {
			className: "text-xs xl:text-sm font-medium dark:text-teal-200 truncate",
			style: { color: "var(--w-text-emphasis, #0f766e)" },
			children: e.title
		}), /* @__PURE__ */ H("div", {
			className: "flex items-center gap-1 mt-0.5",
			children: [/* @__PURE__ */ V(R, {
				size: 12,
				className: "dark:text-teal-300/60",
				style: { color: "var(--w-text-muted, rgba(13,148,136,0.6))" },
				"aria-hidden": "true"
			}), /* @__PURE__ */ H("span", {
				className: "text-[10px] xl:text-xs dark:text-teal-300/60",
				style: { color: "var(--w-text-muted, rgba(13,148,136,0.6))" },
				children: [
					e.participantCount,
					" ",
					"participant",
					e.participantCount > 1 ? "s" : ""
				]
			})]
		})]
	})]
}), Sa = ({ title: e, displayedActiveCount: t, className: n, onWidgetClick: r }) => {
	let i = () => {
		r && r();
	};
	return /* @__PURE__ */ H("div", {
		className: J("h-full w-full dark:bg-teal-900 rounded-lg p-3 sm:p-3.5 md:p-4", r && "cursor-pointer rw-container-hover dark:hover:bg-teal-800/60 transition-colors", n),
		style: { backgroundColor: "var(--w-bg, #ccfbf1)" },
		onClick: i,
		role: r ? "button" : void 0,
		tabIndex: r ? 0 : void 0,
		onKeyDown: r ? (e) => {
			(e.key === "Enter" || e.key === " ") && (e.preventDefault(), i());
		} : void 0,
		children: [/* @__PURE__ */ V("style", { children: ba }), /* @__PURE__ */ H("div", {
			className: "flex items-center justify-between h-full",
			children: [/* @__PURE__ */ H("div", {
				className: "flex items-center gap-2",
				children: [/* @__PURE__ */ V("div", {
					className: "rounded-lg dark:bg-teal-800 p-1.5",
					style: { backgroundColor: "var(--w-bg-emphasis, #99f6e4)" },
					children: /* @__PURE__ */ V(L, {
						size: 16,
						className: "dark:text-teal-400",
						style: { color: "var(--w-text, #0d9488)" },
						"aria-hidden": "true"
					})
				}), /* @__PURE__ */ V("span", {
					className: "text-xs xl:text-sm font-semibold dark:text-teal-300",
					style: { color: "var(--w-text, #0d9488)" },
					children: e
				})]
			}), /* @__PURE__ */ H("div", {
				className: "flex items-baseline gap-1.5 dark:bg-teal-800/40 px-3 py-1.5 rounded-full",
				style: { backgroundColor: "var(--w-bg-subtle, rgba(153,246,228,0.6))" },
				children: [/* @__PURE__ */ V("span", {
					className: "text-lg xl:text-xl font-bold dark:text-teal-200",
					style: { color: "var(--w-text-emphasis, #0f766e)" },
					children: t
				}), /* @__PURE__ */ V("span", {
					className: "text-[10px] xl:text-xs font-medium dark:text-teal-400",
					style: { color: "var(--w-text-subtle, #14b8a6)" },
					children: "actives"
				})]
			})]
		})]
	});
}, Ca = ({ raffles: e, displayedActiveCount: t, title: n, className: r, maxRaffles: i, onRaffleClick: a, onWidgetClick: o }) => {
	let [s, c] = q(0), l = i ? e.slice(0, i) : e, u = l.length > 0, d = l.length, f = (e) => {
		e.stopPropagation(), c((e) => e === 0 ? d - 1 : e - 1);
	}, p = (e) => {
		e.stopPropagation(), c((e) => e === d - 1 ? 0 : e + 1);
	}, m = () => {
		o && o();
	}, h = l[s];
	return /* @__PURE__ */ H("div", {
		className: J("h-full w-full dark:bg-teal-900 rounded-lg p-3 sm:p-3.5 md:p-4 lg:p-4 xl:p-6", o && "cursor-pointer", r),
		style: { backgroundColor: "var(--w-bg, #ccfbf1)" },
		onClick: m,
		role: o ? "button" : void 0,
		tabIndex: o ? 0 : void 0,
		onKeyDown: o ? (e) => {
			(e.key === "Enter" || e.key === " ") && (e.preventDefault(), m());
		} : void 0,
		children: [/* @__PURE__ */ V("style", { children: ba }), /* @__PURE__ */ H("div", {
			className: "flex h-full flex-col",
			children: [
				/* @__PURE__ */ H("div", {
					className: "flex items-center justify-between mb-4",
					children: [/* @__PURE__ */ H("div", {
						className: "flex items-center gap-1.5 xl:gap-2",
						children: [/* @__PURE__ */ V("div", {
							className: "rounded-lg dark:bg-teal-800 p-1.5 xl:p-2",
							style: { backgroundColor: "var(--w-bg-emphasis, #99f6e4)" },
							children: /* @__PURE__ */ V(L, {
								size: 16,
								className: "xl:w-5 xl:h-5 dark:text-teal-400",
								style: { color: "var(--w-text, #0d9488)" },
								"aria-hidden": "true"
							})
						}), /* @__PURE__ */ V("span", {
							className: "text-xs xl:text-sm font-semibold dark:text-teal-300",
							style: { color: "var(--w-text, #0d9488)" },
							children: n
						})]
					}), /* @__PURE__ */ H("div", {
						className: "flex items-baseline gap-1 dark:bg-teal-800/40 px-3 py-1 rounded-full",
						style: { backgroundColor: "var(--w-bg-subtle, rgba(153,246,228,0.6))" },
						children: [/* @__PURE__ */ V("span", {
							className: "text-lg xl:text-xl font-bold dark:text-teal-200",
							style: { color: "var(--w-text-emphasis, #0f766e)" },
							children: t
						}), /* @__PURE__ */ V("span", {
							className: "text-[10px] xl:text-xs font-medium dark:text-teal-400",
							style: { color: "var(--w-text-subtle, #14b8a6)" },
							children: "actives"
						})]
					})]
				}),
				u && h && /* @__PURE__ */ H("div", {
					className: "flex-1 flex flex-col",
					children: [/* @__PURE__ */ H("div", {
						className: J("flex-1 dark:bg-teal-800/30 rounded-xl p-4", a && "cursor-pointer rw-item-hover dark:hover:bg-teal-800/50 transition-colors"),
						style: { backgroundColor: "var(--w-bg-subtle, rgba(153,246,228,0.6))" },
						onClick: (e) => {
							a && (e.stopPropagation(), a(h));
						},
						role: a ? "button" : void 0,
						tabIndex: a ? 0 : void 0,
						children: [
							/* @__PURE__ */ H("div", {
								className: "flex items-center gap-2 mb-3",
								children: [/* @__PURE__ */ V(L, {
									size: 18,
									className: "dark:text-teal-400 flex-shrink-0",
									style: { color: "var(--w-text-subtle, #14b8a6)" }
								}), /* @__PURE__ */ V("h4", {
									className: "text-sm xl:text-base font-semibold dark:text-teal-200 truncate",
									style: { color: "var(--w-text-emphasis, #0f766e)" },
									children: h.title
								})]
							}),
							/* @__PURE__ */ H("div", {
								className: "flex items-center justify-between mb-3 text-xs xl:text-sm dark:text-teal-300/80",
								style: { color: "var(--w-text-muted, rgba(13,148,136,0.8))" },
								children: [/* @__PURE__ */ H("div", {
									className: "flex items-center gap-1.5",
									children: [/* @__PURE__ */ V(R, { size: 14 }), /* @__PURE__ */ H("span", { children: [h.participantCount, " participants"] })]
								}), h.deadline && /* @__PURE__ */ H("div", {
									className: "flex items-center gap-1.5",
									children: [/* @__PURE__ */ V(M, { size: 14 }), /* @__PURE__ */ H("span", { children: ["Se termine: ", h.deadline] })]
								})]
							}),
							h.progressPercent !== void 0 && /* @__PURE__ */ H("div", {
								className: "mt-2",
								children: [/* @__PURE__ */ V("div", {
									className: "h-2 dark:bg-teal-700/50 rounded-full overflow-hidden",
									style: { backgroundColor: "var(--w-progress-bg, rgba(94,234,212,0.5))" },
									children: /* @__PURE__ */ V("div", {
										className: "h-full dark:bg-teal-400 rounded-full transition-all duration-300",
										style: {
											width: `${Math.min(100, h.progressPercent)}%`,
											backgroundColor: "var(--w-progress-fill, #14b8a6)"
										}
									})
								}), /* @__PURE__ */ H("p", {
									className: "text-[10px] xl:text-xs dark:text-teal-300/70 text-right mt-1",
									style: { color: "var(--w-text-muted, rgba(13,148,136,0.7))" },
									children: [h.progressPercent, "%"]
								})]
							})
						]
					}), d > 1 && /* @__PURE__ */ H("div", {
						className: "flex items-center justify-center gap-4 mt-3",
						children: [
							/* @__PURE__ */ V("button", {
								onClick: f,
								className: "rw-nav-hover p-1.5 rounded-full dark:bg-teal-800/40 dark:text-teal-300 dark:hover:bg-teal-800/60 transition-colors",
								style: {
									backgroundColor: "var(--w-bg-subtle, rgba(153,246,228,0.6))",
									color: "var(--w-text, #0d9488)"
								},
								"aria-label": "Tombola precedente",
								children: /* @__PURE__ */ V(E, { size: 16 })
							}),
							/* @__PURE__ */ H("span", {
								className: "text-xs font-medium dark:text-teal-300/70",
								style: { color: "var(--w-text-muted, rgba(13,148,136,0.7))" },
								children: [
									s + 1,
									" / ",
									d
								]
							}),
							/* @__PURE__ */ V("button", {
								onClick: p,
								className: "rw-nav-hover p-1.5 rounded-full dark:bg-teal-800/40 dark:text-teal-300 dark:hover:bg-teal-800/60 transition-colors",
								style: {
									backgroundColor: "var(--w-bg-subtle, rgba(153,246,228,0.6))",
									color: "var(--w-text, #0d9488)"
								},
								"aria-label": "Tombola suivante",
								children: /* @__PURE__ */ V(D, { size: 16 })
							})
						]
					})]
				}),
				!u && /* @__PURE__ */ V("div", {
					className: "flex-1 flex items-center justify-center",
					children: /* @__PURE__ */ V("p", {
						className: "text-xs xl:text-sm dark:text-teal-300/60",
						style: { color: "var(--w-text-muted, rgba(13,148,136,0.6))" },
						children: "Aucune tombola active"
					})
				})
			]
		})]
	});
}, wa = ({ raffles: e, displayedActiveCount: t, title: n, className: r, maxRaffles: i, showParticipantCount: a, onRaffleClick: o, onWidgetClick: s }) => {
	let c = i ? e.slice(0, i) : e, l = c.length > 0, u = (e) => {
		o && o(e);
	}, d = () => {
		s && s();
	};
	return /* @__PURE__ */ H("div", {
		className: J("h-full w-full dark:bg-teal-900 rounded-lg p-3 sm:p-3.5 md:p-4 lg:p-4 xl:p-6", s && "cursor-pointer", r),
		style: { backgroundColor: "var(--w-bg, #ccfbf1)" },
		onClick: d,
		role: s ? "button" : void 0,
		tabIndex: s ? 0 : void 0,
		onKeyDown: s ? (e) => {
			(e.key === "Enter" || e.key === " ") && (e.preventDefault(), d());
		} : void 0,
		children: [/* @__PURE__ */ V("style", { children: ba }), /* @__PURE__ */ H("div", {
			className: "flex h-full flex-col",
			children: [
				/* @__PURE__ */ H("div", {
					className: "flex items-center justify-between mb-3 xl:mb-4",
					children: [/* @__PURE__ */ H("div", {
						className: "flex items-center gap-1.5 xl:gap-2",
						children: [/* @__PURE__ */ V("div", {
							className: "rounded-lg dark:bg-teal-800 p-1.5 xl:p-2",
							style: { backgroundColor: "var(--w-bg-emphasis, #99f6e4)" },
							children: /* @__PURE__ */ V(L, {
								size: 16,
								className: "xl:w-5 xl:h-5 dark:text-teal-400",
								style: { color: "var(--w-text, #0d9488)" },
								"aria-hidden": "true"
							})
						}), /* @__PURE__ */ V("span", {
							className: "text-xs xl:text-sm font-semibold dark:text-teal-300",
							style: { color: "var(--w-text, #0d9488)" },
							children: n
						})]
					}), /* @__PURE__ */ H("div", {
						className: "flex items-baseline gap-1",
						children: [/* @__PURE__ */ V("span", {
							className: "text-2xl xl:text-3xl font-bold dark:text-teal-200",
							style: { color: "var(--w-text-emphasis, #0f766e)" },
							children: t
						}), /* @__PURE__ */ V("span", {
							className: "text-[10px] xl:text-xs font-medium dark:text-teal-400",
							style: { color: "var(--w-text-subtle, #14b8a6)" },
							children: "actives"
						})]
					})]
				}),
				l && a && /* @__PURE__ */ V("div", {
					className: "rw-scroll flex-1 overflow-y-auto space-y-2 pr-1",
					children: c.map((e) => /* @__PURE__ */ V("div", {
						onClick: (t) => {
							o && (t.stopPropagation(), u(e));
						},
						role: o ? "button" : void 0,
						tabIndex: o ? 0 : void 0,
						onKeyDown: o ? (t) => {
							(t.key === "Enter" || t.key === " ") && (t.preventDefault(), t.stopPropagation(), u(e));
						} : void 0,
						children: /* @__PURE__ */ V(xa, { raffle: e })
					}, e.id))
				}),
				!l && /* @__PURE__ */ V("div", {
					className: "flex-1 flex items-center justify-center",
					children: /* @__PURE__ */ V("p", {
						className: "text-xs xl:text-sm dark:text-teal-300/60",
						style: { color: "var(--w-text-muted, rgba(13,148,136,0.6))" },
						children: "Aucune tombola active"
					})
				})
			]
		})]
	});
}, Ta = ({ variant: e = "standard", raffles: t, activeCount: n, maxRaffles: r, showParticipantCount: i = !0, title: a = "Tombolas", className: o, isLoading: s = !1, onRaffleClick: c, onWidgetClick: l }) => {
	if (s) return /* @__PURE__ */ V(Z, { rows: e === "compact" ? 1 : 3 });
	let u = n === void 0 ? t.length : n;
	switch (e) {
		case "compact": return /* @__PURE__ */ V(Sa, {
			title: a,
			displayedActiveCount: u,
			className: o,
			onWidgetClick: l
		});
		case "expanded": return /* @__PURE__ */ V(Ca, {
			raffles: t,
			displayedActiveCount: u,
			title: a,
			className: o,
			maxRaffles: r,
			onRaffleClick: c,
			onWidgetClick: l
		});
		default: return /* @__PURE__ */ V(wa, {
			raffles: t,
			displayedActiveCount: u,
			title: a,
			className: o,
			maxRaffles: r,
			showParticipantCount: i,
			onRaffleClick: c,
			onWidgetClick: l
		});
	}
}, Ea = "\n  .blw-container-hover:hover { background-color: var(--w-bg-subtle, rgba(254,240,138,0.6)) !important; }\n  .blw-item-hover:hover { background-color: var(--w-bg-hover, #fef08a) !important; }\n  .blw-nav-hover:hover { background-color: var(--w-bg-hover, #fef08a) !important; }\n  .blw-scroll {\n    scrollbar-width: thin;\n    scrollbar-color: var(--w-scrollbar, rgba(234, 179, 8, 0.45)) transparent;\n  }\n  .blw-scroll::-webkit-scrollbar { width: 6px; }\n  .blw-scroll::-webkit-scrollbar-track { background: transparent; }\n  .blw-scroll::-webkit-scrollbar-thumb {\n    background: var(--w-scrollbar, rgba(234, 179, 8, 0.45));\n    border-radius: 3px;\n  }\n  .blw-scroll::-webkit-scrollbar-thumb:hover {\n    background: var(--w-scrollbar-hover, rgba(234, 179, 8, 0.65));\n  }\n", Da = ({ post: e }) => /* @__PURE__ */ H("div", {
	className: "blw-item-hover flex items-center gap-2 rounded-lg dark:bg-yellow-800/30 px-3 py-2.5 transition-colors dark:hover:bg-yellow-800/50",
	style: { backgroundColor: "var(--w-bg-subtle, rgba(254,240,138,0.6))" },
	children: [/* @__PURE__ */ V(I, {
		size: 16,
		className: "dark:text-yellow-400 flex-shrink-0",
		style: { color: "var(--w-accent, #eab308)" },
		"aria-hidden": "true"
	}), /* @__PURE__ */ H("div", {
		className: "flex-1 min-w-0",
		children: [/* @__PURE__ */ V("p", {
			className: "text-xs xl:text-sm font-medium dark:text-yellow-200 truncate",
			style: { color: "var(--w-text-emphasis, #a16207)" },
			children: e.title
		}), /* @__PURE__ */ H("div", {
			className: "flex items-center gap-1 mt-0.5",
			children: [/* @__PURE__ */ V(R, {
				size: 12,
				className: "dark:text-yellow-300/60",
				style: { color: "var(--w-text-muted, rgba(202,138,4,0.6))" },
				"aria-hidden": "true"
			}), /* @__PURE__ */ H("span", {
				className: "text-[10px] xl:text-xs dark:text-yellow-300/60",
				style: { color: "var(--w-text-muted, rgba(202,138,4,0.6))" },
				children: [
					e.readCount,
					" ",
					"lecture",
					e.readCount > 1 ? "s" : ""
				]
			})]
		})]
	})]
}), Oa = ({ title: e, displayedActiveCount: t, className: n, onWidgetClick: r }) => {
	let i = () => {
		r && r();
	};
	return /* @__PURE__ */ H("div", {
		className: J("h-full w-full dark:bg-yellow-900 rounded-lg p-3 sm:p-3.5 md:p-4", r && "cursor-pointer blw-container-hover dark:hover:bg-yellow-800/60 transition-colors", n),
		style: { backgroundColor: "var(--w-bg, #fef9c3)" },
		onClick: i,
		role: r ? "button" : void 0,
		tabIndex: r ? 0 : void 0,
		onKeyDown: r ? (e) => {
			(e.key === "Enter" || e.key === " ") && (e.preventDefault(), i());
		} : void 0,
		children: [/* @__PURE__ */ V("style", { children: Ea }), /* @__PURE__ */ H("div", {
			className: "flex items-center justify-between h-full",
			children: [/* @__PURE__ */ H("div", {
				className: "flex items-center gap-2",
				children: [/* @__PURE__ */ V("div", {
					className: "rounded-lg dark:bg-yellow-800 p-1.5",
					style: { backgroundColor: "var(--w-bg-emphasis, #fef08a)" },
					children: /* @__PURE__ */ V(I, {
						size: 16,
						className: "dark:text-yellow-300",
						style: { color: "var(--w-text-emphasis, #a16207)" },
						"aria-hidden": "true"
					})
				}), /* @__PURE__ */ V("span", {
					className: "text-xs xl:text-sm font-semibold dark:text-yellow-300",
					style: { color: "var(--w-text-emphasis, #a16207)" },
					children: e
				})]
			}), /* @__PURE__ */ H("div", {
				className: "flex items-baseline gap-1.5 dark:bg-yellow-800/40 px-3 py-1.5 rounded-full",
				style: { backgroundColor: "var(--w-bg-subtle, rgba(254,240,138,0.6))" },
				children: [/* @__PURE__ */ V("span", {
					className: "text-lg xl:text-xl font-bold dark:text-yellow-100",
					style: { color: "var(--w-text-emphasis, #854d0e)" },
					children: t
				}), /* @__PURE__ */ V("span", {
					className: "text-[10px] xl:text-xs font-medium dark:text-yellow-300",
					style: { color: "var(--w-text-muted, rgba(161,98,7,0.8))" },
					children: "articles"
				})]
			})]
		})]
	});
}, ka = ({ posts: e, displayedActiveCount: t, title: n, className: r, maxPosts: i, onPostClick: a, onWidgetClick: o }) => {
	let [s, c] = q(0), l = i ? e.slice(0, i) : e, u = l.length > 0, d = l.length, f = (e) => {
		e.stopPropagation(), c((e) => e === 0 ? d - 1 : e - 1);
	}, p = (e) => {
		e.stopPropagation(), c((e) => e === d - 1 ? 0 : e + 1);
	}, m = () => {
		o && o();
	}, h = l[s];
	return /* @__PURE__ */ H("div", {
		className: J("h-full w-full dark:bg-yellow-900 rounded-lg p-3 sm:p-3.5 md:p-4 lg:p-4 xl:p-6", o && "cursor-pointer", r),
		style: { backgroundColor: "var(--w-bg, #fef9c3)" },
		onClick: m,
		role: o ? "button" : void 0,
		tabIndex: o ? 0 : void 0,
		onKeyDown: o ? (e) => {
			(e.key === "Enter" || e.key === " ") && (e.preventDefault(), m());
		} : void 0,
		children: [/* @__PURE__ */ V("style", { children: Ea }), /* @__PURE__ */ H("div", {
			className: "flex h-full flex-col",
			children: [
				/* @__PURE__ */ H("div", {
					className: "flex items-center justify-between mb-4",
					children: [/* @__PURE__ */ H("div", {
						className: "flex items-center gap-1.5 xl:gap-2",
						children: [/* @__PURE__ */ V("div", {
							className: "rounded-lg dark:bg-yellow-800 p-1.5 xl:p-2",
							style: { backgroundColor: "var(--w-bg-emphasis, #fef08a)" },
							children: /* @__PURE__ */ V(I, {
								size: 16,
								className: "xl:w-5 xl:h-5 dark:text-yellow-300",
								style: { color: "var(--w-text-emphasis, #a16207)" },
								"aria-hidden": "true"
							})
						}), /* @__PURE__ */ V("span", {
							className: "text-xs xl:text-sm font-semibold dark:text-yellow-300",
							style: { color: "var(--w-text-emphasis, #a16207)" },
							children: n
						})]
					}), /* @__PURE__ */ H("div", {
						className: "flex items-baseline gap-1 dark:bg-yellow-800/40 px-3 py-1 rounded-full",
						style: { backgroundColor: "var(--w-bg-subtle, rgba(254,240,138,0.6))" },
						children: [/* @__PURE__ */ V("span", {
							className: "text-lg xl:text-xl font-bold dark:text-yellow-100",
							style: { color: "var(--w-text-emphasis, #854d0e)" },
							children: t
						}), /* @__PURE__ */ V("span", {
							className: "text-[10px] xl:text-xs font-medium dark:text-yellow-300",
							style: { color: "var(--w-text-muted, rgba(161,98,7,0.8))" },
							children: "articles"
						})]
					})]
				}),
				u && h && /* @__PURE__ */ H("div", {
					className: "flex-1 flex flex-col",
					children: [/* @__PURE__ */ H("div", {
						className: J("flex-1 dark:bg-yellow-800/30 rounded-xl p-4", a && "cursor-pointer blw-item-hover dark:hover:bg-yellow-800/50 transition-colors"),
						style: { backgroundColor: "var(--w-bg-subtle, rgba(254,240,138,0.6))" },
						onClick: (e) => {
							a && (e.stopPropagation(), a(h));
						},
						role: a ? "button" : void 0,
						tabIndex: a ? 0 : void 0,
						children: [
							/* @__PURE__ */ H("div", {
								className: "flex items-center gap-2 mb-3",
								children: [/* @__PURE__ */ V(I, {
									size: 18,
									className: "dark:text-yellow-300 flex-shrink-0",
									style: { color: "var(--w-text-subtle, #ca8a04)" }
								}), /* @__PURE__ */ V("h4", {
									className: "text-sm xl:text-base font-semibold dark:text-yellow-100 truncate",
									style: { color: "var(--w-text-emphasis, #854d0e)" },
									children: h.title
								})]
							}),
							/* @__PURE__ */ H("div", {
								className: "flex items-center justify-between mb-3 text-xs xl:text-sm dark:text-yellow-200/80",
								style: { color: "var(--w-text-muted, rgba(161,98,7,0.8))" },
								children: [/* @__PURE__ */ H("div", {
									className: "flex items-center gap-1.5",
									children: [/* @__PURE__ */ V(R, { size: 14 }), /* @__PURE__ */ H("span", { children: [
										h.readCount,
										" lecture",
										h.readCount > 1 ? "s" : ""
									] })]
								}), h.deadline && /* @__PURE__ */ H("div", {
									className: "flex items-center gap-1.5",
									children: [/* @__PURE__ */ V(M, { size: 14 }), /* @__PURE__ */ H("span", { children: ["Publie: ", h.deadline] })]
								})]
							}),
							h.progressPercent !== void 0 && /* @__PURE__ */ H("div", {
								className: "mt-2",
								children: [/* @__PURE__ */ V("div", {
									className: "h-2 dark:bg-yellow-700/50 rounded-full overflow-hidden",
									style: { backgroundColor: "var(--w-progress-bg, rgba(253,224,71,0.6))" },
									children: /* @__PURE__ */ V("div", {
										className: "h-full dark:bg-yellow-300 rounded-full transition-all duration-300",
										style: {
											width: `${Math.min(100, h.progressPercent)}%`,
											backgroundColor: "var(--w-progress-fill, #eab308)"
										}
									})
								}), /* @__PURE__ */ H("p", {
									className: "text-[10px] xl:text-xs dark:text-yellow-200/70 text-right mt-1",
									style: { color: "var(--w-text-muted, rgba(161,98,7,0.7))" },
									children: [h.progressPercent, "%"]
								})]
							})
						]
					}), d > 1 && /* @__PURE__ */ H("div", {
						className: "flex items-center justify-center gap-4 mt-3",
						children: [
							/* @__PURE__ */ V("button", {
								onClick: f,
								className: "blw-nav-hover p-1.5 rounded-full dark:bg-yellow-800/40 dark:text-yellow-200 dark:hover:bg-yellow-800/60 transition-colors",
								style: {
									backgroundColor: "var(--w-bg-subtle, rgba(254,240,138,0.6))",
									color: "var(--w-text-emphasis, #a16207)"
								},
								"aria-label": "Article precedent",
								children: /* @__PURE__ */ V(E, { size: 16 })
							}),
							/* @__PURE__ */ H("span", {
								className: "text-xs font-medium dark:text-yellow-200/70",
								style: { color: "var(--w-text-muted, rgba(161,98,7,0.7))" },
								children: [
									s + 1,
									" / ",
									d
								]
							}),
							/* @__PURE__ */ V("button", {
								onClick: p,
								className: "blw-nav-hover p-1.5 rounded-full dark:bg-yellow-800/40 dark:text-yellow-200 dark:hover:bg-yellow-800/60 transition-colors",
								style: {
									backgroundColor: "var(--w-bg-subtle, rgba(254,240,138,0.6))",
									color: "var(--w-text-emphasis, #a16207)"
								},
								"aria-label": "Article suivant",
								children: /* @__PURE__ */ V(D, { size: 16 })
							})
						]
					})]
				}),
				!u && /* @__PURE__ */ V("div", {
					className: "flex-1 flex items-center justify-center",
					children: /* @__PURE__ */ V("p", {
						className: "text-xs xl:text-sm dark:text-yellow-200/60",
						style: { color: "var(--w-text-muted, rgba(161,98,7,0.6))" },
						children: "Aucun article recent"
					})
				})
			]
		})]
	});
}, Aa = ({ posts: e, displayedActiveCount: t, title: n, className: r, maxPosts: i, showParticipantCount: a, onPostClick: o, onWidgetClick: s }) => {
	let c = i ? e.slice(0, i) : e, l = c.length > 0, u = (e) => {
		o && o(e);
	}, d = () => {
		s && s();
	};
	return /* @__PURE__ */ H("div", {
		className: J("h-full w-full dark:bg-yellow-900 rounded-lg p-3 sm:p-3.5 md:p-4 lg:p-4 xl:p-6", s && "cursor-pointer", r),
		style: { backgroundColor: "var(--w-bg, #fef9c3)" },
		onClick: d,
		role: s ? "button" : void 0,
		tabIndex: s ? 0 : void 0,
		onKeyDown: s ? (e) => {
			(e.key === "Enter" || e.key === " ") && (e.preventDefault(), d());
		} : void 0,
		children: [/* @__PURE__ */ V("style", { children: Ea }), /* @__PURE__ */ H("div", {
			className: "flex h-full flex-col",
			children: [
				/* @__PURE__ */ H("div", {
					className: "flex items-center justify-between mb-3 xl:mb-4",
					children: [/* @__PURE__ */ H("div", {
						className: "flex items-center gap-1.5 xl:gap-2",
						children: [/* @__PURE__ */ V("div", {
							className: "rounded-lg dark:bg-yellow-800 p-1.5 xl:p-2",
							style: { backgroundColor: "var(--w-bg-emphasis, #fef08a)" },
							children: /* @__PURE__ */ V(I, {
								size: 16,
								className: "xl:w-5 xl:h-5 dark:text-yellow-300",
								style: { color: "var(--w-text-emphasis, #a16207)" },
								"aria-hidden": "true"
							})
						}), /* @__PURE__ */ V("span", {
							className: "text-xs xl:text-sm font-semibold dark:text-yellow-300",
							style: { color: "var(--w-text-emphasis, #a16207)" },
							children: n
						})]
					}), /* @__PURE__ */ H("div", {
						className: "flex items-baseline gap-1",
						children: [/* @__PURE__ */ V("span", {
							className: "text-2xl xl:text-3xl font-bold dark:text-yellow-100",
							style: { color: "var(--w-text-emphasis, #854d0e)" },
							children: t
						}), /* @__PURE__ */ V("span", {
							className: "text-[10px] xl:text-xs font-medium dark:text-yellow-300",
							style: { color: "var(--w-text-muted, rgba(161,98,7,0.8))" },
							children: "articles"
						})]
					})]
				}),
				l && a && /* @__PURE__ */ V("div", {
					className: "blw-scroll flex-1 overflow-y-auto space-y-2 pr-1",
					children: c.map((e) => /* @__PURE__ */ V("div", {
						onClick: (t) => {
							o && (t.stopPropagation(), u(e));
						},
						role: o ? "button" : void 0,
						tabIndex: o ? 0 : void 0,
						onKeyDown: o ? (t) => {
							(t.key === "Enter" || t.key === " ") && (t.preventDefault(), t.stopPropagation(), u(e));
						} : void 0,
						children: /* @__PURE__ */ V(Da, { post: e })
					}, e.id))
				}),
				!l && /* @__PURE__ */ V("div", {
					className: "flex-1 flex items-center justify-center",
					children: /* @__PURE__ */ V("p", {
						className: "text-xs xl:text-sm dark:text-yellow-200/60",
						style: { color: "var(--w-text-muted, rgba(161,98,7,0.6))" },
						children: "Aucun article recent"
					})
				})
			]
		})]
	});
}, ja = ({ variant: e = "standard", posts: t, activeCount: n, maxPosts: r, showParticipantCount: i = !0, title: a = "Blog", className: o, isLoading: s = !1, onPostClick: c, onWidgetClick: l }) => {
	if (s) return /* @__PURE__ */ V(Z, { rows: e === "compact" ? 1 : 3 });
	let u = n === void 0 ? t.length : n;
	switch (e) {
		case "compact": return /* @__PURE__ */ V(Oa, {
			title: a,
			displayedActiveCount: u,
			className: o,
			onWidgetClick: l
		});
		case "expanded": return /* @__PURE__ */ V(ka, {
			posts: t,
			displayedActiveCount: u,
			title: a,
			className: o,
			maxPosts: r,
			onPostClick: c,
			onWidgetClick: l
		});
		default: return /* @__PURE__ */ V(Aa, {
			posts: t,
			displayedActiveCount: u,
			title: a,
			className: o,
			maxPosts: r,
			showParticipantCount: i,
			onPostClick: c,
			onWidgetClick: l
		});
	}
}, Ma = ({ actions: e, maxActions: t, layout: n = "horizontal", backgroundColor: r, icon: i = "Zap", title: a = "Actions rapides", isLoading: o = !1, onActionClick: s, className: c }) => {
	if (o) return /* @__PURE__ */ V(Z, {
		rows: 2,
		className: c
	});
	let l = t ? e.slice(0, t) : e;
	if (l.length === 0) return /* @__PURE__ */ H(X, {
		backgroundColor: r,
		className: c,
		children: [/* @__PURE__ */ V(sn, {
			title: a,
			icon: i
		}), /* @__PURE__ */ V(cn, {
			icon: "⚡",
			message: "Aucune action disponible"
		})]
	});
	let u = (e) => {
		s ? s(e) : e.url && (window.location.href = e.url);
	};
	return /* @__PURE__ */ H(X, {
		backgroundColor: r,
		className: c,
		children: [/* @__PURE__ */ V(sn, {
			title: a,
			icon: i
		}), /* @__PURE__ */ V("div", {
			className: J("flex gap-4", n === "horizontal" && "items-center justify-center", n === "vertical" && "flex-col", n === "grid" && "grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4"),
			children: l.map((e) => {
				let t = an[e.icon] ?? ht;
				return /* @__PURE__ */ H("button", {
					onClick: () => u(e),
					className: J("flex flex-col items-center gap-1.5 p-3 rounded-xl transition-colors group", "hover:bg-gray-50 dark:hover:bg-gray-700/50", "focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"),
					children: [/* @__PURE__ */ V("div", {
						className: "w-10 h-10 rounded-xl bg-blue-50 dark:bg-blue-900/30 flex items-center justify-center group-hover:bg-blue-100 dark:group-hover:bg-blue-900/50 transition-colors",
						children: /* @__PURE__ */ V(t, { className: "w-5 h-5 text-blue-600 dark:text-blue-400" })
					}), /* @__PURE__ */ V("span", {
						className: "text-xs font-medium text-gray-700 dark:text-gray-300 text-center",
						children: e.label
					})]
				}, e.label);
			})
		})]
	});
}, Na = (e, t = 30) => e.length <= t ? e : `${e.slice(0, t)}...`, Pa = "\n  .cw-item-hover:hover { background-color: var(--w-bg-hover, #bfdbfe) !important; }\n", Fa = "\n  .bw-item-hover:hover { background-color: var(--w-bg-hover, #fde68a) !important; }\n  .bw-scroll {\n    scrollbar-width: thin;\n    scrollbar-color: var(--w-scrollbar, rgba(245, 158, 11, 0.4)) transparent;\n  }\n  .bw-scroll::-webkit-scrollbar { width: 6px; }\n  .bw-scroll::-webkit-scrollbar-track { background: transparent; }\n  .bw-scroll::-webkit-scrollbar-thumb {\n    background: var(--w-scrollbar, rgba(245, 158, 11, 0.4));\n    border-radius: 3px;\n  }\n", Ia = ({ conversation: e }) => /* @__PURE__ */ H("div", {
	className: "cw-item-hover flex items-center justify-between gap-2 rounded-lg dark:bg-blue-800/30 p-2 xl:p-2.5 border dark:border-blue-700/50 dark:hover:bg-blue-800/50 transition-all duration-200",
	style: {
		backgroundColor: "var(--w-bg-subtle, rgba(191,219,254,0.6))",
		borderColor: "var(--w-bg-emphasis, rgba(147,197,253,0.5))"
	},
	children: [/* @__PURE__ */ H("div", {
		className: "flex-1 min-w-0",
		children: [/* @__PURE__ */ V("div", {
			className: "flex items-center gap-1.5 mb-0.5",
			children: /* @__PURE__ */ V("span", {
				className: "text-[10px] xl:text-xs font-semibold dark:text-blue-200 truncate",
				style: { color: "var(--w-text-emphasis, #1d4ed8)" },
				children: e.name
			})
		}), /* @__PURE__ */ V("p", {
			className: "text-[9px] xl:text-[10px] dark:text-blue-300/80 truncate leading-tight",
			style: { color: "var(--w-text-muted, rgba(37,99,235,0.8))" },
			children: Na(e.lastMessage, 30)
		})]
	}), e.unreadCount > 0 ? /* @__PURE__ */ V("div", {
		className: "flex-shrink-0 flex items-center justify-center min-w-[20px] xl:min-w-[24px] h-5 xl:h-6 px-1.5 xl:px-2 rounded-lg bg-white text-[9px] xl:text-xs font-bold shadow-sm",
		style: { color: "var(--w-text-emphasis, #1d4ed8)" },
		children: e.unreadCount > 9 ? "9+" : e.unreadCount
	}) : /* @__PURE__ */ V("div", {
		className: "flex-shrink-0 flex items-center justify-center",
		children: /* @__PURE__ */ V(C, {
			size: 16,
			className: "xl:w-5 xl:h-5 dark:text-blue-500",
			style: { color: "var(--w-accent, #60a5fa)" },
			"aria-hidden": "true"
		})
	})]
}), La = {
	Sondage: z,
	Tombola: L,
	Article: I,
	Message: Be,
	Remboursement: l
}, Ra = ({ activity: e, getActivityIcon: t }) => {
	let n = (e) => {
		let t = new Date(e), n = (/* @__PURE__ */ new Date()).getTime() - t.getTime(), r = Math.floor(n / 6e4);
		if (r < 60) return `${r}m`;
		let i = Math.floor(r / 60);
		return i < 24 ? `${i}h` : `${Math.floor(i / 24)}j`;
	}, i = t?.(e), a = La[e.subjectType] ?? r;
	return /* @__PURE__ */ H("div", {
		className: "flex items-center gap-2 rounded-lg bg-lightprimary dark:bg-primary/20 px-3 py-2.5 transition-colors hover:bg-primary/30 dark:hover:bg-primary/30",
		children: [
			i ?? /* @__PURE__ */ V(a, {
				size: 16,
				className: "text-primary dark:text-primary flex-shrink-0",
				"aria-hidden": "true"
			}),
			/* @__PURE__ */ V("div", {
				className: "flex-1 min-w-0",
				children: /* @__PURE__ */ V("p", {
					className: "text-xs xl:text-sm font-medium text-primary-emphasis dark:text-white truncate",
					children: e.subject.title || e.subjectType
				})
			}),
			/* @__PURE__ */ V("span", {
				className: "text-[10px] xl:text-xs text-primary dark:text-primary flex-shrink-0",
				children: n(e.createdAt)
			})
		]
	});
}, za = ({ article: e }) => /* @__PURE__ */ H("div", {
	className: "bw-item-hover flex items-center gap-2 rounded-lg dark:bg-amber-800/30 px-3 py-2.5 transition-colors dark:hover:bg-amber-800/50",
	style: { backgroundColor: "var(--w-bg-subtle, rgba(253,230,138,0.6))" },
	children: [/* @__PURE__ */ V(I, {
		size: 16,
		className: "dark:text-amber-400 flex-shrink-0",
		style: { color: "var(--w-accent, #f59e0b)" },
		"aria-hidden": "true"
	}), /* @__PURE__ */ H("div", {
		className: "flex-1 min-w-0",
		children: [/* @__PURE__ */ V("p", {
			className: "text-xs xl:text-sm font-medium dark:text-amber-200 truncate",
			style: { color: "var(--w-text-emphasis, #b45309)" },
			children: e.title
		}), /* @__PURE__ */ V("p", {
			className: "text-[10px] xl:text-xs dark:text-amber-300/60 truncate",
			style: { color: "var(--w-text-muted, rgba(217,119,6,0.6))" },
			children: e.excerpt
		})]
	})]
}), Ba = ({ conversations: e, title: t, className: n, maxItems: r = 2, onConversationClick: i, onWidgetClick: a }) => {
	let o = e.slice(0, r), s = o.reduce((e, t) => e + t.unreadCount, 0), c = () => {
		a && a();
	};
	return /* @__PURE__ */ H("div", {
		className: J("h-full w-full dark:bg-blue-900 rounded-lg p-3 sm:p-3.5 md:p-4 lg:p-4 xl:p-6", a && "cursor-pointer", n),
		style: { backgroundColor: "var(--w-bg, #dbeafe)" },
		onClick: c,
		role: a ? "button" : void 0,
		tabIndex: a ? 0 : void 0,
		onKeyDown: a ? (e) => {
			(e.key === "Enter" || e.key === " ") && (e.preventDefault(), c());
		} : void 0,
		children: [/* @__PURE__ */ V("style", { children: Pa }), /* @__PURE__ */ H("div", {
			className: "flex h-full flex-col",
			children: [/* @__PURE__ */ H("div", {
				className: "flex items-start justify-between gap-2 mb-3 xl:mb-4",
				children: [/* @__PURE__ */ H("div", {
					className: "flex items-center gap-1.5 xl:gap-2",
					children: [/* @__PURE__ */ V("div", {
						className: "rounded-lg dark:bg-blue-800 p-1.5 xl:p-2",
						style: { backgroundColor: "var(--w-bg-emphasis, #bfdbfe)" },
						children: /* @__PURE__ */ V(Be, {
							size: 16,
							className: "xl:w-5 xl:h-5 dark:text-blue-400",
							style: { color: "var(--w-text, #2563eb)" },
							"aria-hidden": "true"
						})
					}), /* @__PURE__ */ V("span", {
						className: "text-xs xl:text-sm font-semibold dark:text-blue-300",
						style: { color: "var(--w-text, #2563eb)" },
						children: t
					})]
				}), s > 0 && /* @__PURE__ */ V("span", {
					className: "relative text-[10px] xl:text-xs text-red-600 dark:text-red-400 font-medium px-2 py-1 xl:px-3 xl:py-1.5 rounded-lg bg-red-100 dark:bg-red-900/40 flex-shrink-0",
					children: /* @__PURE__ */ H("span", {
						className: "flex items-center gap-1 xl:gap-1.5 relative z-10",
						children: [/* @__PURE__ */ V(Ve, {
							size: 14,
							className: "xl:w-4 xl:h-4 text-red-500",
							"aria-hidden": "true"
						}), /* @__PURE__ */ V("span", {
							className: "font-bold",
							children: s
						})]
					})
				})]
			}), /* @__PURE__ */ V("div", {
				className: "flex flex-col gap-1.5 xl:gap-2",
				children: o.length > 0 ? o.map((e) => /* @__PURE__ */ V("div", {
					onClick: (t) => {
						i && (t.stopPropagation(), i(e));
					},
					role: i ? "button" : void 0,
					tabIndex: i ? 0 : void 0,
					onKeyDown: i ? (t) => {
						(t.key === "Enter" || t.key === " ") && (t.preventDefault(), t.stopPropagation(), i(e));
					} : void 0,
					children: /* @__PURE__ */ V(Ia, { conversation: e })
				}, e.id)) : /* @__PURE__ */ V("p", {
					className: "text-xs xl:text-sm dark:text-blue-300/60 text-center py-4",
					style: { color: "var(--w-text-muted, rgba(37,99,235,0.6))" },
					children: "Aucune conversation"
				})
			})]
		})]
	});
}, Va = ({ activities: e, title: t, className: n, maxItems: i, onActivityClick: a, onWidgetClick: o, getActivityIcon: s }) => {
	let c = i ? e.slice(0, i) : e, l = c.length > 0, u = (e) => {
		a && a(e);
	}, d = () => {
		o && o();
	};
	return /* @__PURE__ */ V("div", {
		className: J("h-full w-full bg-lightprimary dark:bg-primary/30 rounded-lg p-3 sm:p-3.5 md:p-4 lg:p-4 xl:p-6", o && "cursor-pointer", n),
		onClick: d,
		role: o ? "button" : void 0,
		tabIndex: o ? 0 : void 0,
		onKeyDown: o ? (e) => {
			(e.key === "Enter" || e.key === " ") && (e.preventDefault(), d());
		} : void 0,
		children: /* @__PURE__ */ H("div", {
			className: "flex h-full flex-col",
			children: [/* @__PURE__ */ H("div", {
				className: "flex items-center justify-between mb-3 xl:mb-4",
				children: [/* @__PURE__ */ H("div", {
					className: "flex items-center gap-1.5 xl:gap-2",
					children: [/* @__PURE__ */ V("div", {
						className: "rounded-lg bg-primary/20 dark:bg-primary/40 p-1.5 xl:p-2",
						children: /* @__PURE__ */ V(r, {
							size: 16,
							className: "xl:w-5 xl:h-5 text-primary dark:text-primary",
							"aria-hidden": "true"
						})
					}), /* @__PURE__ */ V("span", {
						className: "text-xs xl:text-sm font-semibold text-primary dark:text-white",
						children: t
					})]
				}), /* @__PURE__ */ H("div", {
					className: "flex items-baseline gap-1",
					children: [/* @__PURE__ */ V("span", {
						className: "text-2xl xl:text-3xl font-bold text-primary-emphasis dark:text-white",
						children: c.length
					}), /* @__PURE__ */ V("span", {
						className: "text-[10px] xl:text-xs font-medium text-primary dark:text-primary",
						children: "récentes"
					})]
				})]
			}), l ? /* @__PURE__ */ V("div", {
				className: "flex-1 overflow-y-auto space-y-2 pr-1",
				style: {
					scrollbarWidth: "thin",
					scrollbarColor: "rgba(99, 102, 241, 0.4) transparent"
				},
				children: c.map((e) => /* @__PURE__ */ V("div", {
					className: a ? "cursor-pointer" : void 0,
					onClick: (t) => {
						a && (t.stopPropagation(), u(e));
					},
					role: a ? "button" : void 0,
					tabIndex: a ? 0 : void 0,
					onKeyDown: a ? (t) => {
						(t.key === "Enter" || t.key === " ") && (t.preventDefault(), t.stopPropagation(), u(e));
					} : void 0,
					children: /* @__PURE__ */ V(Ra, {
						activity: e,
						getActivityIcon: s
					})
				}, e.id))
			}) : /* @__PURE__ */ V("div", {
				className: "flex-1 flex items-center justify-center",
				children: /* @__PURE__ */ V("p", {
					className: "text-xs xl:text-sm text-primary/60 dark:text-white/60",
					children: "Aucune activité récente"
				})
			})]
		})
	});
}, Ha = ({ articles: e, title: t, className: n, maxItems: r, onArticleClick: i, onWidgetClick: a }) => {
	let o = r ? e.slice(0, r) : e, s = o.length > 0, c = (e) => {
		i && i(e);
	}, l = () => {
		a && a();
	};
	return /* @__PURE__ */ H("div", {
		className: J("h-full w-full dark:bg-amber-900 rounded-lg p-3 sm:p-3.5 md:p-4 lg:p-4 xl:p-6", a && "cursor-pointer", n),
		style: { backgroundColor: "var(--w-bg, #fef3c7)" },
		onClick: l,
		role: a ? "button" : void 0,
		tabIndex: a ? 0 : void 0,
		onKeyDown: a ? (e) => {
			(e.key === "Enter" || e.key === " ") && (e.preventDefault(), l());
		} : void 0,
		children: [/* @__PURE__ */ V("style", { children: Fa }), /* @__PURE__ */ H("div", {
			className: "flex h-full flex-col",
			children: [/* @__PURE__ */ H("div", {
				className: "flex items-center justify-between mb-3 xl:mb-4",
				children: [/* @__PURE__ */ H("div", {
					className: "flex items-center gap-1.5 xl:gap-2",
					children: [/* @__PURE__ */ V("div", {
						className: "rounded-lg dark:bg-amber-800 p-1.5 xl:p-2",
						style: { backgroundColor: "var(--w-bg-emphasis, #fde68a)" },
						children: /* @__PURE__ */ V(I, {
							size: 16,
							className: "xl:w-5 xl:h-5 dark:text-amber-400",
							style: { color: "var(--w-text, #d97706)" },
							"aria-hidden": "true"
						})
					}), /* @__PURE__ */ V("span", {
						className: "text-xs xl:text-sm font-semibold dark:text-amber-300",
						style: { color: "var(--w-text, #d97706)" },
						children: t
					})]
				}), /* @__PURE__ */ H("div", {
					className: "flex items-baseline gap-1",
					children: [/* @__PURE__ */ V("span", {
						className: "text-2xl xl:text-3xl font-bold dark:text-amber-200",
						style: { color: "var(--w-text-emphasis, #b45309)" },
						children: o.length
					}), /* @__PURE__ */ V("span", {
						className: "text-[10px] xl:text-xs font-medium dark:text-amber-400",
						style: { color: "var(--w-text-subtle, #f59e0b)" },
						children: "articles"
					})]
				})]
			}), s ? /* @__PURE__ */ V("div", {
				className: "bw-scroll flex-1 overflow-y-auto space-y-2 pr-1",
				children: o.map((e) => /* @__PURE__ */ V("div", {
					onClick: (t) => {
						i && (t.stopPropagation(), c(e));
					},
					role: i ? "button" : void 0,
					tabIndex: i ? 0 : void 0,
					onKeyDown: i ? (t) => {
						(t.key === "Enter" || t.key === " ") && (t.preventDefault(), t.stopPropagation(), c(e));
					} : void 0,
					children: /* @__PURE__ */ V(za, { article: e })
				}, e.id))
			}) : /* @__PURE__ */ V("div", {
				className: "flex-1 flex items-center justify-center",
				children: /* @__PURE__ */ V("p", {
					className: "text-xs xl:text-sm dark:text-amber-300/60",
					style: { color: "var(--w-text-muted, rgba(217,119,6,0.6))" },
					children: "Aucun article récent"
				})
			})]
		})]
	});
}, Ua = ({ variant: e, conversations: t = [], activities: n = [], articles: r = [], maxItems: i, title: a, isLoading: o = !1, className: s, onConversationClick: c, onActivityClick: l, onArticleClick: u, onWidgetClick: d, getActivityIcon: f }) => {
	if (o) return /* @__PURE__ */ V(Z, {
		rows: 3,
		className: s
	});
	switch (e) {
		case "chat": return /* @__PURE__ */ V(Ba, {
			conversations: t,
			title: a || "Chat",
			className: s,
			maxItems: i,
			onConversationClick: c,
			onWidgetClick: d
		});
		case "feed": return /* @__PURE__ */ V(Va, {
			activities: n,
			title: a || "Activites",
			className: s,
			maxItems: i,
			onActivityClick: l,
			onWidgetClick: d,
			getActivityIcon: f
		});
		case "blog": return /* @__PURE__ */ V(Ha, {
			articles: r,
			title: a || "Actualites",
			className: s,
			maxItems: i,
			onArticleClick: u,
			onWidgetClick: d
		});
		default: return /* @__PURE__ */ V(Ha, {
			articles: r,
			title: a || "Actualites",
			className: s,
			maxItems: i,
			onArticleClick: u,
			onWidgetClick: d
		});
	}
}, Wa = {
	"Noël des enfants": {
		color: "#f43f5e73",
		badge: "bg-rose-500/15",
		textColor: "text-rose-500"
	},
	"Noël des salariés": {
		color: "#ef444473",
		badge: "bg-red-500/15",
		textColor: "text-red-500"
	},
	"Fête Ste Catherine": {
		color: "#22c55e73",
		badge: "bg-green-500/15",
		textColor: "text-green-500"
	},
	"Fête des Mères": {
		color: "#ec489973",
		badge: "bg-pink-500/15",
		textColor: "text-pink-500"
	},
	"Fête des Pères": {
		color: "#3b82f673",
		badge: "bg-blue-500/15",
		textColor: "text-blue-500"
	},
	"Fête St Nicolas": {
		color: "#14b8a673",
		badge: "bg-teal-500/15",
		textColor: "text-teal-500"
	},
	"Départ en Retraite": {
		color: "#10b98173",
		badge: "bg-emerald-500/15",
		textColor: "text-emerald-500"
	},
	"Mariage / PACS": {
		color: "#d946ef73",
		badge: "bg-fuchsia-500/15",
		textColor: "text-fuchsia-500"
	},
	Naissance: {
		color: "#8b5cf673",
		badge: "bg-violet-500/15",
		textColor: "text-violet-500"
	},
	"Rentrée scolaire": {
		color: "#6366f173",
		badge: "bg-primary/15",
		textColor: "text-primary"
	},
	Culture: {
		color: "#84cc1673",
		badge: "bg-lime-500/15",
		textColor: "text-lime-500"
	},
	"Aide aux vacances": {
		color: "#f59e0b73",
		badge: "bg-amber-500/15",
		textColor: "text-amber-500"
	},
	Remboursement: {
		color: "#64748b73",
		badge: "bg-slate-500/15",
		textColor: "text-slate-500"
	},
	"Hors évènement": {
		color: "#78716c73",
		badge: "bg-stone-500/15",
		textColor: "text-stone-500"
	}
}, Ga = {
	color: "#64748b73",
	badge: "bg-slate-500/15",
	textColor: "text-slate-500"
}, Ka = (e) => Qt(new Intl.NumberFormat("fr-FR", {
	style: "currency",
	currency: "EUR"
}).format(e)), qa = (e) => Wa[e] ?? Ga, Ja = () => /* @__PURE__ */ H("div", {
	"data-testid": "stats-expenses-loading",
	className: "grid grid-cols-12 gap-6 items-start",
	children: [/* @__PURE__ */ V("div", {
		className: "md:col-span-6 col-span-12",
		children: /* @__PURE__ */ V("div", {
			className: "flex flex-col gap-5",
			children: Array.from({ length: 3 }).map((e, t) => /* @__PURE__ */ H("div", {
				className: "flex gap-3 items-center",
				children: [/* @__PURE__ */ V("div", { className: "w-10 h-10 bg-gray-200 dark:bg-gray-700 animate-pulse rounded-full" }), /* @__PURE__ */ H("div", {
					className: "flex-1",
					children: [/* @__PURE__ */ V("div", { className: "w-32 h-4 mb-1 bg-gray-200 dark:bg-gray-700 animate-pulse rounded" }), /* @__PURE__ */ V("div", { className: "w-24 h-8 bg-gray-200 dark:bg-gray-700 animate-pulse rounded" })]
				})]
			}, t))
		})
	}), /* @__PURE__ */ H("div", {
		className: "md:col-span-6 col-span-12 text-center",
		children: [
			/* @__PURE__ */ H("div", {
				className: "relative w-48 h-24 mx-auto mb-4",
				children: [/* @__PURE__ */ V("div", { className: "w-full h-full bg-gray-200 dark:bg-gray-700 animate-pulse rounded-t-full" }), /* @__PURE__ */ V("div", { className: "absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/3 w-36 h-20 bg-white dark:bg-gray-800 rounded-t-full" })]
			}),
			/* @__PURE__ */ V("div", { className: "w-24 h-8 mx-auto mb-3 bg-gray-200 dark:bg-gray-700 animate-pulse rounded" }),
			/* @__PURE__ */ V("div", { className: "w-40 h-4 mx-auto bg-gray-200 dark:bg-gray-700 animate-pulse rounded" })
		]
	})]
}), Ya = () => /* @__PURE__ */ V("div", {
	"data-testid": "stats-expenses-empty",
	className: "grid grid-cols-12 gap-6 items-center",
	children: /* @__PURE__ */ V("div", {
		className: "col-span-12 text-center text-gray-500 dark:text-gray-400",
		children: "Aucune donnée disponible"
	})
}), Xa = ({ event: e, amount: t }) => {
	let n = qa(e);
	return /* @__PURE__ */ H("div", {
		className: "flex gap-3 items-center",
		children: [/* @__PURE__ */ V("div", {
			className: J("flex items-center justify-center p-3 rounded-full", n.badge),
			children: /* @__PURE__ */ V(ot, {
				size: 20,
				style: { color: n.color.replace("73", "") }
			})
		}), /* @__PURE__ */ H("div", { children: [/* @__PURE__ */ V("p", {
			className: "text-gray-500 dark:text-gray-400",
			children: e
		}), /* @__PURE__ */ V("p", {
			className: "text-xl text-gray-900 dark:text-white",
			children: Ka(t)
		})] })]
	});
}, Za = (e, t, n, r) => ({
	x: e + n * Math.cos(r),
	y: t + n * Math.sin(r)
}), Q = (e) => e.toFixed(3), Qa = (e, t, n, r, i, a) => {
	let o = Za(e, t, r, i), s = Za(e, t, r, a), c = Za(e, t, n, i), l = Za(e, t, n, a), u = +(a - i > Math.PI);
	return [
		`M ${Q(o.x)} ${Q(o.y)}`,
		`A ${Q(r)} ${Q(r)} 0 ${u} 1 ${Q(s.x)} ${Q(s.y)}`,
		`L ${Q(l.x)} ${Q(l.y)}`,
		`A ${Q(n)} ${Q(n)} 0 ${u} 0 ${Q(c.x)} ${Q(c.y)}`,
		"Z"
	].join(" ");
}, $a = 200, eo = 120, to = $a / 2, no = 92, ro = 70, io = -Math.PI, ao = Math.PI, oo = "var(--color-surface-ld, #ffffff)", so = ({ data: e, totalExpense: t }) => {
	let n = t > 0 ? t : e.reduce((e, t) => e + t.expenseAmount, 0);
	if (n <= 0) return null;
	let r = io, i = e.filter((e) => e.expenseAmount > 0).map((e, t, i) => {
		let a = e.expenseAmount / n * ao, o = t === i.length - 1 ? io + ao : r + a, s = qa(e.event).color.replace("73", ""), c = {
			event: e.event,
			startAngle: r,
			endAngle: o,
			color: s
		};
		return r = o, c;
	});
	return /* @__PURE__ */ H("div", {
		"data-testid": "stats-expenses-chart",
		className: "text-center",
		children: [
			/* @__PURE__ */ V("svg", {
				className: "mx-auto block",
				width: $a,
				height: eo,
				viewBox: `0 0 ${$a} ${eo}`,
				role: "img",
				"aria-label": "Répartition des dépenses par évènement",
				children: i.map((e) => /* @__PURE__ */ V("path", {
					d: Qa(to, to, ro, no, e.startAngle, e.endAngle),
					fill: e.color,
					stroke: oo,
					strokeWidth: 2
				}, e.event))
			}),
			/* @__PURE__ */ V("p", {
				"data-testid": "total-expense",
				className: "text-3xl font-bold text-gray-700 dark:text-gray-300",
				children: Ka(t)
			}),
			/* @__PURE__ */ V("p", {
				className: "mt-1 text-xs text-gray-500 dark:text-gray-400",
				children: "Total de vos dépenses"
			})
		]
	});
};
function co({ expensesByEvent: e, maxItems: t = 4, title: n = "Mes dépenses par évènement", isLoading: r = !1, className: i }) {
	let a = e.reduce((e, t) => e + t.expenseAmount, 0), o = e.slice(0, t);
	return r ? /* @__PURE__ */ H(X, {
		className: i,
		children: [/* @__PURE__ */ V("h2", {
			className: "text-base font-bold text-gray-900 dark:text-white mb-4",
			children: n
		}), /* @__PURE__ */ V(Ja, {})]
	}) : e.length === 0 || a === 0 ? /* @__PURE__ */ H(X, {
		className: i,
		children: [/* @__PURE__ */ V("h2", {
			className: "text-base font-bold text-gray-900 dark:text-white mb-4",
			children: n
		}), /* @__PURE__ */ V(Ya, {})]
	}) : /* @__PURE__ */ H(X, {
		className: i,
		children: [/* @__PURE__ */ V("h2", {
			className: "text-base font-bold text-gray-900 dark:text-white mb-4",
			children: n
		}), /* @__PURE__ */ H("div", {
			"data-testid": "stats-expenses-report",
			className: "grid grid-cols-12 gap-6 items-start",
			children: [/* @__PURE__ */ V("div", {
				className: "md:col-span-6 col-span-12",
				children: /* @__PURE__ */ V("div", {
					"data-testid": "stats-expenses-list",
					className: "flex flex-col gap-5",
					children: o.map((e) => /* @__PURE__ */ V(Xa, {
						event: e.event,
						amount: e.expenseAmount
					}, e.event))
				})
			}), /* @__PURE__ */ V("div", {
				className: "md:col-span-6 col-span-12",
				children: /* @__PURE__ */ V(so, {
					data: e,
					totalExpense: a
				})
			})]
		})]
	});
}
//#endregion
//#region src/components/widgets/FileManagerWidget.tsx
var lo = 8, uo = 6, fo = "#EFF6FF", po = "\n  .fmw-container-hover:hover { background-color: var(--w-bg-subtle, rgba(191,219,254,0.6)) !important; }\n  .fmw-item-hover:hover { background-color: var(--w-bg-hover, #bfdbfe) !important; }\n  .fmw-dl-hover:hover { color: var(--w-accent, #3b82f6) !important; }\n  .fmw-scroll {\n    scrollbar-width: thin;\n    scrollbar-color: var(--w-scrollbar, rgba(59,130,246,0.4)) transparent;\n  }\n  .fmw-scroll::-webkit-scrollbar { width: 6px; }\n  .fmw-scroll::-webkit-scrollbar-track { background: transparent; }\n  .fmw-scroll::-webkit-scrollbar-thumb {\n    background: var(--w-scrollbar, rgba(59,130,246,0.4));\n    border-radius: 3px;\n  }\n  .fmw-scroll::-webkit-scrollbar-thumb:hover {\n    background: var(--w-scrollbar-hover, rgba(59,130,246,0.6));\n  }\n", mo = { Icon: ce }, $ = {
	pdf: { Icon: P },
	doc: { Icon: P },
	docx: { Icon: P },
	odt: { Icon: P },
	rtf: { Icon: P },
	txt: { Icon: P },
	xls: { Icon: fe },
	xlsx: { Icon: fe },
	csv: { Icon: fe },
	ods: { Icon: fe },
	ppt: { Icon: rt },
	pptx: { Icon: rt },
	odp: { Icon: rt },
	jpg: { Icon: F },
	jpeg: { Icon: F },
	png: { Icon: F },
	gif: { Icon: F },
	webp: { Icon: F },
	svg: { Icon: F },
	heic: { Icon: F },
	mp4: { Icon: pe },
	mov: { Icon: pe },
	avi: { Icon: pe },
	mkv: { Icon: pe },
	webm: { Icon: pe },
	mp3: { Icon: ue },
	wav: { Icon: ue },
	flac: { Icon: ue },
	ogg: { Icon: ue },
	zip: { Icon: le },
	rar: { Icon: le },
	"7z": { Icon: le },
	tar: { Icon: le },
	gz: { Icon: le }
};
function ho(e) {
	let t = e.lastIndexOf(".");
	if (!(t <= 0 || t === e.length - 1)) return e.slice(t + 1).toLowerCase();
}
function go(e, t) {
	let n = ho(e);
	return n && $[n] ? $[n] : t === "application/pdf" ? $.pdf : t.startsWith("image/") ? $.jpg : t.startsWith("video/") ? $.mp4 : t.startsWith("audio/") ? $.mp3 : t.includes("spreadsheet") || t.includes("excel") || t === "text/csv" ? $.csv : t.includes("presentation") || t.includes("powerpoint") ? $.ppt : t.includes("word") || t === "application/vnd.oasis.opendocument.text" ? $.doc : t.includes("zip") || t.includes("rar") || t.includes("tar") || t.includes("gzip") || t.includes("7z") ? $.zip : t.startsWith("text/") ? $.txt : mo;
}
function _o(e) {
	if (e < 1024) return `${e} o`;
	if (e < 1048576) {
		let t = e / 1024;
		return `${t % 1 == 0 ? t : t.toFixed(1)} Ko`;
	}
	let t = e / 1048576;
	return `${t % 1 == 0 ? t : t.toFixed(1)} Mo`;
}
function vo(e) {
	let t = new Date(e), n = /* @__PURE__ */ new Date(), r = new Date(n.getFullYear(), n.getMonth(), n.getDate()), i = new Date(t.getFullYear(), t.getMonth(), t.getDate()), a = Math.round((r.getTime() - i.getTime()) / 864e5);
	return a === 0 ? "aujourd'hui" : a === 1 ? "hier" : a <= 6 ? `il y a ${a} jours` : t.toLocaleDateString("fr-FR", {
		day: "2-digit",
		month: "2-digit",
		year: "numeric"
	});
}
function yo(e, t) {
	return e === void 0 ? t === "grid" ? uo : lo : e;
}
var bo = ({ file: e, compactPreview: t, onFileClick: n, onDownload: r }) => {
	let { Icon: i } = go(e.name, e.mimeType), a = _o(e.byteSize);
	return /* @__PURE__ */ H("div", {
		role: "button",
		tabIndex: 0,
		className: "fmw-item-hover flex items-center gap-2 rounded-lg dark:bg-blue-800/30 px-3 py-2.5 transition-colors dark:hover:bg-blue-800/50 cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-400",
		style: { backgroundColor: "var(--w-bg-subtle, rgba(191,219,254,0.6))" },
		onClick: () => n?.(e),
		onKeyDown: (t) => {
			(t.key === "Enter" || t.key === " ") && (t.preventDefault(), n?.(e));
		},
		"aria-label": `${e.name} — ${a}`,
		"data-testid": `file-row-${e.id}`,
		children: [
			/* @__PURE__ */ V(i, {
				size: 16,
				className: "dark:text-blue-400 flex-shrink-0",
				style: { color: "var(--w-accent, #3b82f6)" },
				"aria-hidden": "true"
			}),
			/* @__PURE__ */ H("div", {
				className: "flex-1 min-w-0",
				children: [/* @__PURE__ */ V("p", {
					className: "text-xs xl:text-sm font-medium dark:text-blue-200 truncate",
					style: { color: "var(--w-text-emphasis, #1e3a8a)" },
					children: e.name
				}), /* @__PURE__ */ H("div", {
					className: "flex items-center gap-0 mt-0.5 text-[10px] xl:text-xs dark:text-blue-300/60",
					style: { color: "var(--w-text-muted, rgba(30,64,175,0.6))" },
					children: [
						!t && e.folderName && /* @__PURE__ */ H(B, { children: [/* @__PURE__ */ V("span", {
							className: "truncate max-w-[110px] inline-block",
							children: e.folderName
						}), /* @__PURE__ */ V("span", {
							className: "mx-1",
							children: "·"
						})] }),
						/* @__PURE__ */ V("span", { children: a }),
						!t && /* @__PURE__ */ H(B, { children: [/* @__PURE__ */ V("span", {
							className: "mx-1",
							children: "·"
						}), /* @__PURE__ */ V("span", { children: vo(e.createdAt) })] })
					]
				})]
			}),
			/* @__PURE__ */ V("button", {
				type: "button",
				className: "fmw-dl-hover flex-shrink-0 p-1.5 rounded-md opacity-0 group-hover:opacity-100 focus:opacity-100 transition-all dark:text-blue-400/60 dark:hover:text-blue-300",
				style: { color: "var(--w-text-muted, rgba(30,64,175,0.6))" },
				onClick: (t) => {
					t.stopPropagation(), r?.(e);
				},
				"aria-label": `Télécharger ${e.name}`,
				"data-testid": `download-btn-${e.id}`,
				tabIndex: 0,
				children: /* @__PURE__ */ V(se, {
					size: 14,
					"aria-hidden": "true"
				})
			})
		]
	});
}, xo = ({ file: e, onFileClick: t, onDownload: n }) => {
	let { Icon: r } = go(e.name, e.mimeType), i = _o(e.byteSize);
	return /* @__PURE__ */ H("div", {
		role: "button",
		tabIndex: 0,
		className: "fmw-item-hover group relative flex flex-col items-center gap-1.5 p-3 rounded-xl cursor-pointer transition-colors text-center dark:bg-blue-800/30 dark:hover:bg-blue-800/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-400",
		style: { backgroundColor: "var(--w-bg-subtle, rgba(191,219,254,0.6))" },
		onClick: () => t?.(e),
		onKeyDown: (n) => {
			(n.key === "Enter" || n.key === " ") && (n.preventDefault(), t?.(e));
		},
		"aria-label": `${e.name} — ${i}`,
		"data-testid": `file-tile-${e.id}`,
		children: [
			/* @__PURE__ */ V(r, {
				size: 20,
				className: "dark:text-blue-400 flex-shrink-0",
				style: { color: "var(--w-accent, #3b82f6)" },
				"aria-hidden": "true"
			}),
			/* @__PURE__ */ V("span", {
				className: "text-xs font-medium dark:text-blue-200 text-center line-clamp-2 w-full",
				style: { color: "var(--w-text-emphasis, #1e3a8a)" },
				children: e.name
			}),
			/* @__PURE__ */ V("span", {
				className: "text-[10px] dark:text-blue-300/60 whitespace-nowrap",
				style: { color: "var(--w-text-muted, rgba(30,64,175,0.6))" },
				children: i
			}),
			/* @__PURE__ */ V("button", {
				type: "button",
				className: "fmw-dl-hover absolute top-1.5 right-1.5 p-1 rounded opacity-0 group-hover:opacity-100 focus:opacity-100 transition-all dark:text-blue-400/60 dark:hover:text-blue-300",
				style: { color: "var(--w-text-muted, rgba(30,64,175,0.6))" },
				onClick: (t) => {
					t.stopPropagation(), n?.(e);
				},
				"aria-label": `Télécharger ${e.name}`,
				"data-testid": `download-btn-${e.id}`,
				children: /* @__PURE__ */ V(se, {
					size: 14,
					"aria-hidden": "true"
				})
			})
		]
	});
};
function So({ files: e, variant: t = "list", maxItems: n, title: r = "Gestionnaire de fichiers", backgroundColor: i = fo, className: a, isLoading: o = !1, compactPreview: s = !1, onFileClick: c, onDownload: l }) {
	if (o) return /* @__PURE__ */ V(Z, {
		rows: 3,
		className: a
	});
	let u = yo(n, t), d = e.slice(0, u), f = e.length, p = rn(i);
	return d.length === 0 ? /* @__PURE__ */ H("div", {
		className: J("h-full w-full dark:bg-blue-900 rounded-lg p-3 sm:p-3.5 md:p-4 lg:p-4 xl:p-6", a),
		style: {
			backgroundColor: "var(--w-bg, #eff6ff)",
			...p
		},
		children: [/* @__PURE__ */ V("style", { children: po }), /* @__PURE__ */ H("div", {
			className: "flex h-full flex-col",
			children: [/* @__PURE__ */ H("div", {
				className: "flex items-center justify-between mb-3 xl:mb-4",
				children: [/* @__PURE__ */ H("div", {
					className: "flex items-center gap-1.5 xl:gap-2",
					children: [/* @__PURE__ */ V("div", {
						className: "rounded-lg dark:bg-blue-800 p-1.5 xl:p-2",
						style: { backgroundColor: "var(--w-bg-emphasis, #bfdbfe)" },
						children: /* @__PURE__ */ V(he, {
							size: 16,
							className: "xl:w-5 xl:h-5 dark:text-blue-300",
							style: { color: "var(--w-text-emphasis, #1e40af)" },
							"aria-hidden": "true"
						})
					}), /* @__PURE__ */ V("span", {
						className: "text-xs xl:text-sm font-semibold dark:text-blue-300",
						style: { color: "var(--w-text-emphasis, #1e40af)" },
						children: r
					})]
				}), /* @__PURE__ */ H("div", {
					className: "flex items-baseline gap-1",
					children: [/* @__PURE__ */ V("span", {
						className: "text-2xl xl:text-3xl font-bold dark:text-blue-100",
						style: { color: "var(--w-text-emphasis, #1e3a8a)" },
						children: "0"
					}), /* @__PURE__ */ V("span", {
						className: "text-[10px] xl:text-xs font-medium dark:text-blue-400",
						style: { color: "var(--w-text-subtle, #3b82f6)" },
						children: "fichiers"
					})]
				})]
			}), /* @__PURE__ */ V("div", {
				className: "flex-1 flex items-center justify-center",
				children: /* @__PURE__ */ V("p", {
					className: "text-xs xl:text-sm dark:text-blue-200/60",
					style: { color: "var(--w-text-muted, rgba(30,64,175,0.6))" },
					children: "Aucun fichier disponible"
				})
			})]
		})]
	}) : /* @__PURE__ */ H("div", {
		className: J("h-full w-full dark:bg-blue-900 rounded-lg p-3 sm:p-3.5 md:p-4 lg:p-4 xl:p-6", a),
		style: {
			backgroundColor: "var(--w-bg, #eff6ff)",
			...p
		},
		children: [/* @__PURE__ */ V("style", { children: po }), /* @__PURE__ */ H("div", {
			className: "flex h-full flex-col",
			children: [/* @__PURE__ */ H("div", {
				className: "flex items-center justify-between mb-3 xl:mb-4",
				children: [/* @__PURE__ */ H("div", {
					className: "flex items-center gap-1.5 xl:gap-2",
					children: [/* @__PURE__ */ V("div", {
						className: "rounded-lg dark:bg-blue-800 p-1.5 xl:p-2",
						style: { backgroundColor: "var(--w-bg-emphasis, #bfdbfe)" },
						children: /* @__PURE__ */ V(he, {
							size: 16,
							className: "xl:w-5 xl:h-5 dark:text-blue-300",
							style: { color: "var(--w-text-emphasis, #1e40af)" },
							"aria-hidden": "true"
						})
					}), /* @__PURE__ */ V("span", {
						className: "text-xs xl:text-sm font-semibold dark:text-blue-300",
						style: { color: "var(--w-text-emphasis, #1e40af)" },
						children: r
					})]
				}), /* @__PURE__ */ H("div", {
					className: "flex items-baseline gap-1",
					children: [/* @__PURE__ */ V("span", {
						className: "text-2xl xl:text-3xl font-bold dark:text-blue-100",
						style: { color: "var(--w-text-emphasis, #1e3a8a)" },
						children: f
					}), /* @__PURE__ */ H("span", {
						className: "text-[10px] xl:text-xs font-medium dark:text-blue-400",
						style: { color: "var(--w-text-subtle, #3b82f6)" },
						children: ["fichier", f > 1 ? "s" : ""]
					})]
				})]
			}), t === "grid" ? /* @__PURE__ */ V("div", {
				className: "grid grid-cols-2 gap-2",
				"data-testid": "file-manager-grid",
				children: d.map((e) => /* @__PURE__ */ V(xo, {
					file: e,
					compactPreview: s,
					onFileClick: c,
					onDownload: l
				}, e.id))
			}) : /* @__PURE__ */ V("div", {
				className: "fmw-scroll flex-1 overflow-y-auto space-y-2 pr-1",
				"data-testid": "file-manager-list",
				children: d.map((e) => /* @__PURE__ */ V(bo, {
					file: e,
					compactPreview: s,
					onFileClick: c,
					onDownload: l
				}, e.id))
			})]
		})]
	});
}
//#endregion
//#region src/components/widgets/ClassifiedAdsWidget.tsx
var Co = {
	gift: "Don",
	wanted: "Recherche",
	swap: "Échange",
	sale: "Vente"
}, wo = {
	gift: "bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-300",
	wanted: "bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300",
	swap: "bg-purple-100 text-purple-700 dark:bg-purple-900/40 dark:text-purple-300",
	sale: "bg-orange-100 text-orange-700 dark:bg-orange-900/40 dark:text-orange-300"
}, To = "\n  .caw-item-hover:hover { background-color: var(--w-bg-hover, #99f6e4) !important; }\n", Eo = (e) => Qt(new Intl.NumberFormat("fr-FR", {
	style: "currency",
	currency: "EUR"
}).format(e / 100)), Do = ({ photoUrl: e, title: t }) => e ? /* @__PURE__ */ V("img", {
	src: e,
	alt: t,
	className: "w-12 h-12 rounded-lg object-cover flex-shrink-0"
}) : /* @__PURE__ */ V("div", {
	className: "w-12 h-12 rounded-lg flex-shrink-0 flex items-center justify-center bg-gray-100 dark:bg-gray-700",
	"aria-hidden": "true",
	children: /* @__PURE__ */ V(Ee, {
		size: 18,
		className: "text-gray-400 dark:text-gray-500"
	})
}), Oo = ({ ad: e, onAdClick: t }) => /* @__PURE__ */ H("div", {
	className: J("caw-item-hover flex items-center gap-3 rounded-lg px-3 py-2.5 transition-colors", "dark:bg-teal-900/40", t && "cursor-pointer dark:hover:bg-teal-800/50"),
	style: { backgroundColor: "var(--w-bg-subtle, rgba(204,251,241,0.6))" },
	onClick: (n) => {
		t && (n.stopPropagation(), t(e));
	},
	role: t ? "button" : void 0,
	tabIndex: t ? 0 : void 0,
	onKeyDown: t ? (n) => {
		t && (n.key === "Enter" || n.key === " ") && (n.preventDefault(), n.stopPropagation(), t(e));
	} : void 0,
	children: [/* @__PURE__ */ V(Do, {
		photoUrl: e.photoUrl,
		title: e.title
	}), /* @__PURE__ */ H("div", {
		className: "flex-1 min-w-0",
		children: [/* @__PURE__ */ V("p", {
			className: "text-xs xl:text-sm font-medium dark:text-teal-100 truncate",
			style: { color: "var(--w-text-emphasis, #115e59)" },
			children: e.title
		}), /* @__PURE__ */ H("div", {
			className: "flex items-center gap-1.5 mt-0.5 flex-wrap",
			children: [
				/* @__PURE__ */ V("span", {
					className: J("text-[10px] xl:text-xs font-medium px-1.5 py-0.5 rounded-full", wo[e.kind]),
					children: Co[e.kind]
				}),
				e.categoryName && /* @__PURE__ */ V("span", {
					className: "text-[10px] xl:text-xs dark:text-teal-300/70 truncate",
					style: { color: "var(--w-text, #0f766e)" },
					children: e.categoryName
				}),
				e.kind === "sale" && /* @__PURE__ */ V("span", {
					className: "text-[10px] xl:text-xs font-semibold dark:text-teal-200 ml-auto flex-shrink-0",
					style: { color: "var(--w-text-emphasis, #115e59)" },
					children: Eo(e.priceCents ?? 0)
				})
			]
		})]
	})]
}), ko = ({ ads: e, maxItems: t = 3, title: n = "Petites annonces", subtitle: r, className: i, isLoading: a = !1, onAdClick: o, onWidgetClick: s }) => {
	if (a) return /* @__PURE__ */ V(Z, { rows: 3 });
	let c = e.slice(0, t), l = c.length > 0, u = () => {
		s && s();
	};
	return /* @__PURE__ */ H("div", {
		className: J("h-full w-full dark:bg-teal-950 rounded-lg p-3 sm:p-3.5 md:p-4 lg:p-4 xl:p-6", s && "cursor-pointer", i),
		style: { backgroundColor: "var(--w-bg, #f0fdfa)" },
		onClick: u,
		role: s ? "button" : void 0,
		tabIndex: s ? 0 : void 0,
		onKeyDown: s ? (e) => {
			(e.key === "Enter" || e.key === " ") && (e.preventDefault(), u());
		} : void 0,
		children: [/* @__PURE__ */ V("style", { children: To }), /* @__PURE__ */ H("div", {
			className: "flex h-full flex-col",
			children: [/* @__PURE__ */ H("div", {
				className: "flex items-center justify-between mb-3 xl:mb-4",
				children: [/* @__PURE__ */ H("div", {
					className: "flex items-center gap-1.5 xl:gap-2",
					children: [/* @__PURE__ */ V("div", {
						className: "rounded-lg dark:bg-teal-800 p-1.5 xl:p-2",
						style: { backgroundColor: "var(--w-bg-emphasis, #ccfbf1)" },
						children: /* @__PURE__ */ V(yt, {
							size: 16,
							className: "xl:w-5 xl:h-5 dark:text-teal-300",
							style: { color: "var(--w-text, #0f766e)" },
							"aria-hidden": "true"
						})
					}), /* @__PURE__ */ H("div", { children: [/* @__PURE__ */ V("span", {
						className: "text-xs xl:text-sm font-semibold dark:text-teal-300",
						style: { color: "var(--w-text, #0f766e)" },
						children: n
					}), r && /* @__PURE__ */ V("p", {
						className: "text-[10px] xl:text-xs dark:text-teal-400/70 leading-tight",
						style: { color: "var(--w-text-muted, #0f766e)" },
						children: r
					})] })]
				}), /* @__PURE__ */ H("div", {
					className: "flex items-baseline gap-1",
					children: [/* @__PURE__ */ V("span", {
						className: "text-2xl xl:text-3xl font-bold dark:text-teal-100",
						style: { color: "var(--w-text-emphasis, #115e59)" },
						children: e.length
					}), /* @__PURE__ */ H("span", {
						className: "text-[10px] xl:text-xs font-medium dark:text-teal-300",
						style: { color: "var(--w-text-muted, #0f766e)" },
						children: ["annonce", e.length === 1 ? "" : "s"]
					})]
				})]
			}), l ? /* @__PURE__ */ V("div", {
				className: "flex-1 space-y-2 overflow-y-auto",
				children: c.map((e) => /* @__PURE__ */ V(Oo, {
					ad: e,
					onAdClick: o
				}, e.id))
			}) : /* @__PURE__ */ V("div", {
				className: "flex-1 flex items-center justify-center",
				children: /* @__PURE__ */ V("p", {
					className: "text-xs xl:text-sm dark:text-teal-200/60",
					style: { color: "var(--w-text-muted, #0f766e)" },
					children: "Aucune annonce pour le moment"
				})
			})]
		})]
	});
}, Ao = {
	hebergement: "Hébergement",
	materiel: "Matériel",
	vehicule: "Véhicule",
	salle: "Salle",
	emplacement: "Emplacement",
	livre: "Livre",
	voyage: "Voyage"
}, jo = {
	hebergement: "bg-blue-100 text-blue-700 dark:bg-blue-800 dark:text-blue-100",
	materiel: "bg-orange-100 text-orange-700 dark:bg-orange-800 dark:text-orange-100",
	vehicule: "bg-purple-100 text-purple-700 dark:bg-purple-800 dark:text-purple-100",
	salle: "bg-teal-100 text-teal-700 dark:bg-teal-800 dark:text-teal-100",
	emplacement: "bg-green-100 text-green-700 dark:bg-green-800 dark:text-green-100",
	livre: "bg-yellow-100 text-yellow-700 dark:bg-yellow-800 dark:text-yellow-100",
	voyage: "bg-rose-100 text-rose-700 dark:bg-rose-800 dark:text-rose-100"
}, Mo = "\n  .rnw-item-hover:hover { background-color: var(--w-bg-hover, #dbeafe) !important; }\n", No = (e) => Qt(new Intl.NumberFormat("fr-FR", {
	style: "currency",
	currency: "EUR"
}).format(e / 100)), Po = (e) => new Date(e).toLocaleDateString("fr-FR", {
	day: "numeric",
	month: "short"
}), Fo = ({ imageUrl: e, itemName: t }) => e ? /* @__PURE__ */ V("img", {
	src: e,
	alt: t,
	className: "w-12 h-12 rounded-lg object-cover flex-shrink-0"
}) : /* @__PURE__ */ V("div", {
	className: "w-12 h-12 rounded-lg flex-shrink-0 flex items-center justify-center bg-blue-50 dark:bg-blue-900/30",
	"aria-hidden": "true",
	children: /* @__PURE__ */ V(Ee, {
		size: 18,
		className: "text-blue-300 dark:text-blue-500"
	})
}), Io = ({ booking: e, onBookingClick: t }) => {
	let n = (n) => {
		t && (n.stopPropagation(), t(e));
	}, r = (n) => {
		t && (n.key === "Enter" || n.key === " ") && (n.preventDefault(), n.stopPropagation(), t(e));
	}, i = e.startDate ?? e.endDate;
	return /* @__PURE__ */ H("div", {
		className: J("rnw-item-hover flex items-center gap-3 rounded-lg px-3 py-2.5 transition-colors", "dark:bg-blue-900/40", t && "cursor-pointer dark:hover:bg-blue-800/50"),
		style: { backgroundColor: "var(--w-bg-subtle, rgba(219,234,254,0.6))" },
		onClick: n,
		role: t ? "button" : void 0,
		tabIndex: t ? 0 : void 0,
		onKeyDown: t ? r : void 0,
		children: [/* @__PURE__ */ V(Fo, {
			imageUrl: e.imageUrl,
			itemName: e.itemName
		}), /* @__PURE__ */ H("div", {
			className: "flex-1 min-w-0",
			children: [/* @__PURE__ */ V("p", {
				className: "text-xs xl:text-sm font-medium dark:text-blue-100 truncate",
				style: { color: "var(--w-text-emphasis, #1e3a5f)" },
				children: e.itemName
			}), /* @__PURE__ */ H("div", {
				className: "flex items-center gap-1.5 mt-0.5 flex-wrap",
				children: [
					/* @__PURE__ */ V("span", {
						className: J("text-[10px] xl:text-xs font-medium px-1.5 py-0.5 rounded-full", jo[e.kind]),
						children: Ao[e.kind]
					}),
					/* @__PURE__ */ V("span", {
						className: "text-[10px] xl:text-xs font-medium px-1.5 py-0.5 rounded-full bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300",
						children: e.statusLabel
					}),
					i && /* @__PURE__ */ H("span", {
						className: "text-[10px] xl:text-xs dark:text-blue-300/70 flex items-center gap-0.5 truncate",
						style: { color: "var(--w-text, #1d4ed8)" },
						children: [
							/* @__PURE__ */ V(b, {
								size: 10,
								"aria-hidden": "true"
							}),
							e.startDate ? Po(e.startDate) : "",
							e.startDate && e.endDate ? " – " : "",
							e.endDate ? Po(e.endDate) : ""
						]
					}),
					e.amountCents != null && /* @__PURE__ */ V("span", {
						className: "text-[10px] xl:text-xs font-semibold dark:text-blue-200 ml-auto flex-shrink-0",
						style: { color: "var(--w-text-emphasis, #1e3a5f)" },
						children: No(e.amountCents)
					})
				]
			})]
		})]
	});
}, Lo = ({ bookings: e, maxItems: t = 3, title: n = "Mes locations", subtitle: r, backgroundColor: i, className: a, isLoading: o = !1, onBookingClick: s, onWidgetClick: c }) => {
	if (o) return /* @__PURE__ */ V(Z, { rows: 3 });
	let l = e.slice(0, t), u = l.length > 0, d = () => {
		c && c();
	};
	return /* @__PURE__ */ H("div", {
		className: J("h-full w-full dark:bg-blue-950 rounded-lg p-3 sm:p-3.5 md:p-4 lg:p-4 xl:p-6", c && "cursor-pointer", a),
		style: { backgroundColor: i ?? "var(--w-bg, #eff6ff)" },
		onClick: d,
		role: c ? "button" : void 0,
		tabIndex: c ? 0 : void 0,
		onKeyDown: c ? (e) => {
			(e.key === "Enter" || e.key === " ") && (e.preventDefault(), d());
		} : void 0,
		children: [/* @__PURE__ */ V("style", { children: Mo }), /* @__PURE__ */ H("div", {
			className: "flex h-full flex-col",
			children: [/* @__PURE__ */ H("div", {
				className: "flex items-center justify-between mb-3 xl:mb-4",
				children: [/* @__PURE__ */ H("div", {
					className: "flex items-center gap-1.5 xl:gap-2",
					children: [/* @__PURE__ */ V("div", {
						className: "rounded-lg dark:bg-blue-800 p-1.5 xl:p-2",
						style: { backgroundColor: "var(--w-bg-emphasis, #dbeafe)" },
						children: /* @__PURE__ */ V(Oe, {
							size: 16,
							className: "xl:w-5 xl:h-5 dark:text-blue-300",
							style: { color: "var(--w-text, #1d4ed8)" },
							"aria-hidden": "true"
						})
					}), /* @__PURE__ */ H("div", { children: [/* @__PURE__ */ V("span", {
						className: "text-xs xl:text-sm font-semibold dark:text-blue-300",
						style: { color: "var(--w-text, #1d4ed8)" },
						children: n
					}), r && /* @__PURE__ */ V("p", {
						className: "text-[10px] xl:text-xs dark:text-blue-400/70 leading-tight",
						style: { color: "var(--w-text-muted, #1d4ed8)" },
						children: r
					})] })]
				}), /* @__PURE__ */ H("div", {
					className: "flex items-baseline gap-1",
					children: [/* @__PURE__ */ V("span", {
						className: "text-2xl xl:text-3xl font-bold dark:text-blue-100",
						style: { color: "var(--w-text-emphasis, #1e3a5f)" },
						children: e.length
					}), /* @__PURE__ */ H("span", {
						className: "text-[10px] xl:text-xs font-medium dark:text-blue-300",
						style: { color: "var(--w-text-muted, #1d4ed8)" },
						children: ["location", e.length === 1 ? "" : "s"]
					})]
				})]
			}), u ? /* @__PURE__ */ V("div", {
				className: "flex-1 space-y-2 overflow-y-auto",
				children: l.map((e) => /* @__PURE__ */ V(Io, {
					booking: e,
					onBookingClick: s
				}, e.id))
			}) : /* @__PURE__ */ H("div", {
				className: "flex-1 flex flex-col items-center justify-center gap-2",
				children: [
					/* @__PURE__ */ V(Oe, {
						size: 24,
						className: "dark:text-blue-700",
						style: { color: "var(--w-text-muted, #93c5fd)" },
						"aria-hidden": "true"
					}),
					/* @__PURE__ */ V("p", {
						className: "text-xs xl:text-sm dark:text-blue-200/60 text-center",
						style: { color: "var(--w-text-muted, #1d4ed8)" },
						children: "Aucune location"
					}),
					c && /* @__PURE__ */ V("button", {
						className: "text-[10px] xl:text-xs font-medium underline underline-offset-2 dark:text-blue-400 mt-0.5",
						style: { color: "var(--w-text, #1d4ed8)" },
						onClick: (e) => {
							e.stopPropagation(), c();
						},
						tabIndex: -1,
						"aria-label": "Voir toutes mes locations",
						children: "Voir mes réservations"
					})
				]
			})]
		})]
	});
}, Ro = {
	label: "Soumis",
	className: "bg-sky-100 text-sky-700 dark:bg-sky-900/40 dark:text-sky-300",
	withCheck: !0
}, zo = {
	submitted: Ro,
	opted_out: Ro,
	validated: {
		label: "Validé",
		className: "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300",
		withCheck: !0
	},
	waiting: {
		label: "À compléter",
		className: "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300",
		withCheck: !1
	},
	refused: {
		label: "Refusé",
		className: "bg-rose-100 text-rose-700 dark:bg-rose-900/40 dark:text-rose-300",
		withCheck: !1
	}
}, Bo = "bg-teal-100 text-teal-700 dark:bg-teal-900/40 dark:text-teal-300", Vo = "bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300", Ho = "\n  .fmw-item-hover:hover { background-color: var(--w-bg-hover, #99f6e4) !important; }\n", Uo = (e) => new Date(e).toLocaleDateString("fr-FR", {
	day: "numeric",
	month: "short"
}), Wo = ({ form: e, onFormClick: t }) => {
	let n = (n) => {
		t && (n.stopPropagation(), t(e.id));
	}, r = (n) => {
		t && (n.key === "Enter" || n.key === " ") && (n.preventDefault(), n.stopPropagation(), t(e.id));
	}, i = e.submissionStatus ? zo[e.submissionStatus] : void 0;
	return /* @__PURE__ */ H("div", {
		className: J("fmw-item-hover rounded-lg px-3 py-2.5 transition-colors", "dark:bg-teal-900/40", t && "cursor-pointer dark:hover:bg-teal-800/50"),
		style: { backgroundColor: "var(--w-bg-subtle, rgba(204,251,241,0.6))" },
		onClick: n,
		role: t ? "button" : void 0,
		tabIndex: t ? 0 : void 0,
		onKeyDown: t ? r : void 0,
		children: [/* @__PURE__ */ H("div", {
			className: "flex items-start gap-2",
			children: [/* @__PURE__ */ V("p", {
				className: "flex-1 min-w-0 text-xs xl:text-sm font-medium dark:text-teal-100 truncate",
				style: { color: "var(--w-text-emphasis, #134e4a)" },
				children: e.title
			}), i && /* @__PURE__ */ H("span", {
				className: J("flex items-center gap-0.5 flex-shrink-0 text-[10px] xl:text-xs font-medium px-1.5 py-0.5 rounded-full", i.className),
				children: [i.withCheck && /* @__PURE__ */ V(w, {
					size: 10,
					"aria-hidden": "true"
				}), i.label]
			})]
		}), /* @__PURE__ */ H("div", {
			className: "flex items-center gap-1.5 mt-0.5 flex-wrap",
			children: [e.isClosed != null && /* @__PURE__ */ V("span", {
				className: J("text-[10px] xl:text-xs font-medium px-1.5 py-0.5 rounded-full", e.isClosed ? Vo : Bo),
				children: e.isClosed ? "Clôturé" : "En cours"
			}), e.deadline && /* @__PURE__ */ H("span", {
				className: "text-[10px] xl:text-xs dark:text-teal-300/70 flex items-center gap-0.5 flex-shrink-0 ml-auto",
				style: { color: "var(--w-text-muted, #14b8a6)" },
				children: [/* @__PURE__ */ V(b, {
					size: 10,
					"aria-hidden": "true"
				}), Uo(e.deadline)]
			})]
		})]
	});
}, Go = ({ forms: e, activeCount: t, title: n = "Formulaires", subtitle: r, backgroundColor: i, icon: a, className: o, isPreview: s = !1, isLoading: c = !1, onFormClick: l, onWidgetClick: u }) => {
	if (c) return /* @__PURE__ */ V(Z, { rows: 3 });
	let d = on(a) ?? j, f = e.length > 0, p = () => {
		u && u();
	};
	return /* @__PURE__ */ H("div", {
		className: J("h-full w-full dark:bg-teal-950 rounded-lg p-3 sm:p-3.5 md:p-4 lg:p-4 xl:p-6", u && "cursor-pointer", s && "pointer-events-none", o),
		style: { backgroundColor: i ?? "var(--w-bg, #f0fdfa)" },
		onClick: p,
		role: u ? "button" : void 0,
		tabIndex: u ? 0 : void 0,
		onKeyDown: u ? (e) => {
			(e.key === "Enter" || e.key === " ") && (e.preventDefault(), p());
		} : void 0,
		children: [/* @__PURE__ */ V("style", { children: Ho }), /* @__PURE__ */ H("div", {
			className: "flex h-full flex-col",
			children: [
				/* @__PURE__ */ H("div", {
					className: "flex items-center justify-between gap-2 mb-3 xl:mb-4",
					children: [/* @__PURE__ */ H("div", {
						className: "flex items-center gap-1.5 xl:gap-2 min-w-0",
						children: [/* @__PURE__ */ V("div", {
							className: "rounded-lg dark:bg-teal-800 p-1.5 xl:p-2 flex-shrink-0",
							style: { backgroundColor: "var(--w-bg-emphasis, #ccfbf1)" },
							children: /* @__PURE__ */ V(d, {
								size: 16,
								className: "xl:w-5 xl:h-5 dark:text-teal-300",
								style: { color: "var(--w-text, #0d9488)" },
								"aria-hidden": "true"
							})
						}), /* @__PURE__ */ H("div", {
							className: "min-w-0",
							children: [/* @__PURE__ */ V("span", {
								className: "block text-xs xl:text-sm font-semibold dark:text-teal-300 truncate",
								style: { color: "var(--w-text, #0d9488)" },
								children: n
							}), r && /* @__PURE__ */ V("p", {
								className: "text-[10px] xl:text-xs dark:text-teal-400/70 leading-tight truncate",
								style: { color: "var(--w-text-muted, #14b8a6)" },
								children: r
							})]
						})]
					}), t != null && /* @__PURE__ */ H("span", {
						className: "flex-shrink-0 text-[10px] xl:text-xs font-semibold px-2 py-0.5 rounded-full dark:bg-teal-800 dark:text-teal-100",
						style: {
							backgroundColor: "var(--w-bg-emphasis, #ccfbf1)",
							color: "var(--w-text-emphasis, #134e4a)"
						},
						children: [
							t,
							" actif",
							t === 1 ? "" : "s"
						]
					})]
				}),
				f ? /* @__PURE__ */ V("div", {
					className: "flex-1 space-y-2 overflow-y-auto",
					children: e.map((e) => /* @__PURE__ */ V(Wo, {
						form: e,
						onFormClick: l
					}, e.id))
				}) : /* @__PURE__ */ H("div", {
					className: "flex-1 flex flex-col items-center justify-center gap-2",
					children: [/* @__PURE__ */ V(j, {
						size: 24,
						className: "dark:text-teal-700",
						style: { color: "var(--w-text-muted, #5eead4)" },
						"aria-hidden": "true"
					}), /* @__PURE__ */ V("p", {
						className: "text-xs xl:text-sm dark:text-teal-200/60 text-center",
						style: { color: "var(--w-text-muted, #14b8a6)" },
						children: "Aucun formulaire disponible"
					})]
				}),
				u && /* @__PURE__ */ V("button", {
					className: "mt-2 text-[10px] xl:text-xs font-medium underline underline-offset-2 dark:text-teal-400 self-center",
					style: { color: "var(--w-text, #0d9488)" },
					onClick: (e) => {
						e.stopPropagation(), u();
					},
					tabIndex: -1,
					"aria-label": "Voir tous les formulaires",
					children: "Voir tous les formulaires"
				})
			]
		})]
	});
}, Ko = {
	published: "En cours",
	closed: "Clôturée"
}, qo = {
	published: "bg-violet-100 text-violet-700 dark:bg-violet-900/40 dark:text-violet-300",
	closed: "bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300"
}, Jo = "\n  .svw-item-hover:hover { background-color: var(--w-bg-hover, #ddd6fe) !important; }\n", Yo = (e) => new Date(e).toLocaleDateString("fr-FR", {
	day: "numeric",
	month: "short"
}), Xo = (e) => {
	let t = [];
	return e.questionCount != null && t.push(`${e.questionCount} question${e.questionCount === 1 ? "" : "s"}`), e.responsesCount != null && t.push(`${e.responsesCount} réponse${e.responsesCount === 1 ? "" : "s"}`), t.length > 0 ? t.join(" · ") : null;
}, Zo = ({ survey: e, onSurveyClick: t }) => {
	let n = (n) => {
		t && (n.stopPropagation(), t(e.id));
	}, r = (n) => {
		t && (n.key === "Enter" || n.key === " ") && (n.preventDefault(), n.stopPropagation(), t(e.id));
	}, i = Xo(e), a = e.participationPercent == null ? null : Math.max(0, Math.min(100, e.participationPercent));
	return /* @__PURE__ */ H("div", {
		className: J("svw-item-hover rounded-lg px-3 py-2.5 transition-colors", "dark:bg-violet-900/40", t && "cursor-pointer dark:hover:bg-violet-800/50"),
		style: { backgroundColor: "var(--w-bg-subtle, rgba(237,233,254,0.6))" },
		onClick: n,
		role: t ? "button" : void 0,
		tabIndex: t ? 0 : void 0,
		onKeyDown: t ? r : void 0,
		children: [
			/* @__PURE__ */ H("div", {
				className: "flex items-start gap-2",
				children: [/* @__PURE__ */ V("p", {
					className: "flex-1 min-w-0 text-xs xl:text-sm font-medium dark:text-violet-100 truncate",
					style: { color: "var(--w-text-emphasis, #4c1d95)" },
					children: e.title
				}), e.answered && /* @__PURE__ */ H("span", {
					className: "flex items-center gap-0.5 flex-shrink-0 text-[10px] xl:text-xs font-medium px-1.5 py-0.5 rounded-full bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300",
					children: [/* @__PURE__ */ V(w, {
						size: 10,
						"aria-hidden": "true"
					}), "Répondue"]
				})]
			}),
			/* @__PURE__ */ H("div", {
				className: "flex items-center gap-1.5 mt-0.5 flex-wrap",
				children: [
					e.status && /* @__PURE__ */ V("span", {
						className: J("text-[10px] xl:text-xs font-medium px-1.5 py-0.5 rounded-full", qo[e.status]),
						children: Ko[e.status]
					}),
					i && /* @__PURE__ */ V("span", {
						className: "text-[10px] xl:text-xs dark:text-violet-300/70 truncate",
						style: { color: "var(--w-text, #7c3aed)" },
						children: i
					}),
					e.deadline && /* @__PURE__ */ H("span", {
						className: "text-[10px] xl:text-xs dark:text-violet-300/70 flex items-center gap-0.5 flex-shrink-0 ml-auto",
						style: { color: "var(--w-text-muted, #8b5cf6)" },
						children: [/* @__PURE__ */ V(b, {
							size: 10,
							"aria-hidden": "true"
						}), Yo(e.deadline)]
					})
				]
			}),
			a != null && /* @__PURE__ */ H("div", {
				className: "mt-1.5 flex items-center gap-1.5",
				children: [/* @__PURE__ */ V("div", {
					className: "flex-1 h-1.5 rounded-full overflow-hidden dark:bg-violet-800",
					style: { backgroundColor: "var(--w-progress-bg, rgba(196,181,253,0.5))" },
					role: "progressbar",
					"aria-valuenow": a,
					"aria-valuemin": 0,
					"aria-valuemax": 100,
					"aria-label": `Participation : ${a}%`,
					children: /* @__PURE__ */ V("div", {
						className: "h-full rounded-full transition-all dark:bg-violet-400",
						style: {
							width: `${a}%`,
							backgroundColor: "var(--w-progress-fill, #8b5cf6)"
						}
					})
				}), /* @__PURE__ */ H("span", {
					className: "text-[10px] xl:text-xs font-semibold flex-shrink-0 dark:text-violet-200",
					style: { color: "var(--w-text-emphasis, #4c1d95)" },
					children: [a, "%"]
				})]
			})
		]
	});
}, Qo = ({ surveys: e, activeCount: t, title: n = "Enquêtes", subtitle: r, backgroundColor: i, icon: a, className: o, isPreview: s = !1, isLoading: c = !1, onSurveyClick: l, onWidgetClick: u }) => {
	if (c) return /* @__PURE__ */ V(Z, { rows: 3 });
	let d = on(a) ?? j, f = e.length > 0, p = () => {
		u && u();
	};
	return /* @__PURE__ */ H("div", {
		className: J("h-full w-full dark:bg-violet-950 rounded-lg p-3 sm:p-3.5 md:p-4 lg:p-4 xl:p-6", u && "cursor-pointer", s && "pointer-events-none", o),
		style: { backgroundColor: i ?? "var(--w-bg, #f5f3ff)" },
		onClick: p,
		role: u ? "button" : void 0,
		tabIndex: u ? 0 : void 0,
		onKeyDown: u ? (e) => {
			(e.key === "Enter" || e.key === " ") && (e.preventDefault(), p());
		} : void 0,
		children: [/* @__PURE__ */ V("style", { children: Jo }), /* @__PURE__ */ H("div", {
			className: "flex h-full flex-col",
			children: [
				/* @__PURE__ */ H("div", {
					className: "flex items-center justify-between gap-2 mb-3 xl:mb-4",
					children: [/* @__PURE__ */ H("div", {
						className: "flex items-center gap-1.5 xl:gap-2 min-w-0",
						children: [/* @__PURE__ */ V("div", {
							className: "rounded-lg dark:bg-violet-800 p-1.5 xl:p-2 flex-shrink-0",
							style: { backgroundColor: "var(--w-bg-emphasis, #ede9fe)" },
							children: /* @__PURE__ */ V(d, {
								size: 16,
								className: "xl:w-5 xl:h-5 dark:text-violet-300",
								style: { color: "var(--w-text, #7c3aed)" },
								"aria-hidden": "true"
							})
						}), /* @__PURE__ */ H("div", {
							className: "min-w-0",
							children: [/* @__PURE__ */ V("span", {
								className: "block text-xs xl:text-sm font-semibold dark:text-violet-300 truncate",
								style: { color: "var(--w-text, #7c3aed)" },
								children: n
							}), r && /* @__PURE__ */ V("p", {
								className: "text-[10px] xl:text-xs dark:text-violet-400/70 leading-tight truncate",
								style: { color: "var(--w-text-muted, #8b5cf6)" },
								children: r
							})]
						})]
					}), t != null && /* @__PURE__ */ H("span", {
						className: "flex-shrink-0 text-[10px] xl:text-xs font-semibold px-2 py-0.5 rounded-full dark:bg-violet-800 dark:text-violet-100",
						style: {
							backgroundColor: "var(--w-bg-emphasis, #ede9fe)",
							color: "var(--w-text-emphasis, #4c1d95)"
						},
						children: [
							t,
							" active",
							t === 1 ? "" : "s"
						]
					})]
				}),
				f ? /* @__PURE__ */ V("div", {
					className: "flex-1 space-y-2 overflow-y-auto",
					children: e.map((e) => /* @__PURE__ */ V(Zo, {
						survey: e,
						onSurveyClick: l
					}, e.id))
				}) : /* @__PURE__ */ H("div", {
					className: "flex-1 flex flex-col items-center justify-center gap-2",
					children: [/* @__PURE__ */ V(j, {
						size: 24,
						className: "dark:text-violet-700",
						style: { color: "var(--w-text-muted, #c4b5fd)" },
						"aria-hidden": "true"
					}), /* @__PURE__ */ V("p", {
						className: "text-xs xl:text-sm dark:text-violet-200/60 text-center",
						style: { color: "var(--w-text-muted, #8b5cf6)" },
						children: "Aucune enquête disponible"
					})]
				}),
				u && /* @__PURE__ */ V("button", {
					className: "mt-2 text-[10px] xl:text-xs font-medium underline underline-offset-2 dark:text-violet-400 self-center",
					style: { color: "var(--w-text, #7c3aed)" },
					onClick: (e) => {
						e.stopPropagation(), u();
					},
					tabIndex: -1,
					"aria-label": "Voir toutes les enquêtes",
					children: "Voir toutes les enquêtes"
				})
			]
		})]
	});
}, $o = (e) => e ? e.includes("gradient") ? { backgroundImage: e } : { backgroundColor: e } : {}, es = (e) => {
	let t = e?.trim().match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i)?.[1];
	if (!t) return !1;
	let n = t.length === 3 ? t.split("").map((e) => e + e).join("") : t, r = parseInt(n.slice(0, 2), 16), i = parseInt(n.slice(2, 4), 16), a = parseInt(n.slice(4, 6), 16);
	return (.299 * r + .587 * i + .114 * a) / 255 > .6;
}, ts = (e) => es(e) ? "text-slate-900" : "text-white", ns = ({ title: e, bodyHtml: t, coverImageUrl: n, ctaLabel: r, ctaUrl: i, backgroundColor: a, textColor: o, onDismiss: s, className: c }) => {
	let l = !!(r && i);
	return /* @__PURE__ */ H("div", {
		className: J("cse-message-modal-enter relative w-full max-w-md overflow-hidden rounded-3xl bg-white shadow-2xl", c),
		role: "dialog",
		"aria-label": e,
		children: [/* @__PURE__ */ H("div", {
			"data-testid": "cse-message-header",
			className: "relative h-36 w-full",
			style: $o(a ?? "linear-gradient(135deg, #e0e7ff 0%, #fce7f3 100%)"),
			children: [n && /* @__PURE__ */ V("img", {
				src: n,
				alt: "",
				className: "absolute inset-0 h-full w-full object-cover"
			}), s && /* @__PURE__ */ V("button", {
				type: "button",
				"aria-label": "Fermer",
				onClick: s,
				className: "absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-full bg-white/70 text-slate-600 backdrop-blur transition hover:bg-white",
				children: /* @__PURE__ */ V(It, { className: "h-4 w-4" })
			})]
		}), /* @__PURE__ */ H("div", {
			className: "px-8 pb-8 pt-6 text-center",
			children: [
				/* @__PURE__ */ V("h2", {
					className: "mb-3 text-xl font-bold text-slate-900",
					style: o ? { color: o } : void 0,
					children: e
				}),
				t && /* @__PURE__ */ V("div", {
					className: J("mb-6 text-sm leading-relaxed text-slate-500", "[&_a]:underline [&_p+p]:mt-2 [&_ul]:mt-2 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:text-left [&_ol]:mt-2 [&_ol]:list-decimal [&_ol]:pl-5 [&_ol]:text-left [&_li+li]:mt-1"),
					dangerouslySetInnerHTML: { __html: Dr(t) }
				}),
				l && /* @__PURE__ */ V("a", {
					href: i,
					target: "_blank",
					rel: "noopener noreferrer",
					className: J("inline-block rounded-full px-6 py-2.5 text-sm font-medium transition", o ? J("hover:opacity-90", ts(o)) : "bg-slate-900 text-white hover:bg-slate-700"),
					style: o ? { backgroundColor: o } : void 0,
					children: r
				})
			]
		})]
	});
}, rs = ({ title: e, bodyHtml: t, ctaLabel: n, ctaUrl: r, backgroundColor: i, textColor: a, onDismiss: o, className: s }) => {
	let c = !!(n && r), l = a ? { color: a } : {};
	return /* @__PURE__ */ H("div", {
		className: J("cse-message-banner-enter relative flex w-full flex-col gap-3 rounded-2xl px-5 py-4 shadow-sm", "sm:flex-row sm:items-center sm:gap-4 sm:py-3.5", s),
		style: {
			...$o(i ?? "#e0e7ff"),
			...l
		},
		role: "status",
		children: [
			/* @__PURE__ */ H("div", {
				className: "min-w-0 flex-1",
				children: [/* @__PURE__ */ V("p", {
					className: J("text-sm font-semibold sm:truncate", o && "pr-8 sm:pr-0"),
					children: e
				}), t && /* @__PURE__ */ V("div", {
					className: J("mt-1 break-words text-xs opacity-80 sm:mt-0", "[&_a]:underline [&_p+p]:mt-2 [&_ul]:mt-2 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:text-left [&_ol]:mt-2 [&_ol]:list-decimal [&_ol]:pl-5 [&_ol]:text-left [&_li+li]:mt-1"),
					dangerouslySetInnerHTML: { __html: Dr(t) }
				})]
			}),
			c && /* @__PURE__ */ V("a", {
				href: r,
				target: "_blank",
				rel: "noopener noreferrer",
				className: J("shrink-0 self-start rounded-full px-4 py-1.5 text-xs font-medium transition sm:self-auto", a ? J("hover:opacity-90", ts(a)) : "bg-slate-900 text-white hover:bg-slate-700"),
				style: a ? { backgroundColor: a } : void 0,
				children: n
			}),
			o && /* @__PURE__ */ V("button", {
				type: "button",
				"aria-label": "Fermer",
				onClick: o,
				className: "absolute right-4 top-4 rounded-full p-1 opacity-60 transition hover:opacity-100 sm:static sm:shrink-0",
				children: /* @__PURE__ */ V(It, { className: "h-4 w-4" })
			})
		]
	});
}, is = ({ title: e, bodyHtml: t, ctaLabel: n, ctaUrl: r, backgroundColor: i, textColor: a, onDismiss: o, className: s }) => {
	let c = !!(n && r);
	return /* @__PURE__ */ H("div", {
		className: J("cse-message-toaster-enter flex w-full max-w-sm items-start gap-3 rounded-2xl bg-white p-4 shadow-xl", s),
		style: $o(i),
		role: "status",
		children: [/* @__PURE__ */ H("div", {
			className: "min-w-0 flex-1",
			children: [
				/* @__PURE__ */ V("p", {
					className: "text-sm font-semibold text-slate-900",
					style: a ? { color: a } : void 0,
					children: e
				}),
				t && /* @__PURE__ */ V("div", {
					className: J("mt-0.5 text-xs", "[&_a]:underline [&_p+p]:mt-2 [&_ul]:mt-2 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:text-left [&_ol]:mt-2 [&_ol]:list-decimal [&_ol]:pl-5 [&_ol]:text-left [&_li+li]:mt-1", a ? "opacity-80" : "text-slate-500"),
					style: a ? { color: a } : void 0,
					dangerouslySetInnerHTML: { __html: Dr(t) }
				}),
				c && /* @__PURE__ */ V("a", {
					href: r,
					target: "_blank",
					rel: "noopener noreferrer",
					className: J("mt-2 inline-block text-xs font-medium underline underline-offset-2", !a && "text-slate-900"),
					style: a ? { color: a } : void 0,
					children: n
				})
			]
		}), o && /* @__PURE__ */ V("button", {
			type: "button",
			"aria-label": "Fermer",
			onClick: o,
			className: "shrink-0 rounded-full p-1 text-slate-400 transition hover:text-slate-600",
			children: /* @__PURE__ */ V(It, { className: "h-4 w-4" })
		})]
	});
};
//#endregion
//#region src/registry/createWidgetRegistry.ts
function as(e) {
	let t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
	return {
		get(r, i) {
			if (i) {
				let e = n.get(`${r}:${i}`);
				if (e) return e;
			}
			return t.get(r) ?? e;
		},
		register(e, n) {
			t.set(e, n);
		},
		registerVariant(e, t, r) {
			n.set(`${e}:${t}`, r);
		},
		has(e) {
			return t.has(e);
		},
		list() {
			return Array.from(t.keys());
		}
	};
}
//#endregion
//#region src/contexts/WidgetTypesContext.tsx
var os = zt(null);
function ss({ children: e, widgetTypes: t, isLoading: n = !1, error: r = null }) {
	let i = G(() => ({
		widgetTypes: t,
		isLoading: n,
		error: r,
		getByCode: (e) => t.find((t) => t.code === e),
		getByCategory: (e) => t.filter((t) => t.category === e),
		getActiveTypes: () => t.filter((e) => e.active !== !1)
	}), [
		t,
		n,
		r
	]);
	return /* @__PURE__ */ V(os.Provider, {
		value: i,
		children: e
	});
}
function cs() {
	let e = Vt(os);
	if (!e) throw Error("useWidgetTypes must be used within WidgetTypesProvider");
	return e;
}
//#endregion
//#region src/mockData/index.ts
var ls = {
	firstName: "Marie",
	lastName: "Dupont",
	email: "marie.dupont@example.com",
	company: "Entreprise Demo",
	avatarUrl: null,
	initials: "MD"
}, us = {
	total: 725,
	originalAmount: 950,
	activeVouchers: 4,
	usagePercentage: 23.7
}, ds = [
	{
		id: "1",
		event: "Vacances 2024",
		amount: 500,
		balance: 350,
		color: "#10B981"
	},
	{
		id: "2",
		event: "Rentre Scolaire",
		amount: 200,
		balance: 200,
		color: "#3B82F6"
	},
	{
		id: "3",
		event: "Culture",
		amount: 150,
		balance: 75,
		color: "#8B5CF6"
	},
	{
		id: "4",
		event: "Sport & Loisirs",
		amount: 100,
		balance: 100,
		color: "#F59E0B"
	}
], fs = {
	lastFour: "4521",
	formattedCardNumber: "**** **** **** 4521",
	embossed_name: "MARIE DUPONT",
	isActivated: !0,
	isUnlocked: !0,
	isActive: !0,
	type: "Mastercard",
	expiryDate: "12/26",
	expireAt: {
		month: "12",
		shortYear: "26"
	}
}, ps = [
	{
		id: "1",
		merchant: "Carrefour",
		amount: 45.8,
		date: "2024-01-15",
		category: "Alimentation"
	},
	{
		id: "2",
		merchant: "FNAC",
		amount: 89.99,
		date: "2024-01-14",
		category: "Culture"
	},
	{
		id: "3",
		merchant: "Decathlon",
		amount: 125.5,
		date: "2024-01-12",
		category: "Sport"
	},
	{
		id: "4",
		merchant: "Amazon",
		amount: 34.99,
		date: "2024-01-10",
		category: "Divers"
	}
], ms = [
	{
		label: "Mes Bons",
		icon: "Gift",
		url: "/bons"
	},
	{
		label: "Ma Carte",
		icon: "CreditCard",
		url: "/carte"
	},
	{
		label: "Boutique",
		icon: "ShoppingBag",
		url: "/boutique"
	},
	{
		label: "Aide",
		icon: "HelpCircle",
		url: "/aide"
	}
], hs = {
	promoText: "Decouvrez nos offres exclusives",
	ctaText: "Voir la boutique",
	featuredProducts: [
		{
			id: "1",
			name: "Bon cinema",
			price: 8.5,
			discount: 15
		},
		{
			id: "2",
			name: "Parc attraction",
			price: 35,
			discount: 20
		},
		{
			id: "3",
			name: "Spa & Bien-etre",
			price: 45,
			discount: 10
		}
	]
}, gs = {
	conversations: [
		{
			id: "1",
			name: "Support Technique",
			lastMessage: "Votre demande a ete traitee",
			unreadCount: 2
		},
		{
			id: "2",
			name: "Equipe RH",
			lastMessage: "Confirmation de votre demande",
			unreadCount: 0
		},
		{
			id: "3",
			name: "Service Comptabilite",
			lastMessage: "Merci pour les documents",
			unreadCount: 1
		}
	],
	activities: [
		{
			id: "1",
			event: "document_uploaded",
			subjectType: "Document telecharge",
			subject: { title: "Facture janvier 2024" },
			createdAt: "2024-01-15T14:30:00Z"
		},
		{
			id: "2",
			event: "request_approved",
			subjectType: "Demande approuvee",
			subject: { title: "Conges ete 2024" },
			createdAt: "2024-01-15T10:15:00Z"
		},
		{
			id: "3",
			event: "message_received",
			subjectType: "Nouveau message",
			subject: { title: "Reunion planifiee" },
			createdAt: "2024-01-14T16:45:00Z"
		}
	],
	articles: [
		{
			id: "1",
			title: "Nouveaux avantages disponibles !",
			excerpt: "Decouvrez les nouveaux partenaires...",
			date: "2024-01-15",
			isPinned: !0,
			imageUrl: null
		},
		{
			id: "2",
			title: "Rappel: Vacances hiver",
			excerpt: "N'oubliez pas d'utiliser vos bons...",
			date: "2024-01-10",
			isPinned: !1,
			imageUrl: null
		},
		{
			id: "3",
			title: "Sortie team building",
			excerpt: "Inscrivez-vous avant le 20 janvier...",
			date: "2024-01-08",
			isPinned: !1,
			imageUrl: null
		}
	]
}, _s = [
	{
		id: "1",
		title: "A faire ✅",
		content: "• Valider les conges avant vendredi\n• Envoyer le recap RH avec un mini bilan\n• Confirmer la presence au point hebdo\nVoir: portail-elu/notes",
		color: "#fef3c7",
		createdAt: "2026-01-18T09:30:00.000Z"
	},
	{
		id: "2",
		title: "Info RH 📣",
		content: "Teletravail: nouvelles modalites en mars\n• 2 jours fixes / semaine\n• Validation manager requise\nLire: intranet/teletravail",
		color: "#dbeafe",
		createdAt: "2026-01-20T14:05:00.000Z"
	},
	{
		id: "3",
		title: "Equipe 🤝",
		content: "Reunion d'equipe jeudi 10h\n• Salle Atlas (niveau 2)\n• Ordre du jour: priorites T1, budget, planning\nDoc: drive/equipe/t1",
		color: "#dcfce7",
		createdAt: "2026-01-22T08:45:00.000Z"
	}
], vs = [
	{
		id: "1",
		title: "Reunion CE",
		date: "2024-01-20",
		time: "14:00",
		color: "#3B82F6"
	},
	{
		id: "2",
		title: "Formation securite",
		date: "2024-01-25",
		time: "09:00",
		color: "#10B981"
	},
	{
		id: "3",
		title: "Pot de depart",
		date: "2024-01-28",
		time: "18:00",
		color: "#F59E0B"
	}
], ys = [
	{
		id: "1",
		title: "Destination voyage CE 2024 ?",
		participantCount: 128,
		deadline: "31 jan.",
		progressPercent: 64
	},
	{
		id: "2",
		title: "Horaires reunion mensuelle ?",
		participantCount: 96,
		deadline: "5 fev.",
		progressPercent: 48
	},
	{
		id: "3",
		title: "Satisfaction restaurant entreprise",
		participantCount: 173,
		progressPercent: 81
	}
], bs = [
	{
		id: "1",
		title: "Nouveaux avantages disponibles",
		participantCount: 214,
		deadline: "15 jan.",
		progressPercent: 72
	},
	{
		id: "2",
		title: "Rappel: Vacances hiver",
		participantCount: 156,
		deadline: "10 jan.",
		progressPercent: 58
	},
	{
		id: "3",
		title: "Sortie team building",
		participantCount: 189,
		progressPercent: 83
	}
], xs = [
	{
		id: "1",
		title: "Tirage mensuel janvier",
		participantCount: 142
	},
	{
		id: "2",
		title: "Weekend spa & detente",
		participantCount: 87
	},
	{
		id: "3",
		title: "Billetterie concert exclusif",
		participantCount: 203
	}
], Ss = {
	activeVouchers: 4,
	usagePercent: 24,
	activePolls: 2,
	participation: 75
}, Cs = {
	defaultTitle: (e) => `Bonjour ${e} !`,
	defaultSubtitle: "Bienvenue sur votre espace avantages",
	mascotEmoji: "🦊"
}, ws = [
	{
		id: "1",
		name: "Procès-verbal CSE Mars 2026.pdf",
		mimeType: "application/pdf",
		byteSize: 245678,
		createdAt: "2026-06-19T10:30:00Z",
		folderName: "PV CSE",
		downloadUrl: "#"
	},
	{
		id: "2",
		name: "Budget prévisionnel 2026.xlsx",
		mimeType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
		byteSize: 1456823,
		createdAt: "2026-06-15T14:22:00Z",
		folderName: "Comptabilité",
		downloadUrl: "#"
	},
	{
		id: "3",
		name: "Photo team building juin 2026.jpg",
		mimeType: "image/jpeg",
		byteSize: 3241056,
		createdAt: "2026-06-10T09:15:00Z",
		folderName: "Photos",
		downloadUrl: "#"
	},
	{
		id: "4",
		name: "Règlement intérieur 2026.docx",
		mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
		byteSize: 98432,
		createdAt: "2026-06-05T11:00:00Z",
		folderName: "RH",
		downloadUrl: "#"
	},
	{
		id: "5",
		name: "Présentation CE avril.mp4",
		mimeType: "video/mp4",
		byteSize: 52428800,
		createdAt: "2026-05-28T16:45:00Z",
		folderName: "Vidéos",
		downloadUrl: "#"
	},
	{
		id: "6",
		name: "Archives documents 2025.zip",
		mimeType: "application/zip",
		byteSize: 8912345,
		createdAt: "2026-05-20T08:30:00Z",
		folderName: "Archives",
		downloadUrl: "#"
	},
	{
		id: "7",
		name: "Tableau de bord activités.ods",
		mimeType: "application/vnd.oasis.opendocument.spreadsheet",
		byteSize: 421037,
		createdAt: "2026-05-12T13:10:00Z",
		folderName: "Comptabilité",
		downloadUrl: "#"
	},
	{
		id: "8",
		name: "Podcast interview DRH.mp3",
		mimeType: "audio/mpeg",
		byteSize: 6553600,
		createdAt: "2026-05-05T10:00:00Z",
		folderName: "Podcasts",
		downloadUrl: "#"
	},
	{
		id: "9",
		name: "Charte ergonomie poste de travail.pdf",
		mimeType: "application/pdf",
		byteSize: 512e3,
		createdAt: "2026-04-28T15:20:00Z",
		folderName: "RH",
		downloadUrl: "#"
	},
	{
		id: "10",
		name: "Liste membres CSE 2026.csv",
		mimeType: "text/csv",
		byteSize: 4096,
		createdAt: "2026-04-15T09:00:00Z",
		folderName: "PV CSE",
		downloadUrl: "#"
	}
], Ts = [
	{
		id: "1",
		title: "Vélo route carbone Trek",
		kind: "sale",
		priceCents: 35e3,
		categoryName: "Sport",
		photoUrl: null,
		authorName: "Marie Dupont"
	},
	{
		id: "2",
		title: "Livres jeunesse (lot de 10)",
		kind: "gift",
		categoryName: "Culture",
		photoUrl: null,
		authorName: "Jean Martin"
	},
	{
		id: "3",
		title: "Cherche perceuse à colonne",
		kind: "wanted",
		categoryName: "Bricolage",
		photoUrl: null,
		authorName: "Sophie Bernard"
	},
	{
		id: "4",
		title: "Échange tapis de yoga contre haltères",
		kind: "swap",
		categoryName: "Sport",
		photoUrl: null,
		authorName: "Pierre Moreau"
	}
], Es = [
	{
		id: "1",
		itemName: "Chalet les Aravis",
		kind: "hebergement",
		status: "confirmed",
		statusLabel: "Confirmée",
		startDate: "2025-08-10",
		endDate: "2025-08-17",
		amountCents: 84e3,
		imageUrl: null
	},
	{
		id: "2",
		itemName: "Vélo électrique Decathlon",
		kind: "materiel",
		status: "pending",
		statusLabel: "En attente",
		startDate: "2025-07-15",
		endDate: "2025-07-16",
		amountCents: 2500,
		imageUrl: null
	},
	{
		id: "3",
		itemName: "Salle de conférence B",
		kind: "salle",
		status: "confirmed",
		statusLabel: "Confirmée",
		startDate: "2025-07-20",
		endDate: null,
		amountCents: null,
		imageUrl: null
	},
	{
		id: "4",
		itemName: "Renault Zoé",
		kind: "vehicule",
		status: "cancelled",
		statusLabel: "Annulée",
		startDate: "2025-06-01",
		endDate: "2025-06-03",
		amountCents: 12e3,
		imageUrl: null
	}
], Ds = [
	{
		id: "1",
		title: "Demande de chèques vacances 2026",
		deadline: "2026-09-01",
		isClosed: !1,
		submissionStatus: "draft"
	},
	{
		id: "2",
		title: "Inscription arbre de Noël",
		deadline: "2026-11-15",
		isClosed: !1,
		submissionStatus: "submitted"
	},
	{
		id: "3",
		title: "Dossier garde d'enfants",
		deadline: "2026-10-05",
		isClosed: !1,
		submissionStatus: "waiting"
	},
	{
		id: "4",
		title: "Remboursement licence sportive",
		deadline: "2026-06-30",
		isClosed: !0,
		submissionStatus: "validated"
	}
], Os = [
	{
		id: "1",
		title: "Satisfaction des activités du CSE",
		status: "published",
		questionCount: 8,
		responsesCount: 42,
		deadline: "2025-09-30",
		participationPercent: 64,
		answered: !1
	},
	{
		id: "2",
		title: "Choix de la destination du voyage annuel",
		status: "published",
		questionCount: 5,
		responsesCount: 87,
		deadline: "2025-10-15",
		participationPercent: 78,
		answered: !0
	},
	{
		id: "3",
		title: "Bilan de la fête de fin d'année",
		status: "closed",
		questionCount: 12,
		responsesCount: 103,
		deadline: "2025-01-20",
		participationPercent: 92,
		answered: !0
	}
], ks = {
	user: ls,
	balance: us,
	vouchers: ds,
	card: fs,
	expenses: ps,
	quickActions: ms,
	shop: hs,
	conversations: gs.conversations,
	activities: gs.activities,
	articles: gs.articles,
	notes: _s,
	events: vs,
	polls: ys,
	blog: bs,
	raffles: xs,
	metrics: Ss,
	files: ws,
	classifieds: Ts,
	rentals: Es,
	forms: Ds,
	surveys: Os
};
//#endregion
export { fr as AutoHeightContext, fn as BalanceWidget, ja as BlogWidget, $r as CARDS_MARGIN, Zr as CARD_MARGIN_X, Qr as CARD_MARGIN_Y, pa as CalendarWidget, Pn as CardsWidget, ko as ClassifiedAdsWidget, Ua as CommunicationWidget, rs as CseMessageBanner, ns as CseMessageModal, is as CseMessageToaster, Yr as DEFAULT_NOTE_SIZE, Xr as DEFAULT_ROW_HEIGHT, Un as ExpensesWidget, So as FileManagerWidget, Go as FormsWidget, Gn as HeroWidget, Xt as KNOWN_CONTENT_TYPES, qr as MAX_GRID_COLS, Jr as MIN_NOTE_SIZE, us as MOCK_BALANCE, bs as MOCK_BLOG, vs as MOCK_CALENDAR, fs as MOCK_CARD, Ts as MOCK_CLASSIFIEDS, gs as MOCK_COMMUNICATION, ks as MOCK_DATA, ps as MOCK_EXPENSES, ws as MOCK_FILES, Ds as MOCK_FORMS, Cs as MOCK_HERO, Ss as MOCK_METRICS, _s as MOCK_PINNED_NOTES, ys as MOCK_POLLS, ms as MOCK_QUICK_ACTIONS, xs as MOCK_RAFFLE, Es as MOCK_RENTALS, hs as MOCK_SHOP, Os as MOCK_SURVEYS, ls as MOCK_USER, ds as MOCK_VOUCHERS, ur as MetricsWidget, dr as NoteReactionsDisplay, ei as OPTIMISTIC_NOTE_PREFIX, Ur as PINNED_NOTE_COLOR_HEX, Kr as PinnedNoteCard, Or as PinnedNoteContent, vi as PinnedNotesGrid, Wi as PinnedNotesWidget, cr as PlaceholderWidget, ya as PollsWidget, Ma as QuickActionsWidget, ti as RESPONSIVE_BREAKPOINTS, ni as RESPONSIVE_GRID_COLS, Ta as RaffleWidget, Lo as RentalsWidget, qn as ShopWidget, co as StatsExpensesWidget, Qo as SurveysWidget, sr as VouchersWidget, X as WidgetContainer, cn as WidgetEmpty, sn as WidgetHeader, Z as WidgetSkeleton, ss as WidgetTypesProvider, pi as applyHeightOverridesAndReflow, J as cn, di as compactLayoutVertically, ri as createOptimisticNoteId, Hr as createSubtleGradient, as as createWidgetRegistry, en as formatDate, $t as formatEuro, si as formatExpirationDate, rn as generateWidgetColorVars, Rr as getContrastTextColor, oi as getExpirationStatus, on as getLucideIcon, mi as getMaxVisibleReactions, ai as hasAttachments, Zt as isKnownContentType, ii as isOptimisticNoteId, Ar as isValidHexColor, an as lucideIconRegistry, yi as normalizeTableColspans, ci as pxToRows, Wr as resolveNoteColor, Dr as sanitizeHtml, li as shouldUpdateHeight, hi as shouldUseUltraCompactReactions, pr as useAutoHeight, cs as useWidgetTypes };
